// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import axiosInstance from './utils/axios';

const resources = {
   en: {
        translation: {
          common: {
            minutes: "minutes",
            add: "Add",
            edit: "Edit",
            delete: "Delete", 
            save: "Save",
            cancel: "Cancel",
            confirm: "Confirm",
            back: "Back", 
            next: "Next",
            min: "min",
            login: "Login",
            register: "Register",
            logout: "Logout",
            email: "Email",
            password: "Password",
            phone: "Phone",
            name: "Name",
            actions: "Actions", 
            optional: "optional",
            telegram: "Telegram",
            instagram: "Instagram",
            status: "Status",
            savechanges: "Save Changes",
            changespecialist: "Change Specialist",
            past: "Past",
            ongoing: "Ongoing", 
            upcoming: "Upcoming",
            future: "Future",
            specialist: "Specialist",
            errorApproving: "Error approving",
            errorRejecting: "Error rejecting",
            errorSaving: "Error saving",
            specialists: "Specialists", 
            schedule: "Schedule",
            services: "Services",
            pendingApprovals: "Pending Approvals",
            activeSpecialists: "Active Specialists",
            approve: "Approve",
            reject: "Reject",
            namecompany: "Name/ Company",
            firstcontact: "First Contact",
            contacts: "Contacts",
            projectstatus: "Project Status",
            createdby: "Created By",
            assignedto: "Assigned To",
            clearalldeleted: "Clear All Deleted",
            dashboard: "Dashboard",

            editservices: "Edit Services",
            setschedule: "Set Schedule",
            website: "Website",
            new: "new",
            regular: "Regular",
            former: "Former",
            clientstatus: "Client Status",
            address: "Address",
            assignspecialiststo: "Assign Specialists to",

            discussion: "Discussion",
            firstcontactdate: "First Contact Date",
            projecttype: "Project Type",
            projectdescription: "Project Description",
            technicaldetails: "Technical Details",
            budget: "Budget",
            contacted: "Contacted",
            unreachable: "Unreachable",
            negotiating: "Negotiating",
            meeting: "Meeting",
            development: "Development",
            completed: "Completed",
            telegramoptional: "Telegram (optional)",
            instagramoptional: "Instagram (optional)",
            allServices: "All Services",

            alreadyhaveanaccount: "Already have an account? Login",
            myappointments: "My Appointments",
            myclients: "My Clients",
            settings: "Settings",
            profilesettings: "Profile Settings",
            saveprofilechanges: "Save Profile Changes",
            changepassword: "Change Password",
            currentpassword: "Current Password",
            newpassword: "New Password",
            confirmnewpassword: "Confirm New Password",
            deleteaccount: "Delete Account",
            accountsettings: "Account Settings",


            export: "Export",
            import: "Import",
            saving: "Saving...",
            role: "Role",
            editRole: "Edit Role",
            changeRole: "Change Role",
            specialistRoleDescription: "Access to specialized tasks and project data.",
            adminRoleDescription: "Full access to manage settings and users.",
            superadmin: "Aunimeda Tech Support",
            admin: "Administrator",
            noServicesSelected: "No Services Selected",
            create: "Create",
            none: "None",

            nazvanie: "Name",
            maxprice: "Maximum Price",
            category: "Category",
            title: "Title",
            addnew: "Add New",
            projectType: "Project Type",
            history: "History",
            assignSpecialists: "Assign Specialists",
            uploadSpecialistPhoto: "Upload Specialist Photo",
            selectimage: "Select Image",
            upload: "Upload",
            anySpecialist: "Any Specialist",



            projectStatus: {
              discussion: "Discussion",
              contacted: "Contacted",
            unreachable: "Unreachable",
            negotiating: "Negotiating",
            meeting: "Meeting",
            development: "Development",
            completed: "Completed",
            },

            assignedspecialists: "Assigned Specialists",
            visibletoallspecialists: "Visible to All Specialists",
            allspecialists: "All Specialists",
            createclient: "Create Client",
            client: "Client",
            deleted: "Deleted",

            editclient: "Edit Client",
            newclient: "New Client",

            selectservices: "Select Services",
            selectspecialist: "Select Specialist",
            selectdateandtime: "Select Date and Time",
            confirmbooking: "Confirm Booking",
            saveschedule: "Save Schedule",
            starttime: "Start Time",
            endtime: "End Time",

            selectall: "Select All",
            editservicesfor: "Edit Services For",
            clearall: "Clear All",
            duration: "Duration",
            price: "Price",
            selected: "Selected",
            saveservices: "Save Services",
            selectservicesthisspecialistcanprovidetoclients: "Select Services This Specialist can provide to clients",
            confirmClearAllDeleted: "Are you sure you want to delete all clients from deleted folder? This action cannot be undone.",
            addnewclient: "Add New Client",
            setSchedule: "Set Schedule",
            setWorkingHours: "Set Working Hours", 
            setworkinghoursfor: "Set Working Hours for",
            startTime: "Start Time",
            endTime: "End Time",
            monday: "Monday",
            tuesday: "Tuesday", 
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday"
         
          },
          products: {
                defaultcategory: "Default",
                title: "Products Management",
                addNew: "Add New Product",
                edit: "Edit Product",
                create: "Create Product",
                name: "Name",
                category: "Category",
                price: "Price",
                costPrice: "Cost Price",
                warehouseName: "Warehouse Name",
                warehouseAddress: "Warehouse Address",
                articleNumber: "Article Number",
                unit: "Unit",
                weight: "Weight",
                length: "Length",
                width: "Width",
                height: "Height",
                stock: "Stock",
                responsibleEmployee: "Responsible Employee",
                dimensions: "Dimensions",
                warehouse: "Warehouse",
                deleteTitle: "Delete Product",
                deleteConfirm: "Are you sure you want to delete {{name}}?",
                
                
                import: {
                  steps: {
                    upload: "Upload",
                    map: "Map",
                    import: "Import"
                  },
                  selectfile: "Select File",
                  guide: "To import products: 1) Create Excel file with columns for product data 2) First row should contain column names 3) Each row represents one product 4) Required field: Product Name 5) Default column mapping is set to A1, B1, etc.",
                  guideTitle: "Import Instructions"
                
                        },
                
                units: {
                    piece: "Piece",
                    kg: "Kilogram",
                    package: "Package"
                }
              },

          auth: {
            login: {
              title: "Login",
              invalidCredentials: "Invalid email or password",
              forgotPassword: "Forgot password?",
              noAccount: "Don't have an account?",
              registerHere: "Register here"
            },
            register: {
              title: "Register",
              success: "Registration successful",
              haveAccount: "Already have an account?",
              loginHere: "Login here",
              asClient: "Register as Client",
              asSpecialist: "Register as Specialist",
              waitingApproval: "Registration successful. Waiting for admin approval."
            }
          },
          booking: {
            steps: {
              selectService: "Select Service",
              selectSpecialist: "Select Specialist",
              selectDateTime: "Select Date & Time",
              confirmation: "Confirmation"
            },
            services: {
              title: "Select a Service",
              duration: "Duration",
              price: "Price"
            },
            specialists: {
              title: "Select a Specialist",
              availability: "Available Times",
              noAvailability: "No available time slots"
            },
            datetime: {
              title: "Select Date and Time",
              availableSlots: "Available Slots",
              noSlots: "No available slots for this date"
            },
            confirmation: {
              title: "Confirm Booking",
              details: "Booking Details",
              service: "Service",
              specialist: "Specialist",
              dateTime: "Date & Time",
              clientInfo: "Your Information",
              confirming: "Confirming...",
              confirmBooking: "Confirm Booking",
              error: "Failed to create booking"
            }
          },
          dashboard: {
            tabs: {
              appointments: "Appointments",
              clients: "Clients",
              services: "Services",
              specialists: "Specialists",
              settings: "Settings",
              products: "Products",
            },
            appointments: {
              title: "Appointments",
              upcoming: "Upcoming",
              past: "Past",
              datetime: "Date & Time",
              client : "Client",
              service: "Service",
              specialist: "Specialist",
              duration: "Duration",
              deleteConfirm: "Are you sure you want to delete this appointment?",

              status: {
                pending: "Pending",
                confirmed: "Confirmed",
                cancelled: "Cancelled",
                completed: "Completed"
              },
              actions: {
                confirm: "Confirm",
                cancel: "Cancel",
                reschedule: "Reschedule"
              }
            },
            clients: {
              title: "Clients",
              addNew: "Add New Client",
              management: "Clients Management",
              details: "Client Details",
              history: "Client History",
              status: {
                new: "New",
                regular: "Regular",
                former: "Former",
                deleted: "Deleted"
              },
              tabs: {
                new: "New",
                regular: "Regular",
                former: "Former",
                deleted: "Deleted"
              }
            },
            services: {
              title: "Services",
              addNew: "Add New Service",
              editService: "Edit Service",
              fields: {
                name: "Service Name",
                duration: "Duration",
                price: "Price"
              }
            },
            specialists: {
              title: "Specialists",
              addNew: "Add New Specialist",
              management: "Specialists Management",
              schedule: "Working Hours",
              services: "Available Services",
              status: {
                pending: "Pending Approval",
                approved: "Approved",
                rejected: "Rejected"
              }
            },
            settings: {
              title: "Settings",
              profile: "Profile Settings",
              account: "Account Settings",
              password: "Change Password",
              
              fields: {
                currentPassword: "Current Password",
                newPassword: "New Password",
                confirmPassword: "Confirm New Password"
              }
            }
          },

          settings: {
          crmSettings: "CRM Settings",
          promoText: "Promo Text",
          headerTitle: "Title",
          headerSubtitle: "Description",
          defaultLanguage: "Default Language",
          currency: "Currency",
          currencyPosition: "Currency Position",
          currencyRight: "On The Right",
          currencyLeft: "On The Left",
          hideAppointments: "Hide 'Appointments' tab",
          hideSpecialists: "Hide 'Specialists' tab", 
          hideServices: "Hide 'Services' tab",
          hideClients: "Hide 'Clients' tab",
          hideProducts: "Hide 'Products' tab",
          tabsSaved: "Tab settings saved",
          errorFetching: "Error loading settings",
          errorSaving: "Error saving settings",
          tabsDescription: "Configure the appearance and behavior of tabs",
          tabVisibility: "Toggle the visibility of tabs",
          configureTabs: "Adjust the settings for your tabs",
          tabAndColumnVisibility: "Tab and Column Visibility",
          tabOrder: "Tab Order",
          hiddenTabs: "Hidden Tabs",
          clientColumns: "Client Columns"
          }
        }
      },


      es: {
        translation: {
          common: {
            nazvanie: "Nombre",
            maxprice: "Precio máximo",
            category: "Categoría",
            title: "Título",
            addnew: "Añadir nuevo",
            projectType: "Tipo de proyecto",
            history: "Historial",
            assignSpecialists: "Asignar especialistas",
            uploadSpecialistPhoto: "Subir foto del especialista",
            selectimage: "Seleccionar imagen",
            upload: "Subir",
            anySpecialist: "Cualquier especialista",
            allServices: "Todos los servicios",
            minutes: "minutos",
            deleted: "Remotos",
            add: "Añadir",
            edit: "Editar",
            delete: "Eliminar", 
            save: "Guardar",
            cancel: "Cancelar",
            confirm: "Confirmar",
            back: "Atrás", 
            next: "Siguiente",
            min: "min",
            login: "Iniciar sesión",
            register: "Registrarse",
            logout: "Cerrar sesión",
            email: "Email",
            password: "Contraseña",
            phone: "Teléfono",
            name: "Nombre",
            actions: "Acciones", 
            optional: "opcional",
            telegram: "Telegram",
            instagram: "Instagram",
            status: "Estado",
            savechanges: "Guardar cambios",
            changespecialist: "Cambiar especialista",
            past: "Pasado",
            ongoing: "En curso", 
            upcoming: "Próximo",
            future: "Futuro",
            specialist: "Especialista",
            errorApproving: "Error al aprobar",
            errorRejecting: "Error al rechazar",
            errorSaving: "Error al guardar",
            specialists: "Especialistas", 
            schedule: "Horario",
            services: "Servicios",
            service: "Servicio",
            pendingApprovals: "Aprobaciones pendientes",
            activeSpecialists: "Especialistas activos",
            approve: "Aprobar",
            reject: "Rechazar",
            namecompany: "Nombre/Empresa",
            firstcontact: "Primer contacto",
            contacts: "Contactos",
            projectstatus: "Estado del proyecto",
            createdby: "Creado por",
            assignedto: "Asignado a",
            clearalldeleted: "Limpiar todo lo eliminado",
            dashboard: "Panel de control",
            editservices: "Editar servicios",
            setschedule: "Establecer horario",
            website: "Sitio web",
            new: "Nuevo",
            regular: "Regular",
            former: "Anterior",
            clientstatus: "Estado del cliente",
            address: "Dirección",
            assignspecialiststo: "Asignar especialistas a",
            discussion: "Discusión",
            firstcontactdate: "Fecha del primer contacto",
            projecttype: "Tipo de proyecto",
            projectdescription: "Descripción del proyecto",
            technicaldetails: "Detalles técnicos",
            budget: "Presupuesto",
            contacted: "Contactado",
            unreachable: "Inaccesible",
            negotiating: "Negociando",
            meeting: "Reunión",
            development: "Desarrollo",
            completed: "Completado",
            telegramoptional: "Telegram (opcional)",
            instagramoptional: "Instagram (opcional)",
            alreadyhaveanaccount: "¿Ya tiene una cuenta? Iniciar sesión",
            myappointments: "Mis citas",
            myclients: "Mis clientes",
            settings: "Configuración",
            profilesettings: "Configuración del perfil",
            saveprofilechanges: "Guardar cambios del perfil",
            changepassword: "Cambiar contraseña",
            currentpassword: "Contraseña actual",
            newpassword: "Nueva contraseña",
            confirmnewpassword: "Confirmar nueva contraseña",
            deleteaccount: "Eliminar cuenta",
            accountsettings: "Configuración de la cuenta",
            saveschedule: "Guardar horario",
            starttime: "Hora de inicio",
            endtime: "Hora de fin",
            addnewclient: "Añadir nuevo cliente",
            editclient: "Editar cliente",
            newclient: "Nuevo cliente",
            export: "Exportar",
            import: "Importar",
            saving: "Guardando...",
            role: "Rol",
            editRole: "Editar rol",
            changeRole: "Cambiar rol",
            specialistRoleDescription: "Acceso a tareas especializadas y datos del proyecto",
            adminRoleDescription: "Acceso completo para administrar configuración y usuarios",
            superadmin: "Soporte Técnico Aunimeda",
            admin: "Administrador",
            noServicesSelected: "No hay servicios seleccionados",
            none: "Ninguno",
            create: "Crear",        
            projectStatus: {
                discussion: "Discusión",
                contacted: "Contactado",
                unreachable: "Inaccesible",
                negotiating: "Negociando",
                meeting: "Reunión",
                development: "Desarrollo",
                completed: "Completado"
            },
            assignedspecialists: "Especialistas asignados",
            visibletoallspecialists: "Visible para todos los especialistas",
            allspecialists: "Todos los especialistas",
            createclient: "Crear cliente",
            client: "Cliente",
            selectservices: "Seleccionar servicios",
            selectspecialist: "Seleccionar especialista",
            selectdateandtime: "Seleccionar fecha y hora",
            confirmbooking: "Confirmar reserva",
            selectall: "Seleccionar todo",
            editservicesfor: "Editar servicios para",
            clearall: "Limpiar todo",
            duration: "Duración",
            price: "Precio",
            selected: "Seleccionado",
            saveservices: "Guardar servicios",
            selectservicesthisspecialistcanprovidetoclients: "Seleccionar servicios que este especialista puede proporcionar a los clientes",
            confirmClearAllDeleted: "¿Está seguro de que desea eliminar todos los clientes eliminados? Esta acción no se puede deshacer.",
            setSchedule: "Establecer horario",
            setWorkingHours: "Establecer horas de trabajo",
            setworkinghoursfor: "Establecer horas de trabajo para",
            startTime: "Hora de inicio",
            endTime: "Hora de fin",
            monday: "Lunes",
            tuesday: "Martes",
            wednesday: "Miércoles",
            thursday: "Jueves",
            friday: "Viernes",
            saturday: "Sábado",
            sunday: "Domingo"
          },
          auth: {
            login: {
              title: "Iniciar sesión",
              invalidCredentials: "Email o contraseña incorrectos",
              forgotPassword: "¿Olvidó su contraseña?",
              noAccount: "¿No tiene cuenta?",
              registerHere: "Regístrese aquí"
            },
            register: {
              title: "Registro",
              success: "Registro exitoso",
              haveAccount: "¿Ya tiene cuenta?",
              loginHere: "Inicie sesión aquí",
              asClient: "Registrarse como cliente",
              asSpecialist: "Registrarse como especialista",
              waitingApproval: "Registro exitoso. Esperando aprobación del administrador."
            }
          },
          booking: {
            steps: {
              selectService: "Seleccionar servicio",
              selectSpecialist: "Seleccionar especialista",
              selectDateTime: "Seleccionar fecha y hora",
              confirmation: "Confirmación"
            },
            services: {
              title: "Seleccionar un servicio",
              duration: "Duración",
              price: "Precio"
            },
            specialists: {
              title: "Seleccionar un especialista",
              availability: "Horarios disponibles",
              noAvailability: "No hay horarios disponibles"
            },
            datetime: {
              title: "Seleccionar fecha y hora",
              availableSlots: "Horarios disponibles",
              noSlots: "No hay horarios disponibles para esta fecha"
            },
            confirmation: {
              title: "Confirmar reserva",
              details: "Detalles de la reserva",
              service: "Servicio",
              specialist: "Especialista",
              dateTime: "Fecha y hora",
              clientInfo: "Su información",
              confirming: "Confirmando...",
              confirmBooking: "Confirmar reserva",
              error: "Error al crear la reserva"
            }
          },
          dashboard: {
            tabs: {
              appointments: "Citas",
              clients: "Clientes",
              services: "Servicios",
              specialists: "Especialistas",
              settings: "Configuración",
              products: "Productos"

            },
            appointments: {
              title: "Citas",
              upcoming: "Próximas",
              past: "Pasadas",
              datetime: "Fecha y hora",
              client: "Cliente",
              service: "Servicio",
              specialist: "Especialista",
              duration: "Duración",
              deleteConfirm: "¿Está seguro de que desea eliminar esta cita?",
              status: {
                pending: "Pendiente",
                confirmed: "Confirmada",
                cancelled: "Cancelada",
                completed: "Completada"
              },
              actions: {
                confirm: "Confirmar",
                cancel: "Cancelar",
                reschedule: "Reprogramar"
              }
            },
            clients: {
              title: "Clientes",
              addNew: "Añadir nuevo cliente",
              management: "Gestión de clientes",
              details: "Detalles del cliente",
              history: "Historial del cliente",
              status: {
                new: "Nuevo",
                regular: "Regular",
                former: "Anterior",
                deleted: "Eliminado"
              },
              tabs: {
                new: "Nuevos",
                regular: "Regulares",
                former: "Anteriores",
                deleted: "Eliminados"
              }
            },
            services: {
              title: "Servicios",
              addNew: "Añadir nuevo servicio",
              editService: "Editar servicio",
              fields: {
                name: "Nombre del servicio",
                duration: "Duración",
                price: "Precio"
              }
            },
            specialists: {
              title: "Especialistas",
              addNew: "Añadir especialista",
              management: "Gestión de especialistas",
              schedule: "Horario de trabajo",
              services: "Servicios disponibles",
              status: {
                pending: "Pendiente de aprobación",
                approved: "Aprobado",
                rejected: "Rechazado"
              }
            },
            settings: {
              title: "Configuración",
              profile: "Configuración del perfil",
              account: "Configuración de la cuenta",
              password: "Cambiar contraseña",
              fields: {
                currentPassword: "Contraseña actual",
                newPassword: "Nueva contraseña",
                confirmPassword: "Confirmar contraseña"
              }
            }
          },
          settings: {
            crmSettings: "Configuración CRM",
            promoText: "Texto promocional",
            headerTitle: "Título",
            headerSubtitle: "Descripción",
            defaultLanguage: "Idioma predeterminado",
            currency: "Moneda",
            currencyPosition: "Posición de la moneda",
            currencyRight: "A la derecha",
            currencyLeft: "A la izquierda",
            hideAppointments: "Ocultar pestaña 'Citas'",
            hideSpecialists: "Ocultar pestaña 'Especialistas'",
            hideServices: "Ocultar pestaña 'Servicios'", 
            hideClients: "Ocultar pestaña 'Clientes'",
            hideProducts: "Ocultar pestaña 'Productos'",
            tabsSaved: "Configuración de pestañas guardada",
            errorFetching: "Error al cargar la configuración",
            errorSaving: "Error al guardar la configuración",
            tabsDescription: "Configura la apariencia y el comportamiento de las pestañas",
            tabVisibility: "Alternar la visibilidad de las pestañas",
            configureTabs: "Ajusta la configuración de tus pestañas",
            tabAndColumnVisibility: "Visibilidad de pestañas y columnas",
            tabOrder: "Orden de pestañas",
            hiddenTabs: "Pestañas ocultas",
            clientColumns: "Columnas del cliente",
           },
           
           products: {
            
            defaultcategory: "Predeterminado",
            title: "Gestión de productos",
            addNew: "Añadir producto",
            edit: "Editar producto",
            create: "Crear producto",
            name: "Nombre",
            category: "Categoría",
            price: "Precio",
            costPrice: "Precio de costo",
            warehouseName: "Nombre del almacén",
            warehouseAddress: "Dirección del almacén",
            articleNumber: "Número de artículo",
            unit: "Unidad",
            weight: "Peso",
            length: "Longitud",
            width: "Ancho",
            height: "Altura",
            stock: "Stock",
            responsibleEmployee: "Empleado responsable",
            dimensions: "Dimensiones",
            warehouse: "Almacén",
            deleteTitle: "Eliminar producto",
            deleteConfirm: "¿Está seguro de que desea eliminar {{name}}?",
            units: {
              piece: "Pieza",
              kg: "Kilogramo",
              package: "Paquete"
            },

            import: {
              steps: {
                upload: "Subir",
                map: "Mapear",
                import: "Importar"
              },
              selectfile: "Seleccionar archivo",
              guide: "Para importar productos: 1) Cree un archivo Excel con columnas para los datos del producto 2) La primera fila debe contener los nombres de las columnas 3) Cada fila representa un producto 4) Campo obligatorio: Nombre del producto 5) La asignación predeterminada de columnas está configurada en A1, B1, etc.",
              guideTitle: "Instrucciones de importación"
            },
          
            
           }
        }
    },





    pt: {
      translation: {
        common: {
          nazvanie: "Nome",
          maxprice: "Preço máximo",
          category: "Categoria",
          title: "Título",
          addnew: "Adicionar novo",
          projectType: "Tipo de projeto",
          history: "Histórico",
          assignSpecialists: "Atribuir especialistas",
          uploadSpecialistPhoto: "Carregar foto do especialista",
          selectimage: "Selecionar imagem",
          upload: "Carregar",
          anySpecialist: "Qualquer especialista",
          allServices: "Todos os serviços",  
          minutes: "minutos",
          deleted: "Remotos",
          add: "Adicionar",
          edit: "Editar",
          delete: "Excluir",
          save: "Salvar",
          cancel: "Cancelar",
          confirm: "Confirmar",
          back: "Voltar",
          next: "Próximo",
          min: "min",
          login: "Entrar",
          register: "Registrar",
          logout: "Sair",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          name: "Nome",
          actions: "Ações",
          optional: "opcional",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Status",
          savechanges: "Salvar alterações",
          changespecialist: "Mudar especialista",
          past: "Passado",
          ongoing: "Em andamento",
          upcoming: "Próximo",
          future: "Futuro",
          specialist: "Especialista",
          errorApproving: "Erro ao aprovar",
          errorRejecting: "Erro ao rejeitar",
          errorSaving: "Erro ao salvar",
          specialists: "Especialistas",
          schedule: "Agenda",
          services: "Serviços",
          service: "Serviço",
          pendingApprovals: "Aprovações pendentes",
          activeSpecialists: "Especialistas ativos",
          approve: "Aprovar",
          reject: "Rejeitar",
          namecompany: "Nome/Empresa",
          firstcontact: "Primeiro contato",
          contacts: "Contatos",
          projectstatus: "Status do projeto",
          createdby: "Criado por",
          assignedto: "Atribuído a",
          clearalldeleted: "Limpar todos excluídos",
          dashboard: "Painel",
          editservices: "Editar serviços",
          setschedule: "Definir agenda",
          website: "Site",
          new: "Novo",
          regular: "Regular",
          former: "Anterior",
          clientstatus: "Status do cliente",
          address: "Endereço",
          assignspecialiststo: "Atribuir especialistas a",
          discussion: "Discussão",
          firstcontactdate: "Data do primeiro contato",
          projecttype: "Tipo de projeto",
          projectdescription: "Descrição do projeto",
          technicaldetails: "Detalhes técnicos",
          budget: "Orçamento",
          contacted: "Contactado",
          unreachable: "Inacessível",
          negotiating: "Negociando",
          meeting: "Reunião",
          development: "Desenvolvimento",
          completed: "Concluído",
          telegramoptional: "Telegram (opcional)",
          instagramoptional: "Instagram (opcional)",
          alreadyhaveanaccount: "Já tem uma conta? Entrar",
          myappointments: "Minhas consultas",
          myclients: "Meus clientes",
          settings: "Configurações",
          profilesettings: "Configurações de perfil",
          saveprofilechanges: "Salvar alterações do perfil",
          changepassword: "Alterar senha",
          currentpassword: "Senha atual",
          newpassword: "Nova senha",
          confirmnewpassword: "Confirmar nova senha",
          deleteaccount: "Excluir conta",
          accountsettings: "Configurações da conta",
          saveschedule: "Salvar agenda",
          starttime: "Hora de início",
          endtime: "Hora de término",
          addnewclient: "Adicionar novo cliente",
          editclient: "Editar cliente",
          newclient: "Novo cliente",

          export: "Exportar",
          import: "Importar",
          saving: "Salvando...",
          role: "Função",
          editRole: "Editar função",
          changeRole: "Alterar função",
          specialistRoleDescription: "Acesso a tarefas especializadas e dados do projeto",
          adminRoleDescription: "Acesso completo para gerenciar configurações e usuários",
          superadmin: "Suporte Técnico Aunimeda",
          admin: "Administrador",
          noServicesSelected: "Nenhum serviço selecionado",
          none: "Nenhum",
          create: "Criar",   
    
          projectStatus: {
            discussion: "Discussão",
            contacted: "Contactado",
            unreachable: "Inacessível",
            negotiating: "Negociando",
            meeting: "Reunião",
            development: "Desenvolvimento",
            completed: "Concluído"
          },
    
          assignedspecialists: "Especialistas atribuídos",
          visibletoallspecialists: "Visível para todos os especialistas",
          allspecialists: "Todos os especialistas",
          createclient: "Criar cliente",
          client: "Cliente",
          selectservices: "Selecionar serviços",
          selectspecialist: "Selecionar especialista",
          selectdateandtime: "Selecionar data e hora",
          confirmbooking: "Confirmar agendamento",
          selectall: "Selecionar todos",
          editservicesfor: "Editar serviços para",
          clearall: "Limpar tudo",
          duration: "Duração",
          price: "Preço",
          selected: "Selecionado",
          saveservices: "Salvar serviços",
          selectservicesthisspecialistcanprovidetoclients: "Selecionar serviços que este especialista pode fornecer aos clientes",
          confirmClearAllDeleted: "Tem certeza que deseja excluir todos os clientes da pasta excluídos? Esta ação não pode ser desfeita.",
    
          setSchedule: "Definir agenda",
          setWorkingHours: "Definir horário de trabalho",
          setworkinghoursfor: "Definir horário de trabalho para",
          startTime: "Hora de início",
          endTime: "Hora de término",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo"
        },
        auth: {
          login: {
            title: "Entrar",
            invalidCredentials: "Email ou senha inválidos",
            forgotPassword: "Esqueceu a senha?",
            noAccount: "Não tem conta?",
            registerHere: "Registre-se aqui"
          },
          register: {
            title: "Registro",
            success: "Registro bem-sucedido",
            haveAccount: "Já tem conta?",
            loginHere: "Entre aqui",
            asClient: "Registrar como cliente",
            asSpecialist: "Registrar como especialista",
            waitingApproval: "Registro bem-sucedido. Aguardando aprovação do administrador."
          }
        },
        booking: {
          steps: {
            selectService: "Selecionar serviço",
            selectSpecialist: "Selecionar especialista",
            selectDateTime: "Selecionar data e hora",
            confirmation: "Confirmação"
          },
          services: {
            title: "Selecionar um serviço",
            duration: "Duração",
            price: "Preço"
          },
          specialists: {
            title: "Selecionar um especialista",
            availability: "Horários disponíveis",
            noAvailability: "Sem horários disponíveis"
          },
          datetime: {
            title: "Selecionar data e hora",
            availableSlots: "Horários disponíveis",
            noSlots: "Sem horários disponíveis para esta data"
          },
          confirmation: {
            title: "Confirmar agendamento",
            details: "Detalhes do agendamento",
            service: "Serviço",
            specialist: "Especialista",
            dateTime: "Data e hora",
            clientInfo: "Suas informações",
            confirming: "Confirmando...",
            confirmBooking: "Confirmar agendamento",
            error: "Erro ao criar agendamento"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Consultas",
            clients: "Clientes",
            services: "Serviços",
            specialists: "Especialistas",
            settings: "Configurações",
            products: "Produtos"
          },
          appointments: {
            title: "Consultas",
            upcoming: "Próximas",
            past: "Passadas",
            datetime: "Data e hora",
            client: "Cliente",
            service: "Serviço",
            specialist: "Especialista",
            duration: "Duração",
            deleteConfirm: "Tem certeza que deseja excluir esta consulta?",
            status: {
              pending: "Pendente",
              confirmed: "Confirmada",
              cancelled: "Cancelada",
              completed: "Concluída"
            },
            actions: {
              confirm: "Confirmar",
              cancel: "Cancelar",
              reschedule: "Reagendar"
            }
          },
          clients: {
            title: "Clientes",
            addNew: "Adicionar novo cliente",
            management: "Gestão de clientes",
            details: "Detalhes do cliente",
            history: "Histórico do cliente",
            status: {
              new: "Novo",
              regular: "Regular",
              former: "Anterior",
              deleted: "Excluído"
            },
            tabs: {
              new: "Novos",
              regular: "Regulares",
              former: "Anteriores",
              deleted: "Excluídos"
            }
          },
          services: {
            title: "Serviços",
            addNew: "Adicionar novo serviço",
            editService: "Editar serviço",
            fields: {
              name: "Nome do serviço",
              duration: "Duração",
              price: "Preço"
            }
          },
          specialists: {
            title: "Especialistas",
            addNew: "Adicionar especialista",
            management: "Gestão de especialistas",
            schedule: "Horário de trabalho",
            services: "Serviços disponíveis",
            status: {
              pending: "Pendente de aprovação",
              approved: "Aprovado",
              rejected: "Rejeitado"
            }
          },
          settings: {
            title: "Configurações",
            profile: "Configurações de perfil",
            account: "Configurações da conta",
            password: "Alterar senha",
            fields: {
              currentPassword: "Senha atual",
              newPassword: "Nova senha",
              confirmPassword: "Confirmar senha"
            }
          }
        },
        settings: {
          tabAndColumnVisibility: "Visibilidade de abas e colunas",
      tabOrder: "Ordem das abas",
      hiddenTabs: "Abas ocultas",
      clientColumns: "Colunas do cliente",
          crmSettings: "Configurações CRM",
          promoText: "Texto promocional",
          headerTitle: "Título",
          headerSubtitle: "Descrição",
          defaultLanguage: "Idioma padrão",
          currency: "Moeda",
          currencyPosition: "Posição da moeda",
          currencyRight: "À direita",
          currencyLeft: "À esquerda",
          hideAppointments: "Ocultar aba 'Agendamentos'",
          hideSpecialists: "Ocultar aba 'Especialistas'",
          hideServices: "Ocultar aba 'Serviços'",
          hideClients: "Ocultar aba 'Clientes'",
          hideProducts: "Ocultar aba 'Produtos'",
          tabsSaved: "Configurações de abas salvas",
          errorFetching: "Erro ao carregar configurações",
          errorSaving: "Erro ao salvar configurações",
          tabsDescription: "Configure a aparência e o comportamento das abas",
          tabVisibility: "Alternar a visibilidade das abas",
          configureTabs: "Ajuste as configurações das suas abas"

         },
         
         products: {
          defaultcategory: "Padrão",
          title: "Gestão de produtos",
          addNew: "Adicionar produto",
          edit: "Editar produto",
          create: "Criar produto",
          name: "Nome",
          category: "Categoria",
          price: "Preço",
          costPrice: "Preço de custo",
          warehouseName: "Nome do armazém",
          warehouseAddress: "Endereço do armazém",
          articleNumber: "Número do artigo",
          unit: "Unidade",
          weight: "Peso",
          length: "Comprimento",
          width: "Largura",
          height: "Altura",
          stock: "Estoque",
          responsibleEmployee: "Funcionário responsável",
          dimensions: "Dimensões",
          warehouse: "Armazém",
          deleteTitle: "Excluir produto",
          deleteConfirm: "Tem certeza que deseja excluir {{name}}?",
          units: {
            piece: "Peça",
            kg: "Quilograma",
            package: "Pacote"
          },
          import: {
            steps: {
              upload: "Carregar",
              map: "Mapear",
              import: "Importar"
            },
            selectfile: "Selecionar arquivo",
            guide: "Para importar produtos: 1) Crie um arquivo Excel com colunas para os dados do produto 2) A primeira linha deve conter os nomes das colunas 3) Cada linha representa um produto 4) Campo obrigatório: Nome do produto 5) A atribuição padrão de colunas está configurada em A1, B1, etc.",
            guideTitle: "Instruções de importação"
          }
         }  
      }
    },



    kg: {
      translation: {
        common: {
          nazvanie: "Аты",
      maxprice: "Эң жогорку баа",
      category: "Категория",
      title: "Тема",
      addnew: "Жаңы кошуу",
      projectType: "Долбоордун түрү",
      history: "Тарых",
      assignSpecialists: "Адистерди дайындоо",
      uploadSpecialistPhoto: "Адистин сүрөтүн жүктөө",
      selectimage: "Сүрөт тандоо",
      upload: "Жүктөө",
      anySpecialist: "Кандай болбосун адис",
      allServices: "Бардык кызматтар",
          minutes: "мүнөт",
          deleted: "Алыстан",
          add: "Кошуу",
          edit: "Түзөтүү",
          delete: "Өчүрүү",
          save: "Сактоо",
          cancel: "Жокко чыгаруу",
          confirm: "Ырастоо",
          back: "Артка",
          next: "Кийинки",
          min: "мүн",
          login: "Кирүү",
          register: "Катталуу",
          logout: "Чыгуу",
          email: "Email",
          password: "Сырсөз",
          phone: "Телефон",
          name: "Аты",
          actions: "Аракеттер",
          optional: "милдеттүү эмес",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Статус",
          savechanges: "Өзгөртүүлөрдү сактоо",
          changespecialist: "Адисти алмаштыруу",
          past: "Өткөн",
          ongoing: "Учурдагы",
          upcoming: "Келе жаткан",
          future: "Келечек",
          specialist: "Адис",
          errorApproving: "Бекитүүдө ката",
          errorRejecting: "Четке кагууда ката",
          errorSaving: "Сактоодо ката",
          specialists: "Адистер",
          schedule: "Жадыбал",
          services: "Кызматтар",
          service: "Кызмат",
          pendingApprovals: "Бекитүүнү күтүүдө",
          activeSpecialists: "Активдүү адистер",
          approve: "Бекитүү",
          reject: "Четке кагуу",
          namecompany: "Аты/Компания",
          firstcontact: "Биринчи байланыш",
          contacts: "Байланыштар",
          projectstatus: "Долбоордун статусу",
          createdby: "Түзгөн",
          assignedto: "Дайындалган",
          clearalldeleted: "Баарын тазалоо",
          dashboard: "Башкаруу панели",
          editservices: "Кызматтарды түзөтүү",
          setschedule: "Жадыбал түзүү",
          website: "Веб-сайт",
          new: "Жаңы",
          regular: "Туруктуу",
          former: "Мурунку",
          clientstatus: "Кардар статусу",
          address: "Дарек",
          assignspecialiststo: "Адистерди дайындоо",
          discussion: "Талкуулоо",
          firstcontactdate: "Биринчи байланыш күнү",
          projecttype: "Долбоордун түрү",
          projectdescription: "Долбоордун сүрөттөмөсү",
          technicaldetails: "Техникалык маалыматтар",
          budget: "Бюджет",
          contacted: "Байланышты",
          unreachable: "Жетүүгө мүмкүн эмес",
          negotiating: "Сүйлөшүүлөр",
          meeting: "Жолугушуу",
          development: "Иштеп чыгуу",
          completed: "Аяктады",
          telegramoptional: "Telegram (милдеттүү эмес)",
          instagramoptional: "Instagram (милдеттүү эмес)",
          alreadyhaveanaccount: "Аккаунтуңуз барбы? Кирүү",
          myappointments: "Менин жолугушууларым",
          myclients: "Менин кардарларым",
          settings: "Орнотуулар",
          profilesettings: "Профиль орнотуулары",
          saveprofilechanges: "Профиль өзгөртүүлөрүн сактоо",
          changepassword: "Сырсөздү өзгөртүү",
          currentpassword: "Учурдагы сырсөз",
          newpassword: "Жаңы сырсөз",
          confirmnewpassword: "Жаңы сырсөздү ырастоо",
          deleteaccount: "Аккаунтту өчүрүү",
          accountsettings: "Аккаунт орнотуулары",
          saveschedule: "Жадыбалды сактоо",
          starttime: "Баштоо убактысы",
          endtime: "Аяктоо убактысы",
          addnewclient: "Жаңы кардар кошуу",
          editclient: "Кардарды түзөтүү",
          newclient: "Жаңы кардар",
          export: "Экспорттоо",
          import: "Импорттоо",
          saving: "Сакталууда...",
          role: "Роль",
          editRole: "Ролду өзгөртүү",
          changeRole: "Ролду алмаштыруу",
          specialistRoleDescription: "Адистештирилген тапшырмаларга жана долбоордун маалыматтарына жетүү",
          adminRoleDescription: "Орнотууларды жана колдонуучуларды башкаруу үчүн толук жетүү",
          superadmin: "Aunimeda техникалык колдоо",
          admin: "Администратор",
          noServicesSelected: "Кызматтар тандалган жок",
          none: "Жок",
          create: "Түзүү",    
    
          projectStatus: {
            discussion: "Талкуулоо",
            contacted: "Байланышты",
            unreachable: "Жетүүгө мүмкүн эмес",
            negotiating: "Сүйлөшүүлөр",
            meeting: "Жолугушуу",
            development: "Иштеп чыгуу",
            completed: "Аяктады"
          },
    
          assignedspecialists: "Дайындалган адистер",
          visibletoallspecialists: "Бардык адистерге көрүнөт",
          allspecialists: "Бардык адистер",
          createclient: "Кардар түзүү",
          client: "Кардар",
          selectservices: "Кызматтарды тандоо",
          selectspecialist: "Адисти тандоо",
          selectdateandtime: "Күн жана убакытты тандоо",
          confirmbooking: "Жазылууну ырастоо",
          selectall: "Баарын тандоо",
          editservicesfor: "Кызматтарды түзөтүү",
          clearall: "Баарын тазалоо",
          duration: "Узактык",
          price: "Баасы",
          selected: "Тандалды",
          saveservices: "Кызматтарды сактоо",
          selectservicesthisspecialistcanprovidetoclients: "Бул адис көрсөтө ала турган кызматтарды тандаңыз",
          confirmClearAllDeleted: "Өчүрүлгөн папкадан бардык кардарларды өчүрүүнү каалайсызбы? Бул аракетти кайтаруу мүмкүн эмес.",
    
          setSchedule: "Жадыбал түзүү",
          setWorkingHours: "Жумуш убактысын коюу",
          setworkinghoursfor: "Жумуш убактысын коюу",
          startTime: "Баштоо убактысы",
          endTime: "Аяктоо убактысы",
          monday: "Дүйшөмбү",
          tuesday: "Шейшемби",
          wednesday: "Шаршемби",
          thursday: "Бейшемби",
          friday: "Жума",
          saturday: "Ишемби",
          sunday: "Жекшемби"
        },
        auth: {
          login: {
            title: "Кирүү",
            invalidCredentials: "Туура эмес email же сырсөз",
            forgotPassword: "Сырсөздү унуттуңузбу?",
            noAccount: "Аккаунтуңуз жокпу?",
            registerHere: "Бул жерден катталыңыз"
          },
          register: {
            title: "Катталуу",
            success: "Катталуу ийгиликтүү болду",
            haveAccount: "Аккаунтуңуз барбы?",
            loginHere: "Бул жерден кириңиз",
            asClient: "Кардар катары катталуу",
            asSpecialist: "Адис катары катталуу",
            waitingApproval: "Катталуу ийгиликтүү. Администратордун бекитүүсүн күтүүдө."
          }
        },
        booking: {
          steps: {
            selectService: "Кызматты тандоо",
            selectSpecialist: "Адисти тандоо",
            selectDateTime: "Күн жана убакытты тандоо",
            confirmation: "Ырастоо"
          },
          services: {
            title: "Кызматты тандаңыз",
            duration: "Узактык",
            price: "Баасы"
          },
          specialists: {
            title: "Адисти тандаңыз",
            availability: "Бош убакыттар",
            noAvailability: "Бош убакыттар жок"
          },
          datetime: {
            title: "Күн жана убакытты тандаңыз",
            availableSlots: "Бош убакыттар",
            noSlots: "Бул күнгө бош убакыттар жок"
          },
          confirmation: {
            title: "Жазылууну ырастоо",
            details: "Жазылуу маалыматтары",
            service: "Кызмат",
            specialist: "Адис",
            dateTime: "Күн жана убакыт",
            clientInfo: "Сиздин маалыматтарыңыз",
            confirming: "Ырасталууда...",
            confirmBooking: "Жазылууну ырастоо",
            error: "Жазылууну түзүүдө ката кетти"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Жазылуулар",
            clients: "Кардарлар",
            services: "Кызматтар",
            specialists: "Адистер",
            settings: "Орнотуулар",
            products: "Товарлар"

          },
          appointments: {
            title: "Жазылуулар",
            upcoming: "Келе жаткан",
            past: "Өткөн",
            datetime: "Күн жана убакыт",
            client: "Кардар",
            service: "Кызмат",
            specialist: "Адис",
            duration: "Узактык",
            deleteConfirm: "Бул жазылууну өчүрүүнү каалайсызбы?",
            status: {
              pending: "Күтүүдө",
              confirmed: "Ырасталды",
              cancelled: "Жокко чыгарылды",
              completed: "Аяктады"
            },
            actions: {
              confirm: "Ырастоо",
              cancel: "Жокко чыгаруу",
              reschedule: "Убактысын өзгөртүү"
            }
          },
          clients: {
            title: "Кардарлар",
            addNew: "Жаңы кардар кошуу",
            management: "Кардарларды башкаруу",
            details: "Кардар маалыматтары",
            history: "Кардар тарыхы",
            status: {
              new: "Жаңы",
              regular: "Туруктуу",
              former: "Мурунку",
              deleted: "Өчүрүлгөн"
            },
            tabs: {
              new: "Жаңы",
              regular: "Туруктуу",
              former: "Мурунку",
              deleted: "Өчүрүлгөн"
            }
          },
          services: {
            title: "Кызматтар",
            addNew: "Жаңы кызмат кошуу",
            editService: "Кызматты түзөтүү",
            fields: {
              name: "Кызмат аты",
              duration: "Узактык",
              price: "Баасы"
            }
          },
          specialists: {
            title: "Адистер",
            addNew: "Жаңы адис кошуу",
            management: "Адистерди башкаруу",
            schedule: "Жумуш графиги",
            services: "Жеткиликтүү кызматтар",
            status: {
              pending: "Бекитүүнү күтүүдө",
              approved: "Бекитилди",
              rejected: "Четке кагылды"
            }
          },
          settings: {
            title: "Орнотуулар",
            profile: "Профиль орнотуулары",
            account: "Аккаунт орнотуулары",
            password: "Сырсөздү өзгөртүү",
            fields: {
              currentPassword: "Учурдагы сырсөз",
              newPassword: "Жаңы сырсөз",
              confirmPassword: "Сырсөздү ырастоо"
            }
          }
        },
        settings: {
          tabAndColumnVisibility: "Тилке жана тилкелердин көрүнүшү",
      tabOrder: "Тилке тартиби",
      hiddenTabs: "Жашырылган тилкелер",
      clientColumns: "Кардардын тилкелери",
          crmSettings: "CRM орнотуулары",
          promoText: "Промо текст",
          headerTitle: "Аталышы",
          headerSubtitle: "Сүрөттөмө",
          defaultLanguage: "Демейки тил",
          currency: "Валюта",
          currencyPosition: "Валютанын жайгашуусу",
          currencyRight: "Оң жакта",
          currencyLeft: "Сол жакта",
          hideAppointments: "Жолугушуулар өңдөөсүн жашыруу",
          hideSpecialists: "Адистер өңдөөсүн жашыруу",
          hideServices: "Кызматтар өңдөөсүн жашыруу",
          hideClients: "Кардарлар өңдөөсүн жашыруу",
          hideProducts: "Продуктулар өңдөөсүн жашыруу",
          tabsSaved: "Өңдөө параметрлери сакталды",
          errorFetching: "Параметрлерди жүктөөдө ката чыкты",
          errorSaving: "Параметрлерди сактоодо ката чыкты",
          tabsDescription: "Калкалардынын көрүнүшүн жана жүрүм-турумун орнотуңуз",
          tabVisibility: "Калкалардын көрүнүшүн өзгөртүү",
          configureTabs: "Калкалардын орнотууларын настройкалоо"
  
         },
         
         products: {
          defaultcategory: "Демейки",
          title: "Товарларды башкаруу",
          addNew: "Жаңы товар кошуу",
          edit: "Товарды түзөтүү",
          create: "Товар түзүү",
          name: "Аталышы",
          category: "Категория",
          price: "Баасы",
          costPrice: "Өздүк наркы",
          warehouseName: "Склад аталышы",
          warehouseAddress: "Склад дареги",
          articleNumber: "Артикул",
          unit: "Өлчөө бирдиги",
          weight: "Салмагы",
          length: "Узундугу",
          width: "Туурасы",
          height: "Бийиктиги",
          stock: "Складда",
          responsibleEmployee: "Жооптуу кызматкер",
          dimensions: "Өлчөмдөрү",
          warehouse: "Склад",
          deleteTitle: "Товарды өчүрүү",
          deleteConfirm: "Сиз {{name}} өчүрүүнү каалайсызбы?",
          import: {
            steps: {
              upload: "Жүктөө",
              map: "Картасын чыгаруу",
              import: "Импорттоо"
            },
            selectfile: "Файл тандоо",
            guide: "Продукцияны импорттоо үчүн: 1) Продукциянын маалыматтарын камтыган Excel файлын түзүү 2) Биринчи сапта тилкелердин аттары болушу керек 3) Ар бир сап бир продуктту билдирет 4) Зарыл талаа: Продукциянын аты 5) Демейки тилкелердин түзүлүшү A1, B1 ж.б. боюнча орнотулат.",
            guideTitle: "Импорттоо боюнча көрсөтмө"
          },
          units: {
            piece: "Даана",
            kg: "Килограмм",
            package: "Таңгак"
          }
         }
      }
    },


    uz: {
      translation: {
        common: {
          nazvanie: "Nomi",
          maxprice: "Maksimal narx",
          category: "Kategoriya",
          title: "Sarlavha",
          addnew: "Yangi qo'shish",
          projectType: "Loyiha turi",
          history: "Tarix",
          assignSpecialists: "Mutaxassislarni tayinlash",
          uploadSpecialistPhoto: "Mutaxassisning fotosuratini yuklash",
          selectimage: "Rasmni tanlash",
          upload: "Yuklash",
          anySpecialist: "Har qanday mutaxassis",
          allServices: "Barcha xizmatlar",  
          minutes: "daqiqa",

          deleted: "Masofaviy",
          add: "Qo'shish",
          edit: "Tahrirlash",
          delete: "O'chirish",
          save: "Saqlash",
          cancel: "Bekor qilish",
          confirm: "Tasdiqlash",
          back: "Orqaga",
          next: "Keyingi",
          min: "daq",
          login: "Kirish",
          register: "Ro'yxatdan o'tish",
          logout: "Chiqish",
          email: "Email",
          password: "Parol",
          phone: "Telefon",
          name: "Ism",
          actions: "Harakatlar",
          optional: "ixtiyoriy",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Holat",
          savechanges: "O'zgarishlarni saqlash",
          changespecialist: "Mutaxassisni o'zgartirish",
          past: "O'tgan",
          ongoing: "Davom etmoqda",
          upcoming: "Kelayotgan",
          future: "Kelajak",
          specialist: "Mutaxassis",
          errorApproving: "Tasdiqlashda xatolik",
          errorRejecting: "Rad etishda xatolik",
          errorSaving: "Saqlashda xatolik",
          specialists: "Mutaxassislar",
          schedule: "Jadval",
          services: "Xizmatlar",
          service: "Xizmat",
          pendingApprovals: "Tasdiqlashni kutmoqda",
          activeSpecialists: "Faol mutaxassislar",
          approve: "Tasdiqlash",
          reject: "Rad etish",
          namecompany: "Ism/Kompaniya",
          firstcontact: "Birinchi aloqa",
          contacts: "Kontaktlar",
          projectstatus: "Loyiha holati",
          createdby: "Yaratdi",
          assignedto: "Tayinlangan",
          clearalldeleted: "O'chirilganlarni tozalash",
          dashboard: "Boshqaruv paneli",
          editservices: "Xizmatlarni tahrirlash",
          setschedule: "Jadval o'rnatish",
          website: "Veb-sayt",
          new: "Yangi",
          regular: "Doimiy",
          former: "Avvalgi",
          clientstatus: "Mijoz holati",
          address: "Manzil",
          assignspecialiststo: "Mutaxassislarni tayinlash",
          discussion: "Muhokama",
          firstcontactdate: "Birinchi aloqa sanasi",
          projecttype: "Loyiha turi",
          projectdescription: "Loyiha tavsifi",
          technicaldetails: "Texnik tafsilotlar",
          budget: "Byudjet",
          contacted: "Aloqaga chiqildi",
          unreachable: "Bog'lanib bo'lmaydi",
          negotiating: "Muzokara",
          meeting: "Uchrashuv",
          development: "Ishlab chiqish",
          completed: "Tugatildi",
          telegramoptional: "Telegram (ixtiyoriy)",
          instagramoptional: "Instagram (ixtiyoriy)",
          alreadyhaveanaccount: "Hisobingiz bormi? Kirish",
          myappointments: "Mening uchrashuvlarim",
          myclients: "Mening mijozlarim",
          settings: "Sozlamalar",
          profilesettings: "Profil sozlamalari",
          saveprofilechanges: "Profil o'zgarishlarini saqlash",
          changepassword: "Parolni o'zgartirish",
          currentpassword: "Joriy parol",
          newpassword: "Yangi parol",
          confirmnewpassword: "Yangi parolni tasdiqlash",
          deleteaccount: "Hisobni o'chirish",
          accountsettings: "Hisob sozlamalari",
          saveschedule: "Jadvalni saqlash",
          starttime: "Boshlash vaqti",
          endtime: "Tugash vaqti",
          addnewclient: "Yangi mijoz qo'shish",
          editclient: "Mijozni tahrirlash",
          newclient: "Yangi mijoz",
          export: "Eksport",
          import: "Import",
          saving: "Saqlanmoqda...",
          role: "Rol",
          editRole: "Rolni tahrirlash",
          changeRole: "Rolni o'zgartirish",
          specialistRoleDescription: "Maxsus vazifalarga va loyiha ma'lumotlariga kirish",
          adminRoleDescription: "Sozlamalar va foydalanuvchilarni boshqarish uchun to'liq kirish",
          superadmin: "Aunimeda texnik yordam",
          admin: "Administrator",
          noServicesSelected: "Xizmatlar tanlanmagan",
          none: "Yo'q",
          create: "Yaratish",  
    
          projectStatus: {
            discussion: "Muhokama",
            contacted: "Aloqaga chiqildi",
            unreachable: "Bog'lanib bo'lmaydi",
            negotiating: "Muzokara",
            meeting: "Uchrashuv",
            development: "Ishlab chiqish",
            completed: "Tugatildi"
          },
    
          assignedspecialists: "Tayinlangan mutaxassislar",
          visibletoallspecialists: "Barcha mutaxassislarga ko'rinadi",
          allspecialists: "Barcha mutaxassislar",
          createclient: "Mijoz yaratish",
          client: "Mijoz",
          selectservices: "Xizmatlarni tanlash",
          selectspecialist: "Mutaxassisni tanlash",
          selectdateandtime: "Sana va vaqtni tanlash",
          confirmbooking: "Bronni tasdiqlash",
          selectall: "Barchasini tanlash",
          editservicesfor: "Xizmatlarni tahrirlash",
          clearall: "Barchasini tozalash",
          duration: "Davomiyligi",
          price: "Narx",
          selected: "Tanlandi",
          saveservices: "Xizmatlarni saqlash",
          selectservicesthisspecialistcanprovidetoclients: "Ushbu mutaxassis mijozlarga taqdim eta oladigan xizmatlarni tanlang",
          confirmClearAllDeleted: "O'chirilganlar papkasidan barcha mijozlarni o'chirishni xohlaysizmi? Bu amalni qaytarib bo'lmaydi.",
    
          setSchedule: "Jadval o'rnatish",
          setWorkingHours: "Ish soatlarini o'rnatish",
          setworkinghoursfor: "Ish soatlarini o'rnatish",
          startTime: "Boshlash vaqti",
          endTime: "Tugash vaqti",
          monday: "Dushanba",
          tuesday: "Seshanba",
          wednesday: "Chorshanba",
          thursday: "Payshanba",
          friday: "Juma",
          saturday: "Shanba",
          sunday: "Yakshanba"
        },
        auth: {
          login: {
            title: "Kirish",
            invalidCredentials: "Noto'g'ri email yoki parol",
            forgotPassword: "Parolni unutdingizmi?",
            noAccount: "Hisobingiz yo'qmi?",
            registerHere: "Bu yerda ro'yxatdan o'ting"
          },
          register: {
            title: "Ro'yxatdan o'tish",
            success: "Ro'yxatdan o'tish muvaffaqiyatli",
            haveAccount: "Hisobingiz bormi?",
            loginHere: "Bu yerda kiring",
            asClient: "Mijoz sifatida ro'yxatdan o'tish",
            asSpecialist: "Mutaxassis sifatida ro'yxatdan o'tish",
            waitingApproval: "Ro'yxatdan o'tish muvaffaqiyatli. Administrator tasdiqini kutmoqda."
          }
        },
        booking: {
          steps: {
            selectService: "Xizmatni tanlash",
            selectSpecialist: "Mutaxassisni tanlash",
            selectDateTime: "Sana va vaqtni tanlash",
            confirmation: "Tasdiqlash"
          },
          services: {
            title: "Xizmatni tanlang",
            duration: "Davomiyligi",
            price: "Narx"
          },
          specialists: {
            title: "Mutaxassisni tanlang",
            availability: "Bo'sh vaqtlar",
            noAvailability: "Bo'sh vaqtlar yo'q"
          },
          datetime: {
            title: "Sana va vaqtni tanlang",
            availableSlots: "Bo'sh vaqtlar",
            noSlots: "Bu sanaga bo'sh vaqtlar yo'q"
          },
          confirmation: {
            title: "Bronni tasdiqlash",
            details: "Bron tafsilotlari",
            service: "Xizmat",
            specialist: "Mutaxassis",
            dateTime: "Sana va vaqt",
            clientInfo: "Sizning ma'lumotlaringiz",
            confirming: "Tasdiqlanmoqda...",
            confirmBooking: "Bronni tasdiqlash",
            error: "Bronni yaratishda xatolik"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Uchrashuvlar",
            clients: "Mijozlar",
            services: "Xizmatlar",
            specialists: "Mutaxassislar",
            settings: "Sozlamalar",
            products: "Mahsulotlar"

          },
          appointments: {
            title: "Uchrashuvlar",
            upcoming: "Kelayotgan",
            past: "O'tgan",
            datetime: "Sana va vaqt",
            client: "Mijoz",
            service: "Xizmat",
            specialist: "Mutaxassis",
            duration: "Davomiyligi",
            deleteConfirm: "Ushbu uchrashuvni o'chirishni xohlaysizmi?",
            status: {
              pending: "Kutilmoqda",
              confirmed: "Tasdiqlangan",
              cancelled: "Bekor qilingan",
              completed: "Tugatilgan"
            },
            actions: {
              confirm: "Tasdiqlash",
              cancel: "Bekor qilish",
              reschedule: "Qayta rejalashtirish"
            }
          },
          clients: {
            title: "Mijozlar",
            addNew: "Yangi mijoz qo'shish",
            management: "Mijozlarni boshqarish",
            details: "Mijoz tafsilotlari",
            history: "Mijoz tarixi",
            status: {
              new: "Yangi",
              regular: "Doimiy",
              former: "Avvalgi",
              deleted: "O'chirilgan"
            },
            tabs: {
              new: "Yangi",
              regular: "Doimiy",
              former: "Avvalgi",
              deleted: "O'chirilgan"
            }
          },
          services: {
            title: "Xizmatlar",
            addNew: "Yangi xizmat qo'shish",
            editService: "Xizmatni tahrirlash",
            fields: {
              name: "Xizmat nomi",
              duration: "Davomiyligi",
              price: "Narx"
            }
          },
          specialists: {
            title: "Mutaxassislar",
            addNew: "Yangi mutaxassis qo'shish",
            management: "Mutaxassislarni boshqarish",
            schedule: "Ish jadvali",
            services: "Mavjud xizmatlar",
            status: {
              pending: "Tasdiqlashni kutmoqda",
              approved: "Tasdiqlangan",
              rejected: "Rad etilgan"
            }
          },
          settings: {
            title: "Sozlamalar",
            profile: "Profil sozlamalari",
            account: "Hisob sozlamalari",
            password: "Parolni o'zgartirish",
            fields: {
              currentPassword: "Joriy parol",
              newPassword: "Yangi parol",
              confirmPassword: "Parolni tasdiqlash"
            }
          }
        },

        settings: {
          tabAndColumnVisibility: "Yorliq va ustunlar ko'rinishi",
          tabOrder: "Yorliq tartibi",
          hiddenTabs: "Yashirin yorliqlar",
          clientColumns: "Mijoz ustunlari", 
          crmSettings: "CRM sozlamalari",
          promoText: "Promo matn",
          headerTitle: "Sarlavha",
          headerSubtitle: "Tavsif",
          defaultLanguage: "Standart til",
          currency: "Valyuta",
          currencyPosition: "Valyuta joylashuvi",
          currencyRight: "O'ng tomonda",
          currencyLeft: "Chap tomonda",

          hideAppointments: "Uchrashuvlar varsagʻini yashirish",
          hideSpecialists: "Mutaxassislar varsagʻini yashirish",
          hideServices: "Xizmatlar varsagʻini yashirish",
          hideClients: "Mijozlar varsagʻini yashirish",
          hideProducts: "Mahsulotlar varsagʻini yashirish",
          tabsSaved: "Varsak sozlamalari saqlandi",
          errorFetching: "Sozlamalarni yuklab olishda xatolik",
          errorSaving: "Sozlamalarni saqlashda xatolik",
          tabsDescription: "Varaqalarning ko‘rinishi va xatti-harakatlarini sozlang",
          tabVisibility: "Varaqalar ko‘rinishini almashtirish",
          configureTabs: "Varaqalar sozlamalarini moslash"
    
         },
         
         products: {
          defaultcategory: "Standart",
          title: "Mahsulotlarni boshqarish",
          addNew: "Yangi mahsulot qo'shish",
          edit: "Mahsulotni tahrirlash",
          create: "Mahsulot yaratish",
          name: "Nomi",
          category: "Kategoriya",
          price: "Narx",
          costPrice: "Tannarx",
          warehouseName: "Ombor nomi",
          warehouseAddress: "Ombor manzili",
          articleNumber: "Artikul",
          unit: "O'lchov birligi",
          weight: "Og'irlik",
          length: "Uzunlik",
          width: "Kenglik",
          height: "Balandlik",
          stock: "Omborda",
          responsibleEmployee: "Mas'ul xodim",
          dimensions: "O'lchamlar",
          warehouse: "Ombor",
          deleteTitle: "Mahsulotni o'chirish",
          deleteConfirm: "Siz {{name}}ni o'chirishni xohlaysizmi?",
          import: {
            steps: {
              upload: "Yuklash",
              map: "Xaritani tuzish",
              import: "Import qilish"
            },
            selectfile: "Faylni tanlash",
            guide: "Mahsulotlarni import qilish uchun: 1) Mahsulot ma'lumotlarini o'z ichiga olgan Excel faylini yaratish 2) Birinchi qator ustun nomlarini o'z ichiga olishi kerak 3) Har bir qator mahsulotni ifodalaydi 4) Zaruriy maydon: Mahsulot nomi 5) Ustunlarning standart holati A1, B1 va hokazolarga o'rnatiladi.",
            guideTitle: "Import qilish bo'yicha ko'rsatma"
          }, 
          units: {
            piece: "Dona",
            kg: "Kilogramm",
            package: "Paket"
          }
         }
      }
    },


    tr: {
      translation: {
        common: {
          nazvanie: "Adı",
          maxprice: "Maksimum fiyat",
          category: "Kategori",
          title: "Başlık",
          addnew: "Yeni ekle",
          projectType: "Proje türü",
          history: "Tarihçe",
          assignSpecialists: "Uzmanları ata",
          uploadSpecialistPhoto: "Uzmanın fotoğrafını yükle",
          selectimage: "Görüntüyü seç",
          upload: "Yükle",
          anySpecialist: "Herhangi bir uzman",
          allServices: "Tüm hizmetler",   
          minutes: "dakika",
          add: "Ekle",
          edit: "Düzenle",
          delete: "Sil",
          save: "Kaydet",
          cancel: "İptal",
          confirm: "Onayla",
          back: "Geri",
          next: "İleri",
          min: "dk",
          login: "Giriş",
          register: "Kayıt Ol",
          logout: "Çıkış",
          email: "E-posta",
          password: "Şifre",
          phone: "Telefon",
          name: "İsim",
          actions: "İşlemler",
          optional: "isteğe bağlı",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Durum",
          savechanges: "Değişiklikleri Kaydet",
          changespecialist: "Uzmanı Değiştir",
          past: "Geçmiş",
          ongoing: "Devam Eden",
          upcoming: "Yaklaşan",
          future: "Gelecek",
          specialist: "Uzman",
          errorApproving: "Onaylama hatası",
          errorRejecting: "Reddetme hatası",
          errorSaving: "Kaydetme hatası",
          specialists: "Uzmanlar",
          schedule: "Program",
          services: "Hizmetler",
          service: "Hizmet",
          pendingApprovals: "Bekleyen Onaylar",
          activeSpecialists: "Aktif Uzmanlar",
          approve: "Onayla",
          reject: "Reddet",
          namecompany: "İsim/Şirket",
          firstcontact: "İlk İletişim",
          contacts: "İletişim Bilgileri",
          projectstatus: "Proje Durumu",
          createdby: "Oluşturan",
          assignedto: "Atanan",
          clearalldeleted: "Silinenleri Temizle",
          dashboard: "Kontrol Paneli",
          editservices: "Hizmetleri Düzenle",
          setschedule: "Program Ayarla",
          website: "Web Sitesi",
          new: "Yeni",
          regular: "Düzenli",
          former: "Eski",
          deleted: "Silinmiş",
          clientstatus: "Müşteri Durumu",
          address: "Adres",
          assignspecialiststo: "Uzmanları Ata",
          discussion: "Görüşme",
          firstcontactdate: "İlk İletişim Tarihi",
          projecttype: "Proje Türü",
          projectdescription: "Proje Açıklaması",
          technicaldetails: "Teknik Detaylar",
          budget: "Bütçe",
          contacted: "İletişime Geçildi",
          unreachable: "Ulaşılamıyor",
          negotiating: "Görüşme Aşamasında",
          meeting: "Toplantı",
          development: "Geliştirme",
          completed: "Tamamlandı",
          telegramoptional: "Telegram (isteğe bağlı)",
          instagramoptional: "Instagram (isteğe bağlı)",
          alreadyhaveanaccount: "Zaten hesabınız var mı? Giriş yapın",
          myappointments: "Randevularım",
          myclients: "Müşterilerim",
          settings: "Ayarlar",
          profilesettings: "Profil Ayarları",
          saveprofilechanges: "Profil Değişikliklerini Kaydet",
          changepassword: "Şifre Değiştir",
          currentpassword: "Mevcut Şifre",
          newpassword: "Yeni Şifre",
          confirmnewpassword: "Yeni Şifreyi Onayla",
          deleteaccount: "Hesabı Sil",
          accountsettings: "Hesap Ayarları",
          saveschedule: "Programı Kaydet",
          starttime: "Başlangıç Saati",
          endtime: "Bitiş Saati",
          addnewclient: "Yeni Müşteri Ekle",
          editclient: "Müşteriyi Düzenle",
          newclient: "Yeni Müşteri",

          export: "Dışa aktar",
          import: "İçe aktar",
          saving: "Kaydediliyor...",
          role: "Rol",
          editRole: "Rolü düzenle",
          changeRole: "Rolü değiştir",
          specialistRoleDescription: "Özel görevlere ve proje verilerine erişim",
          adminRoleDescription: "Ayarları ve kullanıcıları yönetmek için tam erişim",
          superadmin: "Aunimeda Teknik Destek",
          admin: "Yönetici",
          noServicesSelected: "Seçili hizmet yok",
          none: "Hiçbiri",
          create: "Oluştur", 
    
          projectStatus: {
            discussion: "Görüşme",
            contacted: "İletişime Geçildi",
            unreachable: "Ulaşılamıyor",
            negotiating: "Görüşme Aşamasında",
            meeting: "Toplantı",
            development: "Geliştirme",
            completed: "Tamamlandı"
          },
    
          assignedspecialists: "Atanmış Uzmanlar",
          visibletoallspecialists: "Tüm Uzmanlara Görünür",
          allspecialists: "Tüm Uzmanlar",
          createclient: "Müşteri Oluştur",
          client: "Müşteri",
          selectservices: "Hizmetleri Seç",
          selectspecialist: "Uzman Seç",
          selectdateandtime: "Tarih ve Saat Seç",
          confirmbooking: "Randevuyu Onayla",
          selectall: "Tümünü Seç",
          editservicesfor: "Hizmetleri Düzenle",
          clearall: "Tümünü Temizle",
          duration: "Süre",
          price: "Ücret",
          selected: "Seçildi",
          saveservices: "Hizmetleri Kaydet",
          selectservicesthisspecialistcanprovidetoclients: "Bu uzmanın müşterilere sunabileceği hizmetleri seçin",
          confirmClearAllDeleted: "Silinen klasöründeki tüm müşterileri silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    
          setSchedule: "Program Ayarla",
          setWorkingHours: "Çalışma Saatlerini Ayarla",
          setworkinghoursfor: "Çalışma Saatlerini Ayarla",
          startTime: "Başlangıç Saati",
          endTime: "Bitiş Saati",
          monday: "Pazartesi",
          tuesday: "Salı",
          wednesday: "Çarşamba",
          thursday: "Perşembe",
          friday: "Cuma",
          saturday: "Cumartesi",
          sunday: "Pazar"
        },
        auth: {
          login: {
            title: "Giriş",
            invalidCredentials: "Geçersiz e-posta veya şifre",
            forgotPassword: "Şifremi unuttum?",
            noAccount: "Hesabınız yok mu?",
            registerHere: "Buradan kayıt olun"
          },
          register: {
            title: "Kayıt",
            success: "Kayıt başarılı",
            haveAccount: "Zaten hesabınız var mı?",
            loginHere: "Buradan giriş yapın",
            asClient: "Müşteri olarak kayıt ol",
            asSpecialist: "Uzman olarak kayıt ol",
            waitingApproval: "Kayıt başarılı. Yönetici onayı bekleniyor."
          }
        },
        booking: {
          steps: {
            selectService: "Hizmet Seç",
            selectSpecialist: "Uzman Seç",
            selectDateTime: "Tarih ve Saat Seç",
            confirmation: "Onay"
          },
          services: {
            title: "Hizmet Seçin",
            duration: "Süre",
            price: "Ücret"
          },
          specialists: {
            title: "Uzman Seçin",
            availability: "Uygun Saatler",
            noAvailability: "Uygun saat bulunmuyor"
          },
          datetime: {
            title: "Tarih ve Saat Seçin",
            availableSlots: "Uygun Saatler",
            noSlots: "Bu tarih için uygun saat bulunmuyor"
          },
          confirmation: {
            title: "Randevuyu Onayla",
            details: "Randevu Detayları",
            service: "Hizmet",
            specialist: "Uzman",
            dateTime: "Tarih ve Saat",
            clientInfo: "Bilgileriniz",
            confirming: "Onaylanıyor...",
            confirmBooking: "Randevuyu Onayla",
            error: "Randevu oluşturulurken hata oluştu"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Randevular",
            clients: "Müşteriler",
            services: "Hizmetler",
            specialists: "Uzmanlar",
            settings: "Ayarlar",
            products: "Ürünler"

          },
          appointments: {
            title: "Randevular",
            upcoming: "Yaklaşan",
            past: "Geçmiş",
            datetime: "Tarih ve Saat",
            client: "Müşteri",
            service: "Hizmet",
            specialist: "Uzman",
            duration: "Süre",
            deleteConfirm: "Bu randevuyu silmek istediğinizden emin misiniz?",
            status: {
              pending: "Beklemede",
              confirmed: "Onaylandı",
              cancelled: "İptal Edildi",
              completed: "Tamamlandı"
            },
            actions: {
              confirm: "Onayla",
              cancel: "İptal",
              reschedule: "Yeniden Planla"
            }
          },
          clients: {
            title: "Müşteriler",
            addNew: "Yeni Müşteri Ekle",
            management: "Müşteri Yönetimi",
            details: "Müşteri Detayları",
            history: "Müşteri Geçmişi",
            status: {
              new: "Yeni",
              regular: "Düzenli",
              former: "Eski",
              deleted: "Silinmiş"
            },
            tabs: {
              new: "Yeni",
              regular: "Düzenli",
              former: "Eski",
              deleted: "Silinmiş"
            }
          },
          services: {
            title: "Hizmetler",
            addNew: "Yeni Hizmet Ekle",
            editService: "Hizmeti Düzenle",
            fields: {
              name: "Hizmet Adı",
              duration: "Süre",
              price: "Ücret"
            }
          },
          specialists: {
            title: "Uzmanlar",
            addNew: "Yeni Uzman Ekle",
            management: "Uzman Yönetimi",
            schedule: "Çalışma Programı",
            services: "Mevcut Hizmetler",
            status: {
              pending: "Onay Bekliyor",
              approved: "Onaylandı",
              rejected: "Reddedildi"
            }
          },
          settings: {
            title: "Ayarlar",
            profile: "Profil Ayarları",
            account: "Hesap Ayarları",
            password: "Şifre Değiştir",
            fields: {
              currentPassword: "Mevcut Şifre",
              newPassword: "Yeni Şifre",
              confirmPassword: "Şifreyi Onayla"
            }
          }
        },

        settings: {
          tabAndColumnVisibility: "Sekme ve sütun görünürlüğü",
          tabOrder: "Sekme sırası",
          hiddenTabs: "Gizli sekmeler",
          clientColumns: "Müşteri sütunları",
          crmSettings: "CRM Ayarları",
          promoText: "Promosyon metni",
          headerTitle: "Başlık",
          headerSubtitle: "Açıklama",
          defaultLanguage: "Varsayılan dil",
          currency: "Para birimi",
          currencyPosition: "Para birimi konumu",
          currencyRight: "Sağda",
          currencyLeft: "Solda",

          hideAppointments: "Randevular sekmesini gizle",
          hideSpecialists: "Uzmanlar sekmesini gizle",
          hideServices: "Hizmetler sekmesini gizle",
          hideClients: "Müşteriler sekmesini gizle",
          hideProducts: "Ürünler sekmesini gizle",
          tabsSaved: "Sekme ayarları kaydedildi",
          errorFetching: "Ayarları yüklerken hata oluştu",
          errorSaving: "Ayarları kaydederken hata oluştu",
          tabsDescription: "Sekmelerin görünümünü ve davranışını yapılandırın",
          tabVisibility: "Sekmelerin görünürlüğünü değiştir",
          configureTabs: "Sekme ayarlarını düzenle"

         },
         
         products: {
          defaultcategory: "Varsayılan",
          title: "Ürün Yönetimi",
          addNew: "Yeni Ürün Ekle",
          edit: "Ürünü Düzenle",
          create: "Ürün Oluştur",
          name: "İsim",
          category: "Kategori",
          price: "Fiyat",
          costPrice: "Maliyet",
          warehouseName: "Depo Adı",
          warehouseAddress: "Depo Adresi",
          articleNumber: "Ürün Kodu",
          unit: "Birim",
          weight: "Ağırlık",
          length: "Uzunluk",
          width: "Genişlik",
          height: "Yükseklik",
          stock: "Stok",
          responsibleEmployee: "Sorumlu Çalışan",
          dimensions: "Boyutlar",
          warehouse: "Depo",
          deleteTitle: "Ürünü Sil",
          deleteConfirm: "{{name}} ürününü silmek istediğinizden emin misiniz?",
          units: {
            piece: "Adet",
            kg: "Kilogram",
            package: "Paket"
          },
          import: {
            steps: {
              upload: "Yükle",
              map: "Haritalandır",
              import: "İçeri aktar"
            },
            selectfile: "Dosya seç",
            guide: "Ürünleri içe aktarmak için: 1) Ürün bilgilerini içeren bir Excel dosyası oluşturun 2) İlk satırda sütun adları bulunmalıdır 3) Her satır bir ürünü temsil eder 4) Zorunlu alan: Ürün adı 5) Varsayılan sütun ataması A1, B1, vb. olarak ayarlanır.",
            guideTitle: "İçe Aktarma Talimatları"
          }    
         }
      }
    },



    zh: {
      translation: {
        common: {
          nazvanie: "名称",
          maxprice: "最高价格",
          category: "类别",
          title: "标题",
          addnew: "添加新项目",
          projectType: "项目类型",
          history: "历史",
          assignSpecialists: "分配专家",
          uploadSpecialistPhoto: "上传专家照片",
          selectimage: "选择图片",
          upload: "上传",
          anySpecialist: "任何专家",
          allServices: "所有服务",
          minutes: "分钟",
          add: "添加",
          edit: "编辑",
          delete: "删除",
          save: "保存",
          cancel: "取消",
          confirm: "确认",
          back: "返回",
          next: "下一步",
          min: "分钟",
          login: "登录",
          register: "注册",
          logout: "退出",
          email: "电子邮件",
          password: "密码",
          phone: "电话",
          name: "姓名",
          actions: "操作",
          optional: "可选",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "状态",
          savechanges: "保存更改",
          changespecialist: "更换专家",
          past: "过去",
          ongoing: "进行中",
          upcoming: "即将到来",
          future: "未来",
          specialist: "专家",
          errorApproving: "审批错误",
          errorRejecting: "拒绝错误",
          errorSaving: "保存错误",
          specialists: "专家团队",
          schedule: "日程表",
          services: "服务",
          service: "服务",
          pendingApprovals: "待审批",
          activeSpecialists: "在职专家",
          approve: "批准",
          reject: "拒绝",
          namecompany: "姓名/公司",
          firstcontact: "首次联系",
          contacts: "联系方式",
          projectstatus: "项目状态",
          createdby: "创建者",
          assignedto: "已分配给",
          clearalldeleted: "清除所有已删除",
          dashboard: "控制面板",
          editservices: "编辑服务",
          setschedule: "设置日程",
          website: "网站",
          new: "新建",
          regular: "常规",
          former: "前任",
          deleted: "已删除",
          clientstatus: "客户状态",
          address: "地址",
          assignspecialiststo: "分配专家给",
          discussion: "讨论",
          firstcontactdate: "首次联系日期",
          projecttype: "项目类型",
          projectdescription: "项目描述",
          technicaldetails: "技术细节",
          budget: "预算",
          contacted: "已联系",
          unreachable: "无法联系",
          negotiating: "协商中",
          meeting: "会议",
          development: "开发中",
          completed: "已完成",
          telegramoptional: "Telegram（可选）",
          instagramoptional: "Instagram（可选）",
          alreadyhaveanaccount: "已有账号？登录",
          myappointments: "我的预约",
          myclients: "我的客户",
          settings: "设置",
          profilesettings: "个人资料设置",
          saveprofilechanges: "保存个人资料更改",
          changepassword: "修改密码",
          currentpassword: "当前密码",
          newpassword: "新密码",
          confirmnewpassword: "确认新密码",
          deleteaccount: "删除账号",
          accountsettings: "账号设置",
          saveschedule: "保存日程",
          starttime: "开始时间",
          endtime: "结束时间",
          addnewclient: "添加新客户",
          editclient: "编辑客户",
          newclient: "新客户",

          export: "导出",
          import: "导入",
          saving: "正在保存...",
          role: "角色",
          editRole: "编辑角色",
          changeRole: "更改角色",
          specialistRoleDescription: "访问特殊任务和项目数据",
          adminRoleDescription: "完全访问设置和用户管理",
          superadmin: "Aunimeda技术支持",
          admin: "管理员",
          noServicesSelected: "未选择服务",
          none: "无",
          create: "创建",  
    
          projectStatus: {
            discussion: "讨论",
            contacted: "已联系",
            unreachable: "无法联系",
            negotiating: "协商中",
            meeting: "会议",
            development: "开发中",
            completed: "已完成"
          },
    
          assignedspecialists: "已分配的专家",
          visibletoallspecialists: "对所有专家可见",
          allspecialists: "所有专家",
          createclient: "创建客户",
          client: "客户",
          selectservices: "选择服务",
          selectspecialist: "选择专家",
          selectdateandtime: "选择日期和时间",
          confirmbooking: "确认预约",
          selectall: "全选",
          editservicesfor: "编辑服务",
          clearall: "清除全部",
          duration: "时长",
          price: "价格",
          selected: "已选择",
          saveservices: "保存服务",
          selectservicesthisspecialistcanprovidetoclients: "选择该专家可以为客户提供的服务",
          confirmClearAllDeleted: "确定要删除回收站中的所有客户吗？此操作无法撤销。",
    
          setSchedule: "设置日程",
          setWorkingHours: "设置工作时间",
          setworkinghoursfor: "设置工作时间",
          startTime: "开始时间",
          endTime: "结束时间",
          monday: "星期一",
          tuesday: "星期二",
          wednesday: "星期三",
          thursday: "星期四",
          friday: "星期五",
          saturday: "星期六",
          sunday: "星期日"
        },
        auth: {
          login: {
            title: "登录",
            invalidCredentials: "邮箱或密码错误",
            forgotPassword: "忘记密码？",
            noAccount: "没有账号？",
            registerHere: "在此注册"
          },
          register: {
            title: "注册",
            success: "注册成功",
            haveAccount: "已有账号？",
            loginHere: "在此登录",
            asClient: "注册为客户",
            asSpecialist: "注册为专家",
            waitingApproval: "注册成功。等待管理员审批。"
          }
        },
        booking: {
          steps: {
            selectService: "选择服务",
            selectSpecialist: "选择专家",
            selectDateTime: "选择日期和时间",
            confirmation: "确认"
          },
          services: {
            title: "选择服务",
            duration: "时长",
            price: "价格"
          },
          specialists: {
            title: "选择专家",
            availability: "可用时间",
            noAvailability: "暂无可用时间"
          },
          datetime: {
            title: "选择日期和时间",
            availableSlots: "可用时段",
            noSlots: "该日期暂无可用时段"
          },
          confirmation: {
            title: "确认预约",
            details: "预约详情",
            service: "服务",
            specialist: "专家",
            dateTime: "日期和时间",
            clientInfo: "您的信息",
            confirming: "确认中...",
            confirmBooking: "确认预约",
            error: "创建预约时出错"
          }
        },
        dashboard: {
          tabs: {
            appointments: "预约",
            clients: "客户",
            services: "服务",
            specialists: "专家",
            settings: "设置",
            products: "产品"

          },
          appointments: {
            title: "预约",
            upcoming: "即将到来",
            past: "已过期",
            datetime: "日期和时间",
            client: "客户",
            service: "服务",
            specialist: "专家",
            duration: "时长",
            deleteConfirm: "确定要删除此预约吗？",
            status: {
              pending: "待定",
              confirmed: "已确认",
              cancelled: "已取消",
              completed: "已完成"
            },
            actions: {
              confirm: "确认",
              cancel: "取消",
              reschedule: "重新安排"
            }
          },
          clients: {
            title: "客户",
            addNew: "添加新客户",
            management: "客户管理",
            details: "客户详情",
            history: "客户历史",
            status: {
              new: "新客户",
              regular: "常客",
              former: "前客户",
              deleted: "已删除"
            },
            tabs: {
              new: "新客户",
              regular: "常客",
              former: "前客户",
              deleted: "已删除"
            }
          },
          services: {
            title: "服务",
            addNew: "添加新服务",
            editService: "编辑服务",
            fields: {
              name: "服务名称",
              duration: "时长",
              price: "价格"
            }
          },
          specialists: {
            title: "专家",
            addNew: "添加新专家",
            management: "专家管理",
            schedule: "工作时间",
            services: "可提供服务",
            status: {
              pending: "待审批",
              approved: "已批准",
              rejected: "已拒绝"
            }
          },
          settings: {
            title: "设置",
            profile: "个人资料设置",
            account: "账号设置",
            password: "修改密码",
            fields: {
              currentPassword: "当前密码",
              newPassword: "新密码",
              confirmPassword: "确认密码"
            }
          }
        },
        settings: {
          tabAndColumnVisibility: "选项卡和列的可见性",
          tabOrder: "选项卡顺序",
          hiddenTabs: "隐藏选项卡",
          clientColumns: "客户列",    
          crmSettings: "CRM设置",
          promoText: "促销文本",
          headerTitle: "标题",
          headerSubtitle: "描述",
          defaultLanguage: "默认语言",
          currency: "货币",
          currencyPosition: "货币位置",
          currencyRight: "右侧",
          currencyLeft: "左侧",

          hideAppointments: "隐藏'预约'标签",
          hideSpecialists: "隐藏'专家'标签",
          hideServices: "隐藏'服务'标签",
          hideClients: "隐藏'客户'标签",
          hideProducts: "隐藏'产品'标签",
          tabsSaved: "标签设置已保存",
          errorFetching: "加载设置时出错",
          errorSaving: "保存设置时出错",
          tabsDescription: "配置选项卡的外观和行为",
          tabVisibility: "切换选项卡的可见性",
          configureTabs: "调整选项卡的设置"
    
         },
         products: {
          import: {
            steps: {
              upload: "上传",
              map: "映射",
              import: "导入"
            },
            selectfile: "选择文件",
            guide: "导入产品: 1) 创建一个包含产品数据的Excel文件 2) 第一行应包含列名称 3) 每行代表一个产品 4) 必填字段: 产品名称 5) 默认列分配设置为A1, B1等。",
            guideTitle: "导入说明"
          },
          defaultcategory: "默认",
          title: "产品管理",
          addNew: "添加新产品",
          edit: "编辑产品",
          create: "创建产品",
          name: "名称",
          category: "类别",
          price: "价格",
          costPrice: "成本",
          warehouseName: "仓库名称",
          warehouseAddress: "仓库地址",
          articleNumber: "产品编码",
          unit: "单位",
          weight: "重量",
          length: "长度",
          width: "宽度",
          height: "高度",
          stock: "库存",
          responsibleEmployee: "负责员工",
          dimensions: "尺寸",
          warehouse: "仓库",
          deleteTitle: "删除产品",
          deleteConfirm: "您确定要删除产品 {{name}} 吗？",
          units: {
            piece: "件",
            kg: "千克",
            package: "包"
          }
         }

      }
    },


    de: {
      translation: {
        common: {
          nazvanie: "Name",
          maxprice: "Höchstpreis",
          category: "Kategorie",
          title: "Titel",
          addnew: "Neu hinzufügen",
          projectType: "Projekttyp",
          history: "Geschichte",
          assignSpecialists: "Spezialisten zuweisen",
          uploadSpecialistPhoto: "Spezialistenfoto hochladen",
          selectimage: "Bild auswählen",
          upload: "Hochladen",
          anySpecialist: "Jeder Spezialist",
          allServices: "Alle Dienstleistungen",  
          minutes: "Minuten",
          add: "Hinzufügen",
          edit: "Bearbeiten",
          delete: "Löschen",
          save: "Speichern",
          cancel: "Abbrechen",
          confirm: "Bestätigen",
          back: "Zurück",
          next: "Weiter",
          min: "Min",
          login: "Anmelden",
          register: "Registrieren",
          logout: "Abmelden",
          email: "E-Mail",
          password: "Passwort",
          phone: "Telefon",
          name: "Name",
          actions: "Aktionen",
          optional: "optional",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Status",
          savechanges: "Änderungen speichern",
          changespecialist: "Spezialist wechseln",
          past: "Vergangen",
          ongoing: "Laufend",
          upcoming: "Bevorstehend",
          future: "Zukünftig",
          specialist: "Spezialist",
          errorApproving: "Fehler beim Genehmigen",
          errorRejecting: "Fehler beim Ablehnen",
          errorSaving: "Fehler beim Speichern",
          specialists: "Spezialisten",
          schedule: "Terminplan",
          services: "Dienstleistungen",
          service: "Dienstleistung",
          pendingApprovals: "Ausstehende Genehmigungen",
          activeSpecialists: "Aktive Spezialisten",
          approve: "Genehmigen",
          reject: "Ablehnen",
          namecompany: "Name/Firma",
          firstcontact: "Erster Kontakt",
          contacts: "Kontakte",
          projectstatus: "Projektstatus",
          createdby: "Erstellt von",
          assignedto: "Zugewiesen an",
          clearalldeleted: "Alle gelöschten löschen",
          dashboard: "Dashboard",
          editservices: "Dienstleistungen bearbeiten",
          setschedule: "Terminplan festlegen",
          website: "Webseite",
          new: "Neu",
          regular: "Regulär",
          former: "Ehemalig",
          deleted: "Gelöscht",
          clientstatus: "Kundenstatus",
          address: "Adresse",
          assignspecialiststo: "Spezialisten zuweisen zu",
          discussion: "Diskussion",
          firstcontactdate: "Datum erster Kontakt",
          projecttype: "Projekttyp",
          projectdescription: "Projektbeschreibung",
          technicaldetails: "Technische Details",
          budget: "Budget",
          contacted: "Kontaktiert",
          unreachable: "Nicht erreichbar",
          negotiating: "In Verhandlung",
          meeting: "Meeting",
          development: "Entwicklung",
          completed: "Abgeschlossen",
          telegramoptional: "Telegram (optional)",
          instagramoptional: "Instagram (optional)",
          alreadyhaveanaccount: "Bereits ein Konto? Anmelden",
          myappointments: "Meine Termine",
          myclients: "Meine Kunden",
          settings: "Einstellungen",
          profilesettings: "Profileinstellungen",
          saveprofilechanges: "Profileinstellungen speichern",
          changepassword: "Passwort ändern",
          currentpassword: "Aktuelles Passwort",
          newpassword: "Neues Passwort",
          confirmnewpassword: "Neues Passwort bestätigen",
          deleteaccount: "Konto löschen",
          accountsettings: "Kontoeinstellungen",
          saveschedule: "Terminplan speichern",
          starttime: "Startzeit",
          endtime: "Endzeit",
          addnewclient: "Neuen Kunden hinzufügen",
          editclient: "Kunde bearbeiten",
          newclient: "Neuer Kunde",

          export: "Exportieren",
          import: "Importieren",
          saving: "Wird gespeichert...",
          role: "Rolle",
          editRole: "Rolle bearbeiten",
          changeRole: "Rolle ändern",
          specialistRoleDescription: "Zugriff auf spezielle Aufgaben und Projektdaten",
          adminRoleDescription: "Vollzugriff auf Einstellungen und Benutzerverwaltung",
          superadmin: "Aunimeda Technischer Support",
          admin: "Administrator",
          noServicesSelected: "Keine Dienste ausgewählt",
          none: "Keine",
          create: "Erstellen",  
    
          projectStatus: {
            discussion: "Diskussion",
            contacted: "Kontaktiert",
            unreachable: "Nicht erreichbar",
            negotiating: "In Verhandlung",
            meeting: "Meeting",
            development: "Entwicklung",
            completed: "Abgeschlossen"
          },
    
          assignedspecialists: "Zugewiesene Spezialisten",
          visibletoallspecialists: "Sichtbar für alle Spezialisten",
          allspecialists: "Alle Spezialisten",
          createclient: "Kunde erstellen",
          client: "Kunde",
          selectservices: "Dienstleistungen auswählen",
          selectspecialist: "Spezialist auswählen",
          selectdateandtime: "Datum und Uhrzeit auswählen",
          confirmbooking: "Buchung bestätigen",
          selectall: "Alle auswählen",
          editservicesfor: "Dienstleistungen bearbeiten für",
          clearall: "Alle löschen",
          duration: "Dauer",
          price: "Preis",
          selected: "Ausgewählt",
          saveservices: "Dienstleistungen speichern",
          selectservicesthisspecialistcanprovidetoclients: "Dienstleistungen auswählen, die dieser Spezialist Kunden anbieten kann",
          confirmClearAllDeleted: "Sind Sie sicher, dass Sie alle Kunden aus dem Papierkorb endgültig löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    
          setSchedule: "Terminplan festlegen",
          setWorkingHours: "Arbeitszeiten festlegen",
          setworkinghoursfor: "Arbeitszeiten festlegen für",
          startTime: "Startzeit",
          endTime: "Endzeit",
          monday: "Montag",
          tuesday: "Dienstag",
          wednesday: "Mittwoch",
          thursday: "Donnerstag",
          friday: "Freitag",
          saturday: "Samstag",
          sunday: "Sonntag"
        },
        auth: {
          login: {
            title: "Anmelden",
            invalidCredentials: "Ungültige E-Mail oder Passwort",
            forgotPassword: "Passwort vergessen?",
            noAccount: "Noch kein Konto?",
            registerHere: "Hier registrieren"
          },
          register: {
            title: "Registrierung",
            success: "Registrierung erfolgreich",
            haveAccount: "Bereits ein Konto?",
            loginHere: "Hier anmelden",
            asClient: "Als Kunde registrieren",
            asSpecialist: "Als Spezialist registrieren",
            waitingApproval: "Registrierung erfolgreich. Warten auf Genehmigung durch Administrator."
          }
        },
        booking: {
          steps: {
            selectService: "Dienstleistung auswählen",
            selectSpecialist: "Spezialist auswählen",
            selectDateTime: "Datum und Uhrzeit auswählen",
            confirmation: "Bestätigung"
          },
          services: {
            title: "Dienstleistung auswählen",
            duration: "Dauer",
            price: "Preis"
          },
          specialists: {
            title: "Spezialist auswählen",
            availability: "Verfügbare Zeiten",
            noAvailability: "Keine Verfügbarkeiten"
          },
          datetime: {
            title: "Datum und Uhrzeit auswählen",
            availableSlots: "Verfügbare Termine",
            noSlots: "Keine verfügbaren Termine für dieses Datum"
          },
          confirmation: {
            title: "Buchung bestätigen",
            details: "Buchungsdetails",
            service: "Dienstleistung",
            specialist: "Spezialist",
            dateTime: "Datum und Uhrzeit",
            clientInfo: "Ihre Informationen",
            confirming: "Wird bestätigt...",
            confirmBooking: "Buchung bestätigen",
            error: "Fehler beim Erstellen der Buchung"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Termine",
            clients: "Kunden",
            services: "Dienstleistungen",
            specialists: "Spezialisten",
            settings: "Einstellungen",
            products: "Produkte"

          },
          appointments: {
            title: "Termine",
            upcoming: "Bevorstehend",
            past: "Vergangen",
            datetime: "Datum und Uhrzeit",
            client: "Kunde",
            service: "Dienstleistung",
            specialist: "Spezialist",
            duration: "Dauer",
            deleteConfirm: "Sind Sie sicher, dass Sie diesen Termin löschen möchten?",
            status: {
              pending: "Ausstehend",
              confirmed: "Bestätigt",
              cancelled: "Storniert",
              completed: "Abgeschlossen"
            },
            actions: {
              confirm: "Bestätigen",
              cancel: "Stornieren",
              reschedule: "Neu planen"
            }
          },
          clients: {
            title: "Kunden",
            addNew: "Neuen Kunden hinzufügen",
            management: "Kundenverwaltung",
            details: "Kundendetails",
            history: "Kundenverlauf",
            status: {
              new: "Neu",
              regular: "Regulär",
              former: "Ehemalig",
              deleted: "Gelöscht"
            },
            tabs: {
              new: "Neu",
              regular: "Regulär",
              former: "Ehemalig",
              deleted: "Gelöscht"
            }
          },
          services: {
            title: "Dienstleistungen",
            addNew: "Neue Dienstleistung hinzufügen",
            editService: "Dienstleistung bearbeiten",
            fields: {
              name: "Name der Dienstleistung",
              duration: "Dauer",
              price: "Preis"
            }
          },
          specialists: {
            title: "Spezialisten",
            addNew: "Neuen Spezialisten hinzufügen",
            management: "Spezialistenverwaltung",
            schedule: "Arbeitszeiten",
            services: "Verfügbare Dienstleistungen",
            status: {
              pending: "Genehmigung ausstehend",
              approved: "Genehmigt",
              rejected: "Abgelehnt"
            }
          },
          settings: {
            title: "Einstellungen",
            profile: "Profileinstellungen",
            account: "Kontoeinstellungen",
            password: "Passwort ändern",
            fields: {
              currentPassword: "Aktuelles Passwort",
              newPassword: "Neues Passwort",
              confirmPassword: "Passwort bestätigen"
            }
          }
        },

        settings: {
          tabAndColumnVisibility: "Sichtbarkeit von Tabs und Spalten",
          tabOrder: "Tab-Reihenfolge",
          hiddenTabs: "Versteckte Tabs",
          clientColumns: "Kundenspalten",
          crmSettings: "CRM-Einstellungen",
          promoText: "Werbetexte",
          headerTitle: "Titel",
          headerSubtitle: "Beschreibung",
          defaultLanguage: "Standardsprache",
          currency: "Währung",
          currencyPosition: "Währungsposition",
          currencyRight: "Rechts",
          currencyLeft: "Links",
          hideAppointments: "Registerkarte 'Termine' ausblenden",
          hideSpecialists: "Registerkarte 'Spezialisten' ausblenden",
          hideServices: "Registerkarte 'Dienste' ausblenden",
          hideClients: "Registerkarte 'Kunden' ausblenden",
          hideProducts: "Registerkarte 'Produkte' ausblenden",
          tabsSaved: "Registerkarteneinstellungen gespeichert",
          errorFetching: "Fehler beim Laden der Einstellungen",
          errorSaving: "Fehler beim Speichern der Einstellungen", 
          tabsDescription: "Konfigurieren Sie das Erscheinungsbild und das Verhalten der Registerkarten",
          tabVisibility: "Sichtbarkeit der Registerkarten umschalten",
          configureTabs: "Einstellungen der Registerkarten anpassen"
 
        },
         products: {
          import: {
            steps: {
              upload: "Hochladen",
              map: "Zuordnen",
              import: "Importieren"
            },
            selectfile: "Datei auswählen",
            guide: "Um Produkte zu importieren: 1) Erstellen Sie eine Excel-Datei mit Spalten für die Produktdaten 2) Die erste Zeile muss die Spaltennamen enthalten 3) Jede Zeile stellt ein Produkt dar 4) Pflichtfeld: Produktname 5) Die Standardspaltenzuordnung ist auf A1, B1 usw. eingestellt.",
            guideTitle: "Importanweisungen"
          },
          defaultcategory: "Standard",
          title: "Produktverwaltung",
          addNew: "Neues Produkt hinzufügen",
          edit: "Produkt bearbeiten",
          create: "Produkt erstellen",
          name: "Name",
          category: "Kategorie",
          price: "Preis",
          costPrice: "Kosten",
          warehouseName: "LagerName",
          warehouseAddress: "Lageradresse",
          articleNumber: "Produktcode",
          unit: "Einheit",
          weight: "Gewicht",
          length: "Länge",
          width: "Breite",
          height: "Höhe",
          stock: "Lagerbestand",
          responsibleEmployee: "Verantwortlicher Mitarbeiter",
          dimensions: "Abmessungen",
          warehouse: "Lager",
          deleteTitle: "Produkt löschen",
          deleteConfirm: "Sind Sie sicher, dass Sie das Produkt {{name}} löschen möchten?",
          units: {
            piece: "Stück",
            kg: "Kilogramm",
            package: "Paket"
          }
         }  
      }
    },


    fr: {
      translation: {
        common: {
  
          nazvanie: "Nom",
          maxprice: "Prix maximum",
          category: "Catégorie",
          title: "Titre",
          addnew: "Ajouter nouveau",
          projectType: "Type de projet",
          history: "Historique",
          assignSpecialists: "Attribuer des spécialistes",
          uploadSpecialistPhoto: "Télécharger la photo du spécialiste",
          selectimage: "Sélectionner une image",
          upload: "Télécharger",
          anySpecialist: "N'importe quel spécialiste",
          allServices: "Tous les services",
                
          minutes: "minutes",
          add: "Ajouter",
          edit: "Modifier",
          delete: "Supprimer",
          save: "Enregistrer",
          cancel: "Annuler",
          confirm: "Confirmer",
          back: "Retour",
          next: "Suivant",
          min: "min",
          login: "Connexion",
          register: "S'inscrire",
          logout: "Déconnexion",
          email: "Email",
          password: "Mot de passe",
          phone: "Téléphone",
          name: "Nom",
          actions: "Actions",
          optional: "optionnel",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Statut",
          savechanges: "Sauvegarder les modifications",
          changespecialist: "Changer de spécialiste",
          past: "Passé",
          ongoing: "En cours",
          upcoming: "À venir",
          future: "Futur",
          specialist: "Spécialiste",
          errorApproving: "Erreur d'approbation",
          errorRejecting: "Erreur de rejet",
          errorSaving: "Erreur de sauvegarde",
          specialists: "Spécialistes",
          schedule: "Agenda",
          services: "Services",
          service: "Service",
          pendingApprovals: "Approbations en attente",
          activeSpecialists: "Spécialistes actifs",
          approve: "Approuver",
          reject: "Rejeter",
          namecompany: "Nom/Entreprise",
          firstcontact: "Premier contact",
          contacts: "Contacts",
          projectstatus: "Statut du projet",
          createdby: "Créé par",
          assignedto: "Assigné à",
          clearalldeleted: "Effacer tous les éléments supprimés",
          dashboard: "Tableau de bord",
          editservices: "Modifier les services",
          setschedule: "Définir l'agenda",
          website: "Site web",
          new: "Nouveau",
          regular: "Régulier",
          former: "Ancien",
          deleted: "Supprimé",
          clientstatus: "Statut du client",
          address: "Adresse",
          assignspecialiststo: "Assigner des spécialistes à",
          discussion: "Discussion",
          firstcontactdate: "Date du premier contact",
          projecttype: "Type de projet",
          projectdescription: "Description du projet",
          technicaldetails: "Détails techniques",
          budget: "Budget",
          contacted: "Contacté",
          unreachable: "Injoignable",
          negotiating: "En négociation",
          meeting: "Réunion",
          development: "Développement",
          completed: "Terminé",
          telegramoptional: "Telegram (optionnel)",
          instagramoptional: "Instagram (optionnel)",
          alreadyhaveanaccount: "Vous avez déjà un compte ? Connexion",
          myappointments: "Mes rendez-vous",
          myclients: "Mes clients",
          settings: "Paramètres",
          profilesettings: "Paramètres du profil",
          saveprofilechanges: "Sauvegarder les modifications du profil",
          changepassword: "Changer le mot de passe",
          currentpassword: "Mot de passe actuel",
          newpassword: "Nouveau mot de passe",
          confirmnewpassword: "Confirmer le nouveau mot de passe",
          deleteaccount: "Supprimer le compte",
          accountsettings: "Paramètres du compte",
          saveschedule: "Enregistrer l'agenda",
          starttime: "Heure de début",
          endtime: "Heure de fin",
          addnewclient: "Ajouter un nouveau client",
          editclient: "Modifier le client",
          newclient: "Nouveau client",

          export: "Exporter",
          import: "Importer",
          saving: "Enregistrement en cours...",
          role: "Rôle",
          editRole: "Modifier le rôle",
          changeRole: "Changer de rôle",
          specialistRoleDescription: "Accès aux tâches spéciales et aux données du projet",
          adminRoleDescription: "Accès complet aux paramètres et à la gestion des utilisateurs",
          superadmin: "Support technique Aunimeda",
          admin: "Administrateur",
          noServicesSelected: "Aucun service sélectionné",
          none: "Aucun",
          create: "Créer",  
    
          projectStatus: {
            discussion: "Discussion",
            contacted: "Contacté",
            unreachable: "Injoignable",
            negotiating: "En négociation",
            meeting: "Réunion",
            development: "Développement",
            completed: "Terminé"
          },
    
          assignedspecialists: "Spécialistes assignés",
          visibletoallspecialists: "Visible par tous les spécialistes",
          allspecialists: "Tous les spécialistes",
          createclient: "Créer un client",
          client: "Client",
          selectservices: "Sélectionner des services",
          selectspecialist: "Sélectionner un spécialiste",
          selectdateandtime: "Sélectionner date et heure",
          confirmbooking: "Confirmer la réservation",
          selectall: "Tout sélectionner",
          editservicesfor: "Modifier les services pour",
          clearall: "Tout effacer",
          duration: "Durée",
          price: "Prix",
          selected: "Sélectionné",
          saveservices: "Enregistrer les services",
          selectservicesthisspecialistcanprovidetoclients: "Sélectionner les services que ce spécialiste peut fournir aux clients",
          confirmClearAllDeleted: "Êtes-vous sûr de vouloir supprimer tous les clients du dossier supprimé ? Cette action est irréversible.",
    
          setSchedule: "Définir l'agenda",
          setWorkingHours: "Définir les heures de travail",
          setworkinghoursfor: "Définir les heures de travail pour",
          startTime: "Heure de début",
          endTime: "Heure de fin",
          monday: "Lundi",
          tuesday: "Mardi",
          wednesday: "Mercredi",
          thursday: "Jeudi",
          friday: "Vendredi",
          saturday: "Samedi",
          sunday: "Dimanche"
        },
        auth: {
          login: {
            title: "Connexion",
            invalidCredentials: "Email ou mot de passe invalide",
            forgotPassword: "Mot de passe oublié ?",
            noAccount: "Pas encore de compte ?",
            registerHere: "S'inscrire ici"
          },
          register: {
            title: "Inscription",
            success: "Inscription réussie",
            haveAccount: "Vous avez déjà un compte ?",
            loginHere: "Se connecter ici",
            asClient: "S'inscrire en tant que client",
            asSpecialist: "S'inscrire en tant que spécialiste",
            waitingApproval: "Inscription réussie. En attente d'approbation par l'administrateur."
          }
        },
        booking: {
          steps: {
            selectService: "Sélectionner un service",
            selectSpecialist: "Sélectionner un spécialiste",
            selectDateTime: "Sélectionner date et heure",
            confirmation: "Confirmation"
          },
          services: {
            title: "Sélectionner un service",
            duration: "Durée",
            price: "Prix"
          },
          specialists: {
            title: "Sélectionner un spécialiste",
            availability: "Disponibilités",
            noAvailability: "Pas de disponibilités"
          },
          datetime: {
            title: "Sélectionner date et heure",
            availableSlots: "Créneaux disponibles",
            noSlots: "Pas de créneaux disponibles pour cette date"
          },
          confirmation: {
            title: "Confirmer la réservation",
            details: "Détails de la réservation",
            service: "Service",
            specialist: "Spécialiste",
            dateTime: "Date et heure",
            clientInfo: "Vos informations",
            confirming: "Confirmation en cours...",
            confirmBooking: "Confirmer la réservation",
            error: "Erreur lors de la création de la réservation"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Rendez-vous",
            clients: "Clients",
            services: "Services",
            specialists: "Spécialistes",
            settings: "Paramètres",
            products: "Produits"

          },
          appointments: {
            title: "Rendez-vous",
            upcoming: "À venir",
            past: "Passés",
            datetime: "Date et heure",
            client: "Client",
            service: "Service",
            specialist: "Spécialiste",
            duration: "Durée",
            deleteConfirm: "Êtes-vous sûr de vouloir supprimer ce rendez-vous ?",
            status: {
              pending: "En attente",
              confirmed: "Confirmé",
              cancelled: "Annulé",
              completed: "Terminé"
            },
            actions: {
              confirm: "Confirmer",
              cancel: "Annuler",
              reschedule: "Reprogrammer"
            }
          },
          clients: {
            title: "Clients",
            addNew: "Ajouter un nouveau client",
            management: "Gestion des clients",
            details: "Détails du client",
            history: "Historique du client",
            status: {
              new: "Nouveau",
              regular: "Régulier",
              former: "Ancien",
              deleted: "Supprimé"
            },
            tabs: {
              new: "Nouveaux",
              regular: "Réguliers",
              former: "Anciens",
              deleted: "Supprimés"
            }
          },
          services: {
            title: "Services",
            addNew: "Ajouter un nouveau service",
            editService: "Modifier le service",
            fields: {
              name: "Nom du service",
              duration: "Durée",
              price: "Prix"
            }
          },
          specialists: {
            title: "Spécialistes",
            addNew: "Ajouter un nouveau spécialiste",
            management: "Gestion des spécialistes",
            schedule: "Horaires de travail",
            services: "Services disponibles",
            status: {
              pending: "En attente d'approbation",
              approved: "Approuvé",
              rejected: "Rejeté"
            }
          },
          settings: {
            title: "Paramètres",
            profile: "Paramètres du profil",
            account: "Paramètres du compte",
            password: "Changer le mot de passe",
            fields: {
              currentPassword: "Mot de passe actuel",
              newPassword: "Nouveau mot de passe",
              confirmPassword: "Confirmer le mot de passe"
            }
          }
        },

        settings: {
          tabAndColumnVisibility: "Visibilité des onglets et des colonnes",
          tabOrder: "Ordre des onglets",
          hiddenTabs: "Onglets cachés",
          clientColumns: "Colonnes client",  
          crmSettings: "Paramètres CRM",
          promoText: "Texte promotionnel",
          headerTitle: "Titre",
          headerSubtitle: "Description",
          defaultLanguage: "Langue par défaut",
          currency: "Devise",
          currencyPosition: "Position de la devise",
          currencyRight: "Droite",
          currencyLeft: "Gauche",
          hideAppointments: "Masquer l'onglet 'Rendez-vous'",
          hideSpecialists: "Masquer l'onglet 'Spécialistes'",
          hideServices: "Masquer l'onglet 'Services'",
          hideClients: "Masquer l'onglet 'Clients'",
          hideProducts: "Masquer l'onglet 'Produits'",
          tabsSaved: "Paramètres d'onglets enregistrés",
          errorFetching: "Erreur de chargement des paramètres",
          errorSaving: "Erreur d'enregistrement des paramètres",  
          tabsDescription: "Configurer l'apparence et le comportement des onglets",
          tabVisibility: "Basculer la visibilité des onglets",
          configureTabs: "Ajuster les paramètres des onglets"

        },
         products: {
          import: {
            steps: {
              upload: "Télécharger",
              map: "Cartographier",
              import: "Importer"
            },
            selectfile: "Sélectionner un fichier",
            guide: "Pour importer des produits : 1) Créez un fichier Excel avec des colonnes pour les données des produits 2) La première ligne doit contenir les noms des colonnes 3) Chaque ligne représente un produit 4) Champ obligatoire : Nom du produit 5) L'attribution par défaut des colonnes est configurée sur A1, B1, etc.",
            guideTitle: "Instructions d'importation",
          },
          defaultcategory: "Défaut",
          title: "Gestion des produits",
          addNew: "Ajouter un nouveau produit",
          edit: "Modifier le produit",
          create: "Créer un produit",
          name: "Nom",
          category: "Catégorie",
          price: "Prix",
          costPrice: "Coût",
          warehouseName: "Nom de l'entrepôt",
          warehouseAddress: "Adresse de l'entrepôt",
          articleNumber: "Code produit",
          unit: "Unité",
          weight: "Poids",
          length: "Longueur",
          width: "Largeur",
          height: "Hauteur",
          stock: "Stock",
          responsibleEmployee: "Employé responsable",
          dimensions: "Dimensions",
          warehouse: "Entrepôt",
          deleteTitle: "Supprimer le produit",
          deleteConfirm: "Êtes-vous sûr de vouloir supprimer le produit {{name}} ?",
          units: {
            piece: "Pièce",
            kg: "Kilogramme",
            package: "Paquet"
          }
         }
      }
    },



    ja: {
      translation: {
        common: {
          nazvanie: "名前",
          maxprice: "最高価格",
          category: "カテゴリー",
          title: "タイトル",
          addnew: "新規追加",
          projectType: "プロジェクトタイプ",
          history: "履歴",
          assignSpecialists: "スペシャリストを割り当てる",
          uploadSpecialistPhoto: "スペシャリストの写真をアップロード",
          selectimage: "画像を選択",
          upload: "アップロード",
          anySpecialist: "任意のスペシャリスト",
          allServices: "すべてのサービス",    
          minutes: "分",
          add: "追加",
          edit: "編集",
          delete: "削除",
          save: "保存",
          cancel: "キャンセル",
          confirm: "確認",
          back: "戻る",
          next: "次へ",
          min: "分",
          login: "ログイン",
          register: "登録",
          logout: "ログアウト",
          email: "メールアドレス",
          password: "パスワード",
          phone: "電話番号",
          name: "名前",
          actions: "操作",
          optional: "任意",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "ステータス",
          savechanges: "変更を保存",
          changespecialist: "専門家を変更",
          past: "過去",
          ongoing: "進行中",
          upcoming: "予定",
          future: "未来",
          specialist: "専門家",
          errorApproving: "承認エラー",
          errorRejecting: "却下エラー",
          errorSaving: "保存エラー",
          specialists: "専門家一覧",
          schedule: "スケジュール",
          services: "サービス一覧",
          service: "サービス",
          pendingApprovals: "承認待ち",
          activeSpecialists: "アクティブな専門家",
          approve: "承認",
          reject: "却下",
          namecompany: "名前/会社名",
          firstcontact: "初回連絡",
          contacts: "連絡先",
          projectstatus: "プロジェクトステータス",
          createdby: "作成者",
          assignedto: "担当者",
          clearalldeleted: "削除済みをすべて消去",
          dashboard: "ダッシュボード",
          editservices: "サービスを編集",
          setschedule: "スケジュールを設定",
          website: "ウェブサイト",
          new: "新規",
          regular: "通常",
          former: "以前の",
          deleted: "削除済み",
          clientstatus: "クライアントステータス",
          address: "住所",
          assignspecialiststo: "専門家を割り当て",
          discussion: "ディスカッション",
          firstcontactdate: "初回連絡日",
          projecttype: "プロジェクトタイプ",
          projectdescription: "プロジェクト説明",
          technicaldetails: "技術詳細",
          budget: "予算",
          contacted: "連絡済み",
          unreachable: "連絡不可",
          negotiating: "交渉中",
          meeting: "ミーティング",
          development: "開発中",
          completed: "完了",
          telegramoptional: "Telegram（任意）",
          instagramoptional: "Instagram（任意）",
          alreadyhaveanaccount: "アカウントをお持ちの方はログイン",
          myappointments: "予約一覧",
          myclients: "クライアント一覧",
          settings: "設定",
          profilesettings: "プロフィール設定",
          saveprofilechanges: "プロフィールの変更を保存",
          changepassword: "パスワード変更",
          currentpassword: "現在のパスワード",
          newpassword: "新しいパスワード",
          confirmnewpassword: "新しいパスワード（確認）",
          deleteaccount: "アカウント削除",
          accountsettings: "アカウント設定",
          saveschedule: "スケジュールを保存",
          starttime: "開始時間",
          endtime: "終了時間",
          addnewclient: "新規クライアントを追加",
          editclient: "クライアントを編集",
          newclient: "新規クライアント",

          export: "エクスポート",
          import: "インポート",
          saving: "保存中...",
          role: "ロール",
          editRole: "ロールを編集",
          changeRole: "ロールを変更",
          specialistRoleDescription: "特別なタスクとプロジェクトデータへのアクセス",
          adminRoleDescription: "設定とユーザー管理への完全なアクセス",
          superadmin: "Aunimedaテクニカルサポート",
          admin: "管理者",
          noServicesSelected: "サービスが選択されていません",
          none: "なし",
          create: "作成",  
    
          projectStatus: {
            discussion: "ディスカッション",
            contacted: "連絡済み",
            unreachable: "連絡不可",
            negotiating: "交渉中",
            meeting: "ミーティング",
            development: "開発中",
            completed: "完了"
          },
    
          assignedspecialists: "割り当てられた専門家",
          visibletoallspecialists: "全専門家に表示",
          allspecialists: "全専門家",
          createclient: "クライアントを作成",
          client: "クライアント",
          selectservices: "サービスを選択",
          selectspecialist: "専門家を選択",
          selectdateandtime: "日時を選択",
          confirmbooking: "予約を確認",
          selectall: "すべて選択",
          editservicesfor: "サービスを編集",
          clearall: "すべてクリア",
          duration: "所要時間",
          price: "料金",
          selected: "選択済み",
          saveservices: "サービスを保存",
          selectservicesthisspecialistcanprovidetoclients: "この専門家が提供できるサービスを選択",
          confirmClearAllDeleted: "削除済みフォルダのクライアントをすべて削除しますか？この操作は取り消せません。",
    
          setSchedule: "スケジュール設定",
          setWorkingHours: "勤務時間を設定",
          setworkinghoursfor: "勤務時間を設定",
          startTime: "開始時間",
          endTime: "終了時間",
          monday: "月曜日",
          tuesday: "火曜日",
          wednesday: "水曜日",
          thursday: "木曜日",
          friday: "金曜日",
          saturday: "土曜日",
          sunday: "日曜日"
        },
        auth: {
          login: {
            title: "ログイン",
            invalidCredentials: "メールアドレスまたはパスワードが正しくありません",
            forgotPassword: "パスワードをお忘れですか？",
            noAccount: "アカウントをお持ちでない方は",
            registerHere: "こちらで登録"
          },
          register: {
            title: "登録",
            success: "登録が完了しました",
            haveAccount: "すでにアカウントをお持ちの方は",
            loginHere: "こちらでログイン",
            asClient: "クライアントとして登録",
            asSpecialist: "専門家として登録",
            waitingApproval: "登録が完了しました。管理者の承認をお待ちください。"
          }
        },
        booking: {
          steps: {
            selectService: "サービスを選択",
            selectSpecialist: "専門家を選択",
            selectDateTime: "日時を選択",
            confirmation: "確認"
          },
          services: {
            title: "サービスを選択",
            duration: "所要時間",
            price: "料金"
          },
          specialists: {
            title: "専門家を選択",
            availability: "予約可能時間",
            noAvailability: "予約可能な時間がありません"
          },
          datetime: {
            title: "日時を選択",
            availableSlots: "予約可能な時間",
            noSlots: "この日は予約可能な時間がありません"
          },
          confirmation: {
            title: "予約の確認",
            details: "予約詳細",
            service: "サービス",
            specialist: "専門家",
            dateTime: "日時",
            clientInfo: "お客様情報",
            confirming: "確認中...",
            confirmBooking: "予約を確定",
            error: "予約の作成中にエラーが発生しました"
          }
        },
        dashboard: {
          tabs: {
            appointments: "予約",
            clients: "クライアント",
            services: "サービス",
            specialists: "専門家",
            settings: "設定",
            products: "製品"

          },
          appointments: {
            title: "予約",
            upcoming: "予定",
            past: "過去",
            datetime: "日時",
            client: "クライアント",
            service: "サービス",
            specialist: "専門家",
            duration: "所要時間",
            deleteConfirm: "この予約を削除してよろしいですか？",
            status: {
              pending: "保留中",
              confirmed: "確定済み",
              cancelled: "キャンセル済み",
              completed: "完了"
            },
            actions: {
              confirm: "確定",
              cancel: "キャンセル",
              reschedule: "日程変更"
            }
          },
          clients: {
            title: "クライアント",
            addNew: "新規クライアントを追加",
            management: "クライアント管理",
            details: "クライアント詳細",
            history: "クライアント履歴",
            status: {
              new: "新規",
              regular: "通常",
              former: "以前の",
              deleted: "削除済み"
            },
            tabs: {
              new: "新規",
              regular: "通常",
              former: "以前の",
              deleted: "削除済み"
            }
          },
          services: {
            title: "サービス",
            addNew: "新規サービスを追加",
            editService: "サービスを編集",
            fields: {
              name: "サービス名",
              duration: "所要時間",
              price: "料金"
            }
          },
          specialists: {
            title: "専門家",
            addNew: "新規専門家を追加",
            management: "専門家管理",
            schedule: "勤務時間",
            services: "利用可能なサービス",
            status: {
              pending: "承認待ち",
              approved: "承認済み",
              rejected: "却下"
            }
          },
          settings: {
            title: "設定",
            profile: "プロフィール設定",
            account: "アカウント設定",
            password: "パスワード変更",
            fields: {
              currentPassword: "現在のパスワード",
              newPassword: "新しいパスワード",
              confirmPassword: "パスワード確認"
            }
          }
        },
        settings: {
          tabAndColumnVisibility: "タブと列の可視性",
          tabOrder: "タブの順序",
          hiddenTabs: "隠しタブ",
          clientColumns: "クライアント列",  
          crmSettings: "CRM設定",
          promoText: "プロモーションテキスト",
          headerTitle: "タイトル",
          headerSubtitle: "説明",
          defaultLanguage: "デフォルト言語",
          currency: "通貨",
          currencyPosition: "通貨位置",
          currencyRight: "右",
          currencyLeft: "左",
          hideAppointments: "「予約」タブを非表示",
          hideSpecialists: "「専門家」タブを非表示",
          hideServices: "「サービス」タブを非表示",
          hideClients: "「クライアント」タブを非表示",
          hideProducts: "「製品」タブを非表示",
          tabsSaved: "タブ設定が保存されました",
          errorFetching: "設定の読み込みエラー",
          errorSaving: "設定の保存エラー",
          tabsDescription: "タブの外観と動作を設定します",
          tabVisibility: "タブの表示/非表示を切り替えます",
          configureTabs: "タブの設定を調整します"
  
         },
         products: {
          import: {
            steps: {
              upload: "アップロード",
              map: "マップ",
              import: "インポート"
            },
            selectfile: "ファイルを選択",
            guide: "商品をインポートするには：1) 商品データの列を含むExcelファイルを作成 2) 最初の行には列の名前を含める 3) 各行は1つの商品を表す 4) 必須フィールド：商品名 5) デフォルトの列割り当てはA1、B1などに設定されています。",
            guideTitle: "インポート手順",
          },      
          defaultcategory: "デフォルト",
          title: "製品管理",
          addNew: "新製品を追加",
          edit: "製品を編集",
          create: "製品を作成",
          name: "名前",
          category: "カテゴリ",
          price: "価格",
          costPrice: "原価",
          warehouseName: "倉庫名",
          warehouseAddress: "倉庫住所",
          articleNumber: "製品コード",
          unit: "単位",
          weight: "重量",
          length: "長さ",
          width: "幅",
          height: "高さ",
          stock: "在庫",
          responsibleEmployee: "責任者",
          dimensions: "寸法",
          warehouse: "倉庫",
          deleteTitle: "製品を削除",
          deleteConfirm: "製品 {{name}} を削除してもよろしいですか？",
          units: {
            piece: "個",
            kg: "キログラム",
            package: "パッケージ"
          }
         }  
      }
    },


    vi: {
      translation: {
        common: {
          nazvanie: "Tên",
          maxprice: "Giá tối đa",
          category: "Danh mục",
          title: "Tiêu đề",
          addnew: "Thêm mới",
          projectType: "Loại dự án",
          history: "Lịch sử",
          assignSpecialists: "Chỉ định chuyên gia",
          uploadSpecialistPhoto: "Tải ảnh chuyên gia lên",
          selectimage: "Chọn hình ảnh",
          upload: "Tải lên",
          anySpecialist: "Bất kỳ chuyên gia nào",
          allServices: "Tất cả các dịch vụ",      
          minutes: "phút",
          add: "Thêm",
          edit: "Sửa",
          delete: "Xóa",
          save: "Lưu",
          cancel: "Hủy",
          confirm: "Xác nhận",
          back: "Quay lại",
          next: "Tiếp theo",
          min: "phút",
          login: "Đăng nhập",
          register: "Đăng ký",
          logout: "Đăng xuất",
          email: "Email",
          password: "Mật khẩu",
          phone: "Điện thoại",
          name: "Tên",
          actions: "Hành động",
          optional: "tùy chọn",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Trạng thái",
          savechanges: "Lưu thay đổi",
          changespecialist: "Đổi chuyên gia",
          past: "Đã qua",
          ongoing: "Đang diễn ra",
          upcoming: "Sắp tới",
          future: "Tương lai",
          specialist: "Chuyên gia",
          errorApproving: "Lỗi phê duyệt",
          errorRejecting: "Lỗi từ chối",
          errorSaving: "Lỗi lưu",
          specialists: "Chuyên gia",
          schedule: "Lịch",
          services: "Dịch vụ",
          service: "Dịch vụ",
          pendingApprovals: "Chờ phê duyệt",
          activeSpecialists: "Chuyên gia đang hoạt động",
          approve: "Phê duyệt",
          reject: "Từ chối",
          namecompany: "Tên/Công ty",
          firstcontact: "Liên hệ đầu tiên",
          contacts: "Liên hệ",
          projectstatus: "Trạng thái dự án",
          createdby: "Tạo bởi",
          assignedto: "Phân công cho",
          clearalldeleted: "Xóa tất cả đã xóa",
          dashboard: "Bảng điều khiển",
          editservices: "Sửa dịch vụ",
          setschedule: "Đặt lịch",
          website: "Trang web",
          new: "Mới",
          regular: "Thường xuyên",
          former: "Cũ",
          deleted: "Đã xóa",
          clientstatus: "Trạng thái khách hàng",
          address: "Địa chỉ",
          assignspecialiststo: "Phân công chuyên gia cho",
          discussion: "Thảo luận",
          firstcontactdate: "Ngày liên hệ đầu tiên",
          projecttype: "Loại dự án",
          projectdescription: "Mô tả dự án",
          technicaldetails: "Chi tiết kỹ thuật",
          budget: "Ngân sách",
          contacted: "Đã liên hệ",
          unreachable: "Không liên lạc được",
          negotiating: "Đang đàm phán",
          meeting: "Họp",
          development: "Phát triển",
          completed: "Hoàn thành",
          telegramoptional: "Telegram (tùy chọn)",
          instagramoptional: "Instagram (tùy chọn)",
          alreadyhaveanaccount: "Đã có tài khoản? Đăng nhập",
          myappointments: "Cuộc hẹn của tôi",
          myclients: "Khách hàng của tôi",
          settings: "Cài đặt",
          profilesettings: "Cài đặt hồ sơ",
          saveprofilechanges: "Lưu thay đổi hồ sơ",
          changepassword: "Đổi mật khẩu",
          currentpassword: "Mật khẩu hiện tại",
          newpassword: "Mật khẩu mới",
          confirmnewpassword: "Xác nhận mật khẩu mới",
          deleteaccount: "Xóa tài khoản",
          accountsettings: "Cài đặt tài khoản",
          saveschedule: "Lưu lịch",
          starttime: "Giờ bắt đầu",
          endtime: "Giờ kết thúc",
          addnewclient: "Thêm khách hàng mới",
          editclient: "Sửa khách hàng",
          newclient: "Khách hàng mới",
          export: "Xuất",
          import: "Nhập",
          saving: "Đang lưu...",
          role: "Vai trò",
          editRole: "Chỉnh sửa vai trò",
          changeRole: "Thay đổi vai trò",
          specialistRoleDescription: "Truy cập các nhiệm vụ đặc biệt và dữ liệu dự án",
          adminRoleDescription: "Truy cập đầy đủ vào cài đặt và quản lý người dùng",
          superadmin: "Hỗ trợ kỹ thuật Aunimeda",
          admin: "Quản trị viên",
          noServicesSelected: "Chưa chọn dịch vụ",
          none: "Không có",
          create: "Tạo",  
    
          projectStatus: {
            discussion: "Thảo luận",
            contacted: "Đã liên hệ",
            unreachable: "Không liên lạc được",
            negotiating: "Đang đàm phán",
            meeting: "Họp",
            development: "Phát triển",
            completed: "Hoàn thành"
          },
    
          assignedspecialists: "Chuyên gia được phân công",
          visibletoallspecialists: "Hiển thị cho tất cả chuyên gia",
          allspecialists: "Tất cả chuyên gia",
          createclient: "Tạo khách hàng",
          client: "Khách hàng",
          selectservices: "Chọn dịch vụ",
          selectspecialist: "Chọn chuyên gia",
          selectdateandtime: "Chọn ngày và giờ",
          confirmbooking: "Xác nhận đặt lịch",
          selectall: "Chọn tất cả",
          editservicesfor: "Sửa dịch vụ cho",
          clearall: "Xóa tất cả",
          duration: "Thời lượng",
          price: "Giá",
          selected: "Đã chọn",
          saveservices: "Lưu dịch vụ",
          selectservicesthisspecialistcanprovidetoclients: "Chọn dịch vụ mà chuyên gia này có thể cung cấp cho khách hàng",
          confirmClearAllDeleted: "Bạn có chắc chắn muốn xóa tất cả khách hàng khỏi thư mục đã xóa? Hành động này không thể hoàn tác.",
    
          setSchedule: "Đặt lịch",
          setWorkingHours: "Đặt giờ làm việc",
          setworkinghoursfor: "Đặt giờ làm việc cho",
          startTime: "Giờ bắt đầu",
          endTime: "Giờ kết thúc",
          monday: "Thứ Hai",
          tuesday: "Thứ Ba",
          wednesday: "Thứ Tư",
          thursday: "Thứ Năm",
          friday: "Thứ Sáu",
          saturday: "Thứ Bảy",
          sunday: "Chủ Nhật"
        },
        auth: {
          login: {
            title: "Đăng nhập",
            invalidCredentials: "Email hoặc mật khẩu không đúng",
            forgotPassword: "Quên mật khẩu?",
            noAccount: "Chưa có tài khoản?",
            registerHere: "Đăng ký tại đây"
          },
          register: {
            title: "Đăng ký",
            success: "Đăng ký thành công",
            haveAccount: "Đã có tài khoản?",
            loginHere: "Đăng nhập tại đây",
            asClient: "Đăng ký như khách hàng",
            asSpecialist: "Đăng ký như chuyên gia",
            waitingApproval: "Đăng ký thành công. Đang chờ phê duyệt từ quản trị viên."
          }
        },
        booking: {
          steps: {
            selectService: "Chọn dịch vụ",
            selectSpecialist: "Chọn chuyên gia",
            selectDateTime: "Chọn ngày và giờ",
            confirmation: "Xác nhận"
          },
          services: {
            title: "Chọn dịch vụ",
            duration: "Thời lượng",
            price: "Giá"
          },
          specialists: {
            title: "Chọn chuyên gia",
            availability: "Thời gian rảnh",
            noAvailability: "Không có thời gian rảnh"
          },
          datetime: {
            title: "Chọn ngày và giờ",
            availableSlots: "Khung giờ rảnh",
            noSlots: "Không có khung giờ rảnh cho ngày này"
          },
          confirmation: {
            title: "Xác nhận đặt lịch",
            details: "Chi tiết đặt lịch",
            service: "Dịch vụ",
            specialist: "Chuyên gia",
            dateTime: "Ngày và giờ",
            clientInfo: "Thông tin của bạn",
            confirming: "Đang xác nhận...",
            confirmBooking: "Xác nhận đặt lịch",
            error: "Lỗi khi tạo đặt lịch"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Cuộc hẹn",
            clients: "Khách hàng",
            services: "Dịch vụ",
            specialists: "Chuyên gia",
            settings: "Cài đặt",
            products: "Sản phẩm"

          },
          appointments: {
            title: "Cuộc hẹn",
            upcoming: "Sắp tới",
            past: "Đã qua",
            datetime: "Ngày và giờ",
            client: "Khách hàng",
            service: "Dịch vụ",
            specialist: "Chuyên gia",
            duration: "Thời lượng",
            deleteConfirm: "Bạn có chắc chắn muốn xóa cuộc hẹn này?",
            status: {
              pending: "Đang chờ",
              confirmed: "Đã xác nhận",
              cancelled: "Đã hủy",
              completed: "Đã hoàn thành"
            },
            actions: {
              confirm: "Xác nhận",
              cancel: "Hủy",
              reschedule: "Đặt lại lịch"
            }
          },
          clients: {
            title: "Khách hàng",
            addNew: "Thêm khách hàng mới",
            management: "Quản lý khách hàng",
            details: "Chi tiết khách hàng",
            history: "Lịch sử khách hàng",
            status: {
              new: "Mới",
              regular: "Thường xuyên",
              former: "Cũ",
              deleted: "Đã xóa"
            },
            tabs: {
              new: "Mới",
              regular: "Thường xuyên",
              former: "Cũ",
              deleted: "Đã xóa"
            }
          },
          services: {
            title: "Dịch vụ",
            addNew: "Thêm dịch vụ mới",
            editService: "Sửa dịch vụ",
            fields: {
              name: "Tên dịch vụ",
              duration: "Thời lượng",
              price: "Giá"
            }
          },
          specialists: {
            title: "Chuyên gia",
            addNew: "Thêm chuyên gia mới",
            management: "Quản lý chuyên gia",
            schedule: "Giờ làm việc",
            services: "Dịch vụ có sẵn",
            status: {
              pending: "Đang chờ phê duyệt",
              approved: "Đã phê duyệt",
              rejected: "Đã từ chối"
            }
          },
          settings: {
            title: "Cài đặt",
            profile: "Cài đặt hồ sơ",
            account: "Cài đặt tài khoản",
            password: "Đổi mật khẩu",
            fields: {
              currentPassword: "Mật khẩu hiện tại",
              newPassword: "Mật khẩu mới",
              confirmPassword: "Xác nhận mật khẩu"
            }
          }
        },
        settings: {
          tabAndColumnVisibility: "Khả năng hiển thị của tab và cột",
          tabOrder: "Thứ tự tab",
          hiddenTabs: "Tab ẩn",
          clientColumns: "Các cột của khách hàng",      
          crmSettings: "Cài đặt CRM",
          promoText: "Văn bản khuyến mãi",
          headerTitle: "Tiêu đề",
          headerSubtitle: "Mô tả",
          defaultLanguage: "Ngôn ngữ mặc định",
          currency: "Tiền tệ",
          currencyPosition: "Vị trí tiền tệ",
          currencyRight: "Phải",
          currencyLeft: "Trái",
          hideAppointments: "Ẩn tab 'Lịch hẹn'",
          hideSpecialists: "Ẩn tab 'Chuyên gia'",
          hideServices: "Ẩn tab 'Dịch vụ'",
          hideClients: "Ẩn tab 'Khách hàng'",
          hideProducts: "Ẩn tab 'Sản phẩm'",
          tabsSaved: "Đã lưu cài đặt tab",
          errorFetching: "Lỗi tải cài đặt",
          errorSaving: "Lỗi lưu cài đặt",
          tabsDescription: "Cấu hình giao diện và hành vi của các tab",
          tabVisibility: "Chuyển đổi khả năng hiển thị của các tab",
          configureTabs: "Điều chỉnh cài đặt của các tab"
  
         },
         products: {
          import: {
            steps: {
              upload: "Tải lên",
              map: "Lập bản đồ",
              import: "Nhập khẩu"
            },
            selectfile: "Chọn tệp",
            guide: "Để nhập sản phẩm: 1) Tạo tệp Excel có các cột cho dữ liệu sản phẩm 2) Dòng đầu tiên phải chứa tên các cột 3) Mỗi dòng đại diện cho một sản phẩm 4) Trường bắt buộc: Tên sản phẩm 5) Việc gán cột mặc định được đặt thành A1, B1, v.v.",
            guideTitle: "Hướng dẫn nhập khẩu"
          },  
          defaultcategory: "Mặc định",
          title: "Quản lý sản phẩm",
          addNew: "Thêm sản phẩm mới",
          edit: "Chỉnh sửa sản phẩm",
          create: "Tạo sản phẩm",
          name: "Tên",
          category: "Danh mục",
          price: "Giá",
          costPrice: "Chi phí",
          warehouseName: "Tên kho",
          warehouseAddress: "Địa chỉ kho",
          articleNumber: "Mã sản phẩm",
          unit: "Đơn vị",
          weight: "Trọng lượng",
          length: "Chiều dài",
          width: "Chiều rộng",
          height: "Chiều cao",
          stock: "Tồn kho",
          responsibleEmployee: "Nhân viên phụ trách",
          dimensions: "Kích thước",
          warehouse: "Kho",
          deleteTitle: "Xóa sản phẩm",
          deleteConfirm: "Bạn có chắc chắn muốn xóa sản phẩm {{name}} không?",
          units: {
            piece: "Cái",
            kg: "Kilogram",
            package: "Gói"
          }
         }  
      }
    },


    jv: {
      translation: {
        common: {
      
          nazvanie: "Jeneng",
          maxprice: "Rega maksimal",
          category: "Kategori",
          title: "Judhul",
          addnew: "Tambah anyar",
          projectType: "Tipe proyek",
          history: "Sejarah",
          assignSpecialists: "Tetepake spesialis",
          uploadSpecialistPhoto: "Unggah foto spesialis",
          selectimage: "Pilih gambar",
          upload: "Unggah",
          anySpecialist: "Sembarang spesialis",
          allServices: "Kabeh layanan",    
          minutes: "menit",
          add: "Tambah",
          edit: "Owahi",
          delete: "Busak",
          save: "Simpen",
          cancel: "Batal",
          confirm: "Konfirmasi",
          back: "Bali",
          next: "Sabanjure",
          min: "menit",
          login: "Mlebu",
          register: "Daftar",
          logout: "Metu",
          email: "Email",
          password: "Tembung Wadi",
          phone: "Telpon",
          name: "Jeneng",
          actions: "Tumindak",
          optional: "opsional",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Status",
          savechanges: "Simpen Owahan",
          changespecialist: "Ganti Ahli",
          past: "Kepungkur",
          ongoing: "Lagi Mlaku",
          upcoming: "Sing Arep Teka",
          future: "Mangsa Ngarep",
          specialist: "Ahli",
          errorApproving: "Kesalahan Nyetujui",
          errorRejecting: "Kesalahan Nolak",
          errorSaving: "Kesalahan Nyimpen",
          specialists: "Para Ahli",
          schedule: "Jadwal",
          services: "Layanan",
          service: "Layanan",
          pendingApprovals: "Nungggu Persetujuan",
          activeSpecialists: "Ahli Aktif",
          approve: "Setuju",
          reject: "Tolak",
          namecompany: "Jeneng/Perusahaan",
          firstcontact: "Kontak Pertama",
          contacts: "Kontak",
          projectstatus: "Status Proyek",
          createdby: "Digawe Dening",
          assignedto: "Ditugasake Menyang",
          clearalldeleted: "Busak Kabeh sing Dibusak",
          dashboard: "Dasboard",
          editservices: "Owahi Layanan",
          setschedule: "Atur Jadwal",
          website: "Website",
          new: "Anyar",
          regular: "Biasa",
          former: "Lawas",
          deleted: "Dibusak",
          clientstatus: "Status Pelanggan",
          address: "Alamat",
          assignspecialiststo: "Tugasake Ahli Menyang",
          discussion: "Diskusi",
          firstcontactdate: "Tanggal Kontak Pertama",
          projecttype: "Jinis Proyek",
          projectdescription: "Deskripsi Proyek",
          technicaldetails: "Detail Teknis",
          budget: "Anggaran",
          contacted: "Wis Dikontak",
          unreachable: "Ora Bisa Dihubungi",
          negotiating: "Lagi Negosiasi",
          meeting: "Rapat",
          development: "Pengembangan",
          completed: "Rampung",
          telegramoptional: "Telegram (opsional)",
          instagramoptional: "Instagram (opsional)",
          alreadyhaveanaccount: "Wis Duwe Akun? Mlebu",
          myappointments: "Janjianku",
          myclients: "Pelanggaku",
          settings: "Setelan",
          profilesettings: "Setelan Profil",
          saveprofilechanges: "Simpen Owahan Profil",
          changepassword: "Ganti Tembung Wadi",
          currentpassword: "Tembung Wadi Saiki",
          newpassword: "Tembung Wadi Anyar",
          confirmnewpassword: "Konfirmasi Tembung Wadi Anyar",
          deleteaccount: "Busak Akun",
          accountsettings: "Setelan Akun",
          saveschedule: "Simpen Jadwal",
          starttime: "Wektu Wiwit",
          endtime: "Wektu Rampung",
          addnewclient: "Tambah Pelanggan Anyar",
          editclient: "Owahi Pelanggan",
          newclient: "Pelanggan Anyar",
          export: "Ekspor",
          import: "Impor",
          saving: "Sedang menyimpan...",
          role: "Peran",
          editRole: "Edit Peran",
          changeRole: "Ubah Peran",
          specialistRoleDescription: "Akses ke tugas khusus dan data proyek",
          adminRoleDescription: "Akses penuh ke pengaturan dan manajemen pengguna",
          superadmin: "Dukungan Teknis Aunimeda",
          admin: "Administrator",
          noServicesSelected: "Tidak ada layanan yang dipilih",
          none: "Tidak ada",
          create: "Buat",  
    
          projectStatus: {
            discussion: "Diskusi",
            contacted: "Wis Dikontak",
            unreachable: "Ora Bisa Dihubungi",
            negotiating: "Lagi Negosiasi",
            meeting: "Rapat",
            development: "Pengembangan",
            completed: "Rampung"
          },
    
          assignedspecialists: "Ahli sing Ditugasake",
          visibletoallspecialists: "Ketok Kanggo Kabeh Ahli",
          allspecialists: "Kabeh Ahli",
          createclient: "Gawe Pelanggan",
          client: "Pelanggan",
          selectservices: "Pilih Layanan",
          selectspecialist: "Pilih Ahli",
          selectdateandtime: "Pilih Tanggal lan Wektu",
          confirmbooking: "Konfirmasi Pemesanan",
          selectall: "Pilih Kabeh",
          editservicesfor: "Owahi Layanan Kanggo",
          clearall: "Resiki Kabeh",
          duration: "Durasi",
          price: "Rega",
          selected: "Dipilih",
          saveservices: "Simpen Layanan",
          selectservicesthisspecialistcanprovidetoclients: "Pilih Layanan sing Bisa Diwenehake Ahli Iki Marang Pelanggan",
          confirmClearAllDeleted: "Sampeyan yakin arep mbusak kabeh pelanggan saka folder sing dibusak? Tumindak iki ora bisa dibatalake.",
    
          setSchedule: "Atur Jadwal",
          setWorkingHours: "Atur Jam Kerja",
          setworkinghoursfor: "Atur Jam Kerja Kanggo",
          startTime: "Wektu Wiwit",
          endTime: "Wektu Rampung",
          monday: "Senin",
          tuesday: "Selasa",
          wednesday: "Rebo",
          thursday: "Kemis",
          friday: "Jumat",
          saturday: "Setu",
          sunday: "Minggu"
        },
        auth: {
          login: {
            title: "Mlebu",
            invalidCredentials: "Email utawa tembung wadi ora bener",
            forgotPassword: "Lali tembung wadi?",
            noAccount: "Durung duwe akun?",
            registerHere: "Daftar ing kene"
          },
          register: {
            title: "Daftar",
            success: "Pendaftaran sukses",
            haveAccount: "Wis duwe akun?",
            loginHere: "Mlebu ing kene",
            asClient: "Daftar minangka Pelanggan",
            asSpecialist: "Daftar minangka Ahli",
            waitingApproval: "Pendaftaran sukses. Nunggu persetujuan saka administrator."
          }
        },
        booking: {
          steps: {
            selectService: "Pilih Layanan",
            selectSpecialist: "Pilih Ahli",
            selectDateTime: "Pilih Tanggal lan Wektu",
            confirmation: "Konfirmasi"
          },
          services: {
            title: "Pilih Layanan",
            duration: "Durasi",
            price: "Rega"
          },
          specialists: {
            title: "Pilih Ahli",
            availability: "Wektu sing Tersedia",
            noAvailability: "Ora ana wektu sing tersedia"
          },
          datetime: {
            title: "Pilih Tanggal lan Wektu",
            availableSlots: "Slot sing Tersedia",
            noSlots: "Ora ana slot sing tersedia kanggo tanggal iki"
          },
          confirmation: {
            title: "Konfirmasi Pemesanan",
            details: "Detail Pemesanan",
            service: "Layanan",
            specialist: "Ahli",
            dateTime: "Tanggal lan Wektu",
            clientInfo: "Informasi Sampeyan",
            confirming: "Lagi Konfirmasi...",
            confirmBooking: "Konfirmasi Pemesanan",
            error: "Kesalahan nalika nggawe pemesanan"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Janjian",
            clients: "Pelanggan",
            services: "Layanan",
            specialists: "Ahli",
            settings: "Setelan",
            products: "Produk"

          },
          appointments: {
            title: "Janjian",
            upcoming: "Sing Arep Teka",
            past: "Kepungkur",
            datetime: "Tanggal lan Wektu",
            client: "Pelanggan",
            service: "Layanan",
            specialist: "Ahli",
            duration: "Durasi",
            deleteConfirm: "Sampeyan yakin arep mbusak janjian iki?",
            status: {
              pending: "Nunggu",
              confirmed: "Dikonfirmasi",
              cancelled: "Dibatalake",
              completed: "Rampung"
            },
            actions: {
              confirm: "Konfirmasi",
              cancel: "Batal",
              reschedule: "Jadwal Ulang"
            }
          },
          clients: {
            title: "Pelanggan",
            addNew: "Tambah Pelanggan Anyar",
            management: "Manajemen Pelanggan",
            details: "Detail Pelanggan",
            history: "Riwayat Pelanggan",
            status: {
              new: "Anyar",
              regular: "Biasa",
              former: "Lawas",
              deleted: "Dibusak"
            },
            tabs: {
              new: "Anyar",
              regular: "Biasa",
              former: "Lawas",
              deleted: "Dibusak"
            }
          },
          services: {
            title: "Layanan",
            addNew: "Tambah Layanan Anyar",
            editService: "Owahi Layanan",
            fields: {
              name: "Jeneng Layanan",
              duration: "Durasi",
              price: "Rega"
            }
          },
          specialists: {
            title: "Ahli",
            addNew: "Tambah Ahli Anyar",
            management: "Manajemen Ahli",
            schedule: "Jam Kerja",
            services: "Layanan sing Tersedia",
            status: {
              pending: "Nunggu Persetujuan",
              approved: "Disetujui",
              rejected: "Ditolak"
            }
          },
          settings: {
            title: "Setelan",
            profile: "Setelan Profil",
            account: "Setelan Akun",
            password: "Ganti Tembung Wadi",
            fields: {
              currentPassword: "Tembung Wadi Saiki",
              newPassword: "Tembung Wadi Anyar",
              confirmPassword: "Konfirmasi Tembung Wadi"
            }
          }
        },
        settings: {
          tabAndColumnVisibility: "Visibilitas tab lan kolom",
          tabOrder: "Urutan tab",
          hiddenTabs: "Tab sing didhelikake",
          clientColumns: "Kolom klien",      
          crmSettings: "Pengaturan CRM",
          promoText: "Teks Promosi",
          headerTitle: "Judul",
          headerSubtitle: "Deskripsi",
          defaultLanguage: "Bahasa Default",
          currency: "Mata Uang",
          currencyPosition: "Posisi Mata Uang",
          currencyRight: "Kanan",
          currencyLeft: "Kiri",
          hideAppointments: "Dhedhes tab 'Janji'",
          hideSpecialists: "Dhedhes tab 'Ahli'",
          hideServices: "Dhedhes tab 'Layanan'",
          hideClients: "Dhedhes tab 'Klien'",
          hideProducts: "Dhedhes tab 'Produk'",
          tabsSaved: "Setelan tab wis disimpen",
          errorFetching: "Error pas ngleboake setelan",
          errorSaving: "Error pas nyimpen setelan",
          tabsDescription: "Konfigurasi tampilan dan perilaku tab",
          tabVisibility: "Alihkan visibilitas tab",
          configureTabs: "Sesuaikan pengaturan tab"

         },
         products: {
          import: {
            steps: {
              upload: "Unggah",
              map: "Peta",
              import: "Impor"
            },
            selectfile: "Pilih file",
            guide: "Kanggo ngimpor produk: 1) Gawe file Excel kanthi kolom kanggo data produk 2) Baris pertama kudu ngemot jeneng kolom 3) Saben baris nggambarake produk 4) Kolom wajib: Jeneng produk 5) Penetepan kolom standar disetel ing A1, B1, lsp.",
            guideTitle: "Pandhuan ngimpor"
          },
          defaultcategory: "Default",
          title: "Manajemen Produk",
          addNew: "Tambah Produk Baru",
          edit: "Edit Produk",
          create: "Buat Produk",
          name: "Nama",
          category: "Kategori",
          price: "Harga",
          costPrice: "Biaya",
          warehouseName: "Nama Gudang",
          warehouseAddress: "Alamat Gudang",
          articleNumber: "Kode Produk",
          unit: "Satuan",
          weight: "Berat",
          length: "Panjang",
          width: "Lebar",
          height: "Tinggi",
          stock: "Stok",
          responsibleEmployee: "Karyawan Penanggung Jawab",
          dimensions: "Dimensi",
          warehouse: "Gudang",
          deleteTitle: "Hapus Produk",
          deleteConfirm: "Apakah Anda yakin ingin menghapus produk {{name}}?",
          units: {
            piece: "Buah",
            kg: "Kilogram",
            package: "Paket"
          }
         }  
      }
    },


    th: {
      translation: {
        common: {
          nazvanie: "ชื่อ",
          maxprice: "ราคาสูงสุด",
          category: "หมวดหมู่",
          title: "ชื่อเรื่อง",
          addnew: "เพิ่มใหม่",
          projectType: "ประเภทโครงการ",
          history: "ประวัติ",
          assignSpecialists: "กำหนดผู้เชี่ยวชาญ",
          uploadSpecialistPhoto: "อัพโหลดรูปถ่ายของผู้เชี่ยวชาญ",
          selectimage: "เลือกภาพ",
          upload: "อัพโหลด",
          anySpecialist: "ผู้เชี่ยวชาญใดก็ได้",
          allServices: "บริการทั้งหมด",      
          minutes: "นาที",
          add: "เพิ่ม",
          edit: "แก้ไข",
          delete: "ลบ",
          save: "บันทึก",
          cancel: "ยกเลิก",
          confirm: "ยืนยัน",
          back: "ย้อนกลับ",
          next: "ถัดไป",
          min: "นาที",
          login: "เข้าสู่ระบบ",
          register: "ลงทะเบียน",
          logout: "ออกจากระบบ",
          email: "อีเมล",
          password: "รหัสผ่าน",
          phone: "โทรศัพท์",
          name: "ชื่อ",
          actions: "การดำเนินการ",
          optional: "ไม่บังคับ",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "สถานะ",
          savechanges: "บันทึกการเปลี่ยนแปลง",
          changespecialist: "เปลี่ยนผู้เชี่ยวชาญ",
          past: "ที่ผ่านมา",
          ongoing: "กำลังดำเนินการ",
          upcoming: "ที่กำลังจะมาถึง",
          future: "อนาคต",
          specialist: "ผู้เชี่ยวชาญ",
          errorApproving: "ข้อผิดพลาดในการอนุมัติ",
          errorRejecting: "ข้อผิดพลาดในการปฏิเสธ",
          errorSaving: "ข้อผิดพลาดในการบันทึก",
          specialists: "ผู้เชี่ยวชาญ",
          schedule: "ตารางเวลา",
          services: "บริการ",
          service: "บริการ",
          pendingApprovals: "รออนุมัติ",
          activeSpecialists: "ผู้เชี่ยวชาญที่ใช้งาน",
          approve: "อนุมัติ",
          reject: "ปฏิเสธ",
          namecompany: "ชื่อ/บริษัท",
          firstcontact: "การติดต่อครั้งแรก",
          contacts: "ข้อมูลติดต่อ",
          projectstatus: "สถานะโครงการ",
          createdby: "สร้างโดย",
          assignedto: "มอบหมายให้",
          clearalldeleted: "ล้างรายการที่ลบทั้งหมด",
          dashboard: "แดชบอร์ด",
          editservices: "แก้ไขบริการ",
          setschedule: "กำหนดตารางเวลา",
          website: "เว็บไซต์",
          new: "ใหม่",
          regular: "ปกติ",
          former: "อดีต",
          deleted: "ลบแล้ว",
          clientstatus: "สถานะลูกค้า",
          address: "ที่อยู่",
          assignspecialiststo: "มอบหมายผู้เชี่ยวชาญให้",
          discussion: "การสนทนา",
          firstcontactdate: "วันที่ติดต่อครั้งแรก",
          projecttype: "ประเภทโครงการ",
          projectdescription: "รายละเอียดโครงการ",
          technicaldetails: "รายละเอียดทางเทคนิค",
          budget: "งบประมาณ",
          contacted: "ติดต่อแล้ว",
          unreachable: "ไม่สามารถติดต่อได้",
          negotiating: "กำลังเจรจา",
          meeting: "การประชุม",
          development: "การพัฒนา",
          completed: "เสร็จสิ้น",
          telegramoptional: "Telegram (ไม่บังคับ)",
          instagramoptional: "Instagram (ไม่บังคับ)",
          alreadyhaveanaccount: "มีบัญชีอยู่แล้ว? เข้าสู่ระบบ",
          myappointments: "การนัดหมายของฉัน",
          myclients: "ลูกค้าของฉัน",
          settings: "การตั้งค่า",
          profilesettings: "การตั้งค่าโปรไฟล์",
          saveprofilechanges: "บันทึกการเปลี่ยนแปลงโปรไฟล์",
          changepassword: "เปลี่ยนรหัสผ่าน",
          currentpassword: "รหัสผ่านปัจจุบัน",
          newpassword: "รหัสผ่านใหม่",
          confirmnewpassword: "ยืนยันรหัสผ่านใหม่",
          deleteaccount: "ลบบัญชี",
          accountsettings: "การตั้งค่าบัญชี",
          saveschedule: "บันทึกตารางเวลา",
          starttime: "เวลาเริ่มต้น",
          endtime: "เวลาสิ้นสุด",
          addnewclient: "เพิ่มลูกค้าใหม่",
          editclient: "แก้ไขลูกค้า",
          newclient: "ลูกค้าใหม่",

          export: "ส่งออก",
          import: "นำเข้า",
          saving: "กำลังบันทึก...",
          role: "บทบาท",
          editRole: "แก้ไขบทบาท",
          changeRole: "เปลี่ยนบทบาท",
          specialistRoleDescription: "เข้าถึงงานพิเศษและข้อมูลโครงการ",
          adminRoleDescription: "การเข้าถึงแบบเต็มสำหรับการตั้งค่าและการจัดการผู้ใช้",
          superadmin: "การสนับสนุนทางเทคนิค Aunimeda",
          admin: "ผู้ดูแลระบบ",
          noServicesSelected: "ไม่ได้เลือกบริการ",
          none: "ไม่มี",
          create: "สร้าง",  
    
          projectStatus: {
            discussion: "การสนทนา",
            contacted: "ติดต่อแล้ว",
            unreachable: "ไม่สามารถติดต่อได้",
            negotiating: "กำลังเจรจา",
            meeting: "การประชุม",
            development: "การพัฒนา",
            completed: "เสร็จสิ้น"
          },
    
          assignedspecialists: "ผู้เชี่ยวชาญที่มอบหมาย",
          visibletoallspecialists: "มองเห็นได้สำหรับผู้เชี่ยวชาญทุกคน",
          allspecialists: "ผู้เชี่ยวชาญทั้งหมด",
          createclient: "สร้างลูกค้า",
          client: "ลูกค้า",
          selectservices: "เลือกบริการ",
          selectspecialist: "เลือกผู้เชี่ยวชาญ",
          selectdateandtime: "เลือกวันและเวลา",
          confirmbooking: "ยืนยันการจอง",
          selectall: "เลือกทั้งหมด",
          editservicesfor: "แก้ไขบริการสำหรับ",
          clearall: "ล้างทั้งหมด",
          duration: "ระยะเวลา",
          price: "ราคา",
          selected: "เลือกแล้ว",
          saveservices: "บันทึกบริการ",
          selectservicesthisspecialistcanprovidetoclients: "เลือกบริการที่ผู้เชี่ยวชาญคนนี้สามารถให้บริการแก่ลูกค้าได้",
          confirmClearAllDeleted: "คุณแน่ใจหรือไม่ที่จะลบลูกค้าทั้งหมดจากโฟลเดอร์ที่ลบ? การดำเนินการนี้ไม่สามารถยกเลิกได้",
    
          setSchedule: "กำหนดตารางเวลา",
          setWorkingHours: "กำหนดเวลาทำงาน",
          setworkinghoursfor: "กำหนดเวลาทำงานสำหรับ",
          startTime: "เวลาเริ่มต้น",
          endTime: "เวลาสิ้นสุด",
          monday: "วันจันทร์",
          tuesday: "วันอังคาร",
          wednesday: "วันพุธ",
          thursday: "วันพฤหัสบดี",
          friday: "วันศุกร์",
          saturday: "วันเสาร์",
          sunday: "วันอาทิตย์"
        },
        auth: {
          login: {
            title: "เข้าสู่ระบบ",
            invalidCredentials: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
            forgotPassword: "ลืมรหัสผ่าน?",
            noAccount: "ยังไม่มีบัญชี?",
            registerHere: "ลงทะเบียนที่นี่"
          },
          register: {
            title: "ลงทะเบียน",
            success: "ลงทะเบียนสำเร็จ",
            haveAccount: "มีบัญชีอยู่แล้ว?",
            loginHere: "เข้าสู่ระบบที่นี่",
            asClient: "ลงทะเบียนเป็นลูกค้า",
            asSpecialist: "ลงทะเบียนเป็นผู้เชี่ยวชาญ",
            waitingApproval: "ลงทะเบียนสำเร็จ กำลังรอการอนุมัติจากผู้ดูแลระบบ"
          }
        },
        booking: {
          steps: {
            selectService: "เลือกบริการ",
            selectSpecialist: "เลือกผู้เชี่ยวชาญ",
            selectDateTime: "เลือกวันและเวลา",
            confirmation: "ยืนยัน"
          },
          services: {
            title: "เลือกบริการ",
            duration: "ระยะเวลา",
            price: "ราคา"
          },
          specialists: {
            title: "เลือกผู้เชี่ยวชาญ",
            availability: "เวลาที่ว่าง",
            noAvailability: "ไม่มีเวลาว่าง"
          },
          datetime: {
            title: "เลือกวันและเวลา",
            availableSlots: "ช่วงเวลาที่ว่าง",
            noSlots: "ไม่มีช่วงเวลาว่างสำหรับวันนี้"
          },
          confirmation: {
            title: "ยืนยันการจอง",
            details: "รายละเอียดการจอง",
            service: "บริการ",
            specialist: "ผู้เชี่ยวชาญ",
            dateTime: "วันและเวลา",
            clientInfo: "ข้อมูลของคุณ",
            confirming: "กำลังยืนยัน...",
            confirmBooking: "ยืนยันการจอง",
            error: "เกิดข้อผิดพลาดในการสร้างการจอง"
          }
        },
        dashboard: {
          tabs: {
            appointments: "การนัดหมาย",
            clients: "ลูกค้า",
            services: "บริการ",
            specialists: "ผู้เชี่ยวชาญ",
            settings: "การตั้งค่า",
            products: "สินค้า"

          },
          appointments: {
            title: "การนัดหมาย",
            upcoming: "ที่กำลังจะมาถึง",
            past: "ที่ผ่านมา",
            datetime: "วันและเวลา",
            client: "ลูกค้า",
            service: "บริการ",
            specialist: "ผู้เชี่ยวชาญ",
            duration: "ระยะเวลา",
            deleteConfirm: "คุณแน่ใจหรือไม่ที่จะลบการนัดหมายนี้?",
            status: {
              pending: "รอดำเนินการ",
              confirmed: "ยืนยันแล้ว",
              cancelled: "ยกเลิกแล้ว",
              completed: "เสร็จสิ้น"
            },
            actions: {
              confirm: "ยืนยัน",
              cancel: "ยกเลิก",
              reschedule: "กำหนดเวลาใหม่"
            }
          },
          clients: {
            title: "ลูกค้า",
            addNew: "เพิ่มลูกค้าใหม่",
            management: "จัดการลูกค้า",
            details: "รายละเอียดลูกค้า",
            history: "ประวัติลูกค้า",
            status: {
              new: "ใหม่",
              regular: "ปกติ",
              former: "อดีต",
              deleted: "ลบแล้ว"
            },
            tabs: {
              new: "ใหม่",
              regular: "ปกติ",
              former: "อดีต",
              deleted: "ลบแล้ว"
            }
          },
          services: {
            title: "บริการ",
            addNew: "เพิ่มบริการใหม่",
            editService: "แก้ไขบริการ",
            fields: {
              name: "ชื่อบริการ",
              duration: "ระยะเวลา",
              price: "ราคา"
        }
      },
      specialists: {
        title: "ผู้เชี่ยวชาญ",
        addNew: "เพิ่มผู้เชี่ยวชาญใหม่",
        management: "จัดการผู้เชี่ยวชาญ",
        schedule: "ตารางเวลาทำงาน",
        services: "บริการที่มี",
        status: {
          pending: "รอการอนุมัติ",
          approved: "อนุมัติแล้ว",
          rejected: "ปฏิเสธแล้ว"
        }
      },
      settings: {
        title: "การตั้งค่า",
        profile: "การตั้งค่าโปรไฟล์",
        account: "การตั้งค่าบัญชี",
        password: "เปลี่ยนรหัสผ่าน",
        fields: {
          currentPassword: "รหัสผ่านปัจจุบัน",
          newPassword: "รหัสผ่านใหม่",
          confirmPassword: "ยืนยันรหัสผ่าน"
        }
      }
    },

    settings: {
      tabAndColumnVisibility: "การมองเห็นแท็บและคอลัมน์",
      tabOrder: "ลำดับแท็บ",
      hiddenTabs: "แท็บที่ซ่อนอยู่",
      clientColumns: "คอลัมน์ของลูกค้า",  
      crmSettings: "การตั้งค่า CRM",
      promoText: "ข้อความส่งเสริมการขาย",
      headerTitle: "หัวข้อ",
      headerSubtitle: "คำอธิบาย",
      defaultLanguage: "ภาษาเริ่มต้น",
      currency: "สกุลเงิน",
      currencyPosition: "ตำแหน่งสกุลเงิน",
      currencyRight: "ขวา",
      currencyLeft: "ซ้าย",
      hideAppointments: "ซ่อนแท็บ 'การนัดหมาย'",
      hideSpecialists: "ซ่อนแท็บ 'ผู้เชี่ยวชาญ'",
      hideServices: "ซ่อนแท็บ 'บริการ'",
      hideClients: "ซ่อนแท็บ 'ลูกค้า'",
      hideProducts: "ซ่อนแท็บ 'สินค้า'",
      tabsSaved: "บันทึกการตั้งค่าแท็บแล้ว",
      errorFetching: "เกิดข้อผิดพลาดในการโหลดการตั้งค่า",
      errorSaving: "เกิดข้อผิดพลาดในการบันทึกการตั้งค่า",
      tabsDescription: "กำหนดลักษณะและพฤติกรรมของแท็บ",
      tabVisibility: "สลับการมองเห็นของแท็บ",
      configureTabs: "ปรับแต่งการตั้งค่าแท็บ"

     },
     products: {
      import: {
        steps: {
          upload: "อัพโหลด",
          map: "แผนที่",
          import: "นำเข้า"
        },
        selectfile: "เลือกไฟล์",
        guide: "ในการนำเข้าผลิตภัณฑ์: 1) สร้างไฟล์ Excel ที่มีคอลัมน์สำหรับข้อมูลผลิตภัณฑ์ 2) แถวแรกควรมีชื่อคอลัมน์ 3) แต่ละแถวแสดงถึงผลิตภัณฑ์หนึ่งรายการ 4) ฟิลด์ที่จำเป็น: ชื่อผลิตภัณฑ์ 5) การกำหนดค่าเริ่มต้นของคอลัมน์จะถูกตั้งค่าเป็น A1, B1 เป็นต้น",
        guideTitle: "คำแนะนำในการนำเข้า"
      },  
      defaultcategory: "ค่าเริ่มต้น",
      title: "การจัดการสินค้า",
      addNew: "เพิ่มสินค้าใหม่",
      edit: "แก้ไขสินค้า",
      create: "สร้างสินค้า",
      name: "ชื่อ",
      category: "หมวดหมู่",
      price: "ราคา",
      costPrice: "ต้นทุน",
      warehouseName: "ชื่อคลังสินค้า",
      warehouseAddress: "ที่อยู่คลังสินค้า",
      articleNumber: "รหัสสินค้า",
      unit: "หน่วย",
      weight: "น้ำหนัก",
      length: "ความยาว",
      width: "ความกว้าง",
      height: "ความสูง",
      stock: "สต็อก",
      responsibleEmployee: "พนักงานผู้รับผิดชอบ",
      dimensions: "ขนาด",
      warehouse: "คลังสินค้า",
      deleteTitle: "ลบสินค้า",
      deleteConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบสินค้า {{name}}?",
      units: {
        piece: "ชิ้น",
        kg: "กิโลกรัม",
        package: "แพ็ค"
      }
     }  
  }
},


    it: {
      translation: {
        common: {
          nazvanie: "Nome",
          maxprice: "Prezzo massimo",
          category: "Categoria",
          title: "Titolo",
          addnew: "Aggiungi nuovo",
          projectType: "Tipo di progetto",
          history: "Storia",
          assignSpecialists: "Assegna specialisti",
          uploadSpecialistPhoto: "Carica foto dello specialista",
          selectimage: "Seleziona immagine",
          upload: "Carica",
          anySpecialist: "Qualsiasi specialista",
          allServices: "Tutti i servizi",      
          minutes: "minuti",
          add: "Aggiungi",
          edit: "Modifica",
          delete: "Elimina",
          save: "Salva",
          cancel: "Annulla",
          confirm: "Conferma",
          back: "Indietro",
          next: "Avanti",
          min: "min",
          login: "Accedi",
          register: "Registrati",
          logout: "Esci",
          email: "Email",
          password: "Password",
          phone: "Telefono",
          name: "Nome",
          actions: "Azioni",
          optional: "opzionale",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Stato",
          savechanges: "Salva modifiche",
          changespecialist: "Cambia specialista",
          past: "Passato",
          ongoing: "In corso",
          upcoming: "In arrivo",
          future: "Futuro",
          specialist: "Specialista",
          errorApproving: "Errore nell'approvazione",
          errorRejecting: "Errore nel rifiuto",
          errorSaving: "Errore nel salvataggio",
          specialists: "Specialisti",
          schedule: "Agenda",
          services: "Servizi",
          service: "Servizio",
          pendingApprovals: "Approvazioni in attesa",
          activeSpecialists: "Specialisti attivi",
          approve: "Approva",
          reject: "Rifiuta",
          namecompany: "Nome/Azienda",
          firstcontact: "Primo contatto",
          contacts: "Contatti",
          projectstatus: "Stato del progetto",
          createdby: "Creato da",
          assignedto: "Assegnato a",
          clearalldeleted: "Cancella tutti gli elementi eliminati",
          dashboard: "Dashboard",
          editservices: "Modifica servizi",
          setschedule: "Imposta agenda",
          website: "Sito web",
          new: "Nuovo",
          regular: "Regolare",
          former: "Precedente",
          deleted: "Eliminato",
          clientstatus: "Stato del cliente",
          address: "Indirizzo",
          assignspecialiststo: "Assegna specialisti a",
          discussion: "Discussione",
          firstcontactdate: "Data primo contatto",
          projecttype: "Tipo di progetto",
          projectdescription: "Descrizione del progetto",
          technicaldetails: "Dettagli tecnici",
          budget: "Budget",
          contacted: "Contattato",
          unreachable: "Non raggiungibile",
          negotiating: "In trattativa",
          meeting: "Riunione",
          development: "Sviluppo",
          completed: "Completato",
          telegramoptional: "Telegram (opzionale)",
          instagramoptional: "Instagram (opzionale)",
          alreadyhaveanaccount: "Hai già un account? Accedi",
          myappointments: "I miei appuntamenti",
          myclients: "I miei clienti",
          settings: "Impostazioni",
          profilesettings: "Impostazioni profilo",
          saveprofilechanges: "Salva modifiche profilo",
          changepassword: "Cambia password",
          currentpassword: "Password attuale",
          newpassword: "Nuova password",
          confirmnewpassword: "Conferma nuova password",
          deleteaccount: "Elimina account",
          accountsettings: "Impostazioni account",
          saveschedule: "Salva agenda",
          starttime: "Ora di inizio",
          endtime: "Ora di fine",
          addnewclient: "Aggiungi nuovo cliente",
          editclient: "Modifica cliente",
          newclient: "Nuovo cliente",

          export: "Esporta",
          import: "Importa",
          saving: "Salvataggio in corso...",
          role: "Ruolo",
          editRole: "Modifica ruolo",
          changeRole: "Cambia ruolo",
          specialistRoleDescription: "Accesso a compiti speciali e dati di progetto",
          adminRoleDescription: "Accesso completo a impostazioni e gestione utenti",
          superadmin: "Supporto tecnico Aunimeda",
          admin: "Amministratore",
          noServicesSelected: "Nessun servizio selezionato",
          none: "Nessuno",
          create: "Crea",  
    
          projectStatus: {
            discussion: "Discussione",
            contacted: "Contattato",
            unreachable: "Non raggiungibile",
            negotiating: "In trattativa",
            meeting: "Riunione",
            development: "Sviluppo",
            completed: "Completato"
          },
    
          assignedspecialists: "Specialisti assegnati",
          visibletoallspecialists: "Visibile a tutti gli specialisti",
          allspecialists: "Tutti gli specialisti",
          createclient: "Crea cliente",
          client: "Cliente",
          selectservices: "Seleziona servizi",
          selectspecialist: "Seleziona specialista",
          selectdateandtime: "Seleziona data e ora",
          confirmbooking: "Conferma prenotazione",
          selectall: "Seleziona tutto",
          editservicesfor: "Modifica servizi per",
          clearall: "Cancella tutto",
          duration: "Durata",
          price: "Prezzo",
          selected: "Selezionato",
          saveservices: "Salva servizi",
          selectservicesthisspecialistcanprovidetoclients: "Seleziona i servizi che questo specialista può fornire ai clienti",
          confirmClearAllDeleted: "Sei sicuro di voler eliminare tutti i clienti dal cestino? Questa azione non può essere annullata.",
    
          setSchedule: "Imposta agenda",
          setWorkingHours: "Imposta orario di lavoro",
          setworkinghoursfor: "Imposta orario di lavoro per",
          startTime: "Ora di inizio",
          endTime: "Ora di fine",
          monday: "Lunedì",
          tuesday: "Martedì",
          wednesday: "Mercoledì",
          thursday: "Giovedì",
          friday: "Venerdì",
          saturday: "Sabato",
          sunday: "Domenica"
        },
        auth: {
          login: {
            title: "Accedi",
            invalidCredentials: "Email o password non validi",
            forgotPassword: "Password dimenticata?",
            noAccount: "Non hai un account?",
            registerHere: "Registrati qui"
          },
          register: {
            title: "Registrazione",
            success: "Registrazione completata",
            haveAccount: "Hai già un account?",
            loginHere: "Accedi qui",
            asClient: "Registrati come cliente",
            asSpecialist: "Registrati come specialista",
            waitingApproval: "Registrazione completata. In attesa di approvazione dall'amministratore."
          }
        },
        booking: {
          steps: {
            selectService: "Seleziona servizio",
            selectSpecialist: "Seleziona specialista",
            selectDateTime: "Seleziona data e ora",
            confirmation: "Conferma"
          },
          services: {
            title: "Seleziona servizio",
            duration: "Durata",
            price: "Prezzo"
          },
          specialists: {
            title: "Seleziona specialista",
            availability: "Disponibilità",
            noAvailability: "Nessuna disponibilità"
          },
          datetime: {
            title: "Seleziona data e ora",
            availableSlots: "Slot disponibili",
            noSlots: "Nessuno slot disponibile per questa data"
          },
          confirmation: {
            title: "Conferma prenotazione",
            details: "Dettagli prenotazione",
            service: "Servizio",
            specialist: "Specialista",
            dateTime: "Data e ora",
            clientInfo: "Le tue informazioni",
            confirming: "Conferma in corso...",
            confirmBooking: "Conferma prenotazione",
            error: "Errore nella creazione della prenotazione"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Appuntamenti",
            clients: "Clienti",
            services: "Servizi",
            specialists: "Specialisti",
            settings: "Impostazioni",
            products: "Prodotti"

          },
          appointments: {
            title: "Appuntamenti",
            upcoming: "In arrivo",
            past: "Passati",
            datetime: "Data e ora",
            client: "Cliente",
            service: "Servizio",
            specialist: "Specialista",
            duration: "Durata",
            deleteConfirm: "Sei sicuro di voler eliminare questo appuntamento?",
            status: {
              pending: "In attesa",
              confirmed: "Confermato",
              cancelled: "Annullato",
              completed: "Completato"
            },
            actions: {
              confirm: "Conferma",
              cancel: "Annulla",
              reschedule: "Riprogramma"
            }
          },
          clients: {
            title: "Clienti",
            addNew: "Aggiungi nuovo cliente",
            management: "Gestione clienti",
            details: "Dettagli cliente",
            history: "Storico cliente",
            status: {
              new: "Nuovo",
              regular: "Regolare",
              former: "Precedente",
              deleted: "Eliminato"
            },
            tabs: {
              new: "Nuovi",
              regular: "Regolari",
              former: "Precedenti",
              deleted: "Eliminati"
            }
          },
          services: {
            title: "Servizi",
            addNew: "Aggiungi nuovo servizio",
            editService: "Modifica servizio",
            fields: {
              name: "Nome servizio",
              duration: "Durata",
              price: "Prezzo"
            }
          },
          specialists: {
            title: "Specialisti",
            addNew: "Aggiungi nuovo specialista",
            management: "Gestione specialisti",
            schedule: "Orario di lavoro",
            services: "Servizi disponibili",
            status: {
              pending: "In attesa di approvazione",
              approved: "Approvato",
              rejected: "Rifiutato"
            }
          },
          settings: {
            title: "Impostazioni",
            profile: "Impostazioni profilo",
            account: "Impostazioni account",
            password: "Cambia password",
            fields: {
              currentPassword: "Password attuale",
              newPassword: "Nuova password",
              confirmPassword: "Conferma password"
            }
          }
        },
        settings: {
          tabAndColumnVisibility: "Visibilità delle schede e delle colonne",
          tabOrder: "Ordine delle schede",
          hiddenTabs: "Schede nascoste",
          clientColumns: "Colonne cliente",      
          crmSettings: "Impostazioni CRM",
          promoText: "Testo promozionale",
          headerTitle: "Titolo",
          headerSubtitle: "Descrizione",
          defaultLanguage: "Lingua predefinita",
          currency: "Valuta",
          currencyPosition: "Posizione valuta",
          currencyRight: "Destra",
          currencyLeft: "Sinistra",
          hideAppointments: "Nascondi scheda 'Appuntamenti'",
          hideSpecialists: "Nascondi scheda 'Specialisti'",
          hideServices: "Nascondi scheda 'Servizi'",
          hideClients: "Nascondi scheda 'Clienti'",
          hideProducts: "Nascondi scheda 'Prodotti'",
          tabsSaved: "Impostazioni schede salvate",
          errorFetching: "Errore durante il caricamento delle impostazioni",
          errorSaving: "Errore durante il salvataggio delle impostazioni",
          tabsDescription: "Configura l'aspetto e il comportamento delle schede",
          tabVisibility: "Alterna la visibilità delle schede",
          configureTabs: "Regola le impostazioni delle schede"
 
         },
         products: {
          import: {
            steps: {
              upload: "Carica",
              map: "Mappa",
              import: "Importa"
            },
            selectfile: "Seleziona file",
            guide: "Per importare i prodotti: 1) Crea un file Excel con colonne per i dati del prodotto 2) La prima riga deve contenere i nomi delle colonne 3) Ogni riga rappresenta un prodotto 4) Campo obbligatorio: Nome del prodotto 5) L'assegnazione delle colonne predefinita è impostata su A1, B1, ecc.",
            guideTitle: "Istruzioni per l'importazione",
          },      
          defaultcategory: "Predefinito",
          title: "Gestione prodotti",
          addNew: "Aggiungi nuovo prodotto",
          edit: "Modifica prodotto",
          create: "Crea prodotto",
          name: "Nome",
          category: "Categoria",
          price: "Prezzo",
          costPrice: "Costo",
          warehouseName: "Nome magazzino",
          warehouseAddress: "Indirizzo magazzino",
          articleNumber: "Codice prodotto",
          unit: "Unità",
          weight: "Peso",
          length: "Lunghezza",
          width: "Larghezza",
          height: "Altezza",
          stock: "Scorte",
          responsibleEmployee: "Dipendente responsabile",
          dimensions: "Dimensioni",
          warehouse: "Magazzino",
          deleteTitle: "Elimina prodotto",
          deleteConfirm: "Sei sicuro di voler eliminare il prodotto {{name}}?",
          units: {
            piece: "Pezzo",
            kg: "Chilogrammo",
            package: "Confezione"
          }
         }

      }
    },


    ko: {
      translation: {
        common: {
          nazvanie: "이름",
          maxprice: "최대 가격",
          category: "카테고리",
          title: "제목",
          addnew: "새로 추가",
          projectType: "프로젝트 유형",
          history: "역사",
          assignSpecialists: "전문가 할당",
          uploadSpecialistPhoto: "전문가 사진 업로드",
          selectimage: "이미지 선택",
          upload: "업로드",
          anySpecialist: "어떤 전문가라도",
          allServices: "모든 서비스",      
          minutes: "분",
          add: "추가",
          edit: "수정",
          delete: "삭제",
          save: "저장",
          cancel: "취소",
          confirm: "확인",
          back: "뒤로",
          next: "다음",
          min: "분",
          login: "로그인",
          register: "회원가입",
          logout: "로그아웃",
          email: "이메일",
          password: "비밀번호",
          phone: "전화번호",
          name: "이름",
          actions: "작업",
          optional: "선택사항",
          telegram: "텔레그램",
          instagram: "인스타그램",
          status: "상태",
          savechanges: "변경사항 저장",
          changespecialist: "전문가 변경",
          past: "지난",
          ongoing: "진행중",
          upcoming: "예정",
          future: "미래",
          specialist: "전문가",
          errorApproving: "승인 오류",
          errorRejecting: "거절 오류",
          errorSaving: "저장 오류",
          specialists: "전문가 목록",
          schedule: "일정",
          services: "서비스 목록",
          service: "서비스",
          pendingApprovals: "승인 대기",
          activeSpecialists: "활동중인 전문가",
          approve: "승인",
          reject: "거절",
          namecompany: "이름/회사",
          firstcontact: "첫 연락",
          contacts: "연락처",
          projectstatus: "프로젝트 상태",
          createdby: "작성자",
          assignedto: "담당자",
          clearalldeleted: "삭제된 항목 모두 지우기",
          dashboard: "대시보드",
          editservices: "서비스 수정",
          setschedule: "일정 설정",
          website: "웹사이트",
          new: "신규",
          regular: "일반",
          former: "이전",
          deleted: "삭제됨",
          clientstatus: "고객 상태",
          address: "주소",
          assignspecialiststo: "전문가 배정",
          discussion: "논의",
          firstcontactdate: "첫 연락일",
          projecttype: "프로젝트 유형",
          projectdescription: "프로젝트 설명",
          technicaldetails: "기술 세부사항",
          budget: "예산",
          contacted: "연락됨",
          unreachable: "연락 불가",
          negotiating: "협상중",
          meeting: "미팅",
          development: "개발중",
          completed: "완료",
          telegramoptional: "텔레그램 (선택사항)",
          instagramoptional: "인스타그램 (선택사항)",
          alreadyhaveanaccount: "이미 계정이 있으신가요? 로그인",
          myappointments: "내 예약",
          myclients: "내 고객",
          settings: "설정",
          profilesettings: "프로필 설정",
          saveprofilechanges: "프로필 변경사항 저장",
          changepassword: "비밀번호 변경",
          currentpassword: "현재 비밀번호",
          newpassword: "새 비밀번호",
          confirmnewpassword: "새 비밀번호 확인",
          deleteaccount: "계정 삭제",
          accountsettings: "계정 설정",
          saveschedule: "일정 저장",
          starttime: "시작 시간",
          endtime: "종료 시간",
          addnewclient: "새 고객 추가",
          editclient: "고객 수정",
          newclient: "새 고객",
          export: "내보내기",
          import: "가져오기",
          saving: "저장 중...",
          role: "역할",
          editRole: "역할 편집",
          changeRole: "역할 변경",
          specialistRoleDescription: "특수 작업 및 프로젝트 데이터에 대한 접근",
          adminRoleDescription: "설정 및 사용자 관리에 대한 전체 접근",
          superadmin: "Aunimeda 기술 지원",
          admin: "관리자",
          noServicesSelected: "선택된 서비스 없음",
          none: "없음",
          create: "생성",  
    
          projectStatus: {
            discussion: "논의",
            contacted: "연락됨",
            unreachable: "연락 불가",
            negotiating: "협상중",
            meeting: "미팅",
            development: "개발중",
            completed: "완료"
          },
    
          assignedspecialists: "배정된 전문가",
          visibletoallspecialists: "모든 전문가에게 공개",
          allspecialists: "전체 전문가",
          createclient: "고객 생성",
          client: "고객",
          selectservices: "서비스 선택",
          selectspecialist: "전문가 선택",
          selectdateandtime: "날짜 및 시간 선택",
          confirmbooking: "예약 확인",
          selectall: "전체 선택",
          editservicesfor: "서비스 수정",
          clearall: "모두 지우기",
          duration: "소요시간",
          price: "가격",
          selected: "선택됨",
          saveservices: "서비스 저장",
          selectservicesthisspecialistcanprovidetoclients: "이 전문가가 고객에게 제공할 수 있는 서비스 선택",
          confirmClearAllDeleted: "삭제된 폴더의 모든 고객을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
    
          setSchedule: "일정 설정",
          setWorkingHours: "근무 시간 설정",
          setworkinghoursfor: "근무 시간 설정",
          startTime: "시작 시간",
          endTime: "종료 시간",
          monday: "월요일",
          tuesday: "화요일",
          wednesday: "수요일",
          thursday: "목요일",
          friday: "금요일",
          saturday: "토요일",
          sunday: "일요일"
        },
        auth: {
          login: {
            title: "로그인",
            invalidCredentials: "잘못된 이메일 또는 비밀번호",
            forgotPassword: "비밀번호를 잊으셨나요?",
            noAccount: "계정이 없으신가요?",
            registerHere: "여기서 가입하세요"
          },
          register: {
            title: "회원가입",
            success: "회원가입 성공",
            haveAccount: "이미 계정이 있으신가요?",
            loginHere: "여기서 로그인하세요",
            asClient: "고객으로 가입",
            asSpecialist: "전문가로 가입",
            waitingApproval: "회원가입이 완료되었습니다. 관리자 승인을 기다리고 있습니다."
          }
        },
        booking: {
          steps: {
            selectService: "서비스 선택",
            selectSpecialist: "전문가 선택",
            selectDateTime: "날짜 및 시간 선택",
            confirmation: "확인"
          },
          services: {
            title: "서비스 선택",
            duration: "소요시간",
            price: "가격"
          },
          specialists: {
            title: "전문가 선택",
            availability: "예약 가능 시간",
            noAvailability: "예약 가능한 시간이 없습니다"
          },
          datetime: {
            title: "날짜 및 시간 선택",
            availableSlots: "예약 가능 시간",
            noSlots: "해당 날짜에 예약 가능한 시간이 없습니다"
          },
          confirmation: {
            title: "예약 확인",
            details: "예약 상세",
            service: "서비스",
            specialist: "전문가",
            dateTime: "날짜 및 시간",
            clientInfo: "고객 정보",
            confirming: "확인 중...",
            confirmBooking: "예약 확정",
            error: "예약 생성 중 오류가 발생했습니다"
          }
        },
        dashboard: {
          tabs: {
            appointments: "예약",
            clients: "고객",
            services: "서비스",
            specialists: "전문가",
            settings: "설정",
            products: "제품"

          },
          appointments: {
            title: "예약",
            upcoming: "예정된",
            past: "지난",
            datetime: "날짜 및 시간",
            client: "고객",
            service: "서비스",
            specialist: "전문가",
            duration: "소요시간",
            deleteConfirm: "이 예약을 삭제하시겠습니까?",
            status: {
              pending: "대기중",
              confirmed: "확정됨",
              cancelled: "취소됨",
              completed: "완료됨"
            },
            actions: {
              confirm: "확정",
              cancel: "취소",
              reschedule: "일정 변경"
            }
          },
          clients: {
            title: "고객",
            addNew: "새 고객 추가",
            management: "고객 관리",
            details: "고객 상세",
            history: "고객 이력",
            status: {
              new: "신규",
              regular: "일반",
              former: "이전",
              deleted: "삭제됨"
            },
            tabs: {
              new: "신규",
              regular: "일반",
              former: "이전",
              deleted: "삭제됨"
            }
          },
          services: {
            title: "서비스",
            addNew: "새 서비스 추가",
            editService: "서비스 수정",
            fields: {
              name: "서비스명",
              duration: "소요시간",
              price: "가격"
            }
          },
          specialists: {
            title: "전문가",
            addNew: "새 전문가 추가",
            management: "전문가 관리",
            schedule: "근무 시간",
            services: "제공 가능 서비스",
            status: {
              pending: "승인 대기중",
              approved: "승인됨",
              rejected: "거절됨"
            }
          },
          settings: {
            title: "설정",
            profile: "프로필 설정",
            account: "계정 설정",
            password: "비밀번호 변경",
            fields: {
              currentPassword: "현재 비밀번호",
              newPassword: "새 비밀번호",
              confirmPassword: "비밀번호 확인"
            }
          }
        },

        settings: {
          tabAndColumnVisibility: "탭 및 열 가시성",
          tabOrder: "탭 순서",
          hiddenTabs: "숨겨진 탭",
          clientColumns: "클라이언트 열",  
          crmSettings: "CRM 설정",
          promoText: "프로모션 텍스트",
          headerTitle: "제목",
          headerSubtitle: "설명",
          defaultLanguage: "기본 언어",
          currency: "통화",
          currencyPosition: "통화 위치",
          currencyRight: "오른쪽",
          currencyLeft: "왼쪽",
          hideAppointments: "'예약' 탭 숨기기",
          hideSpecialists: "'전문가' 탭 숨기기",
          hideServices: "'서비스' 탭 숨기기",
          hideClients: "'고객' 탭 숨기기",
          hideProducts: "'제품' 탭 숨기기",
          tabsSaved: "탭 설정이 저장되었습니다",
          errorFetching: "설정 로드 중 오류",
          errorSaving: "설정 저장 중 오류",
          tabsDescription: "탭의 모양과 동작을 구성합니다",
          tabVisibility: "탭의 가시성을 전환합니다",
          configureTabs: "탭 설정을 조정합니다"
  
         },
         products: {
          import: {
            steps: {
              upload: "업로드",
              map: "매핑",
              import: "가져오기"
            },
            selectfile: "파일 선택",
            guide: "제품을 가져오려면: 1) 제품 데이터가 포함된 Excel 파일을 작성 2) 첫 번째 행은 열 이름을 포함해야 함 3) 각 행은 하나의 제품을 나타냄 4) 필수 필드: 제품 이름 5) 기본 열 할당은 A1, B1 등에 설정됨.",
            guideTitle: "가져오기 지침"
          },  
          defaultcategory: "기본",
          title: "제품 관리",
          addNew: "새 제품 추가",
          edit: "제품 편집",
          create: "제품 생성",
          name: "이름",
          category: "카테고리",
          price: "가격",
          costPrice: "비용",
          warehouseName: "창고 이름",
          warehouseAddress: "창고 주소",
          articleNumber: "제품 코드",
          unit: "단위",
          weight: "무게",
          length: "길이",
          width: "너비",
          height: "높이",
          stock: "재고",
          responsibleEmployee: "담당 직원",
          dimensions: "치수",
          warehouse: "창고",
          deleteTitle: "제품 삭제",
          deleteConfirm: "정말 {{name}} 제품을 삭제하시겠습니까?",
          units: {
            piece: "개",
            kg: "킬로그램",
            package: "패키지"
          }
         }
      }
    },


    ar: {
      translation: {
        common: {
          nazvanie: "اسم",
          maxprice: "السعر الأقصى",
          category: "فئة",
          title: "عنوان",
          addnew: "إضافة جديد",
          projectType: "نوع المشروع",
          history: "تاريخ",
          assignSpecialists: "تعيين المتخصصين",
          uploadSpecialistPhoto: "تحميل صورة المتخصص",
          selectimage: "اختر صورة",
          upload: "تحميل",
          anySpecialist: "أي متخصص",
          allServices: "جميع الخدمات",      
          minutes: "دقيقة",
          add: "إضافة",
          edit: "تعديل",
          delete: "حذف",
          save: "حفظ",
          cancel: "إلغاء",
          confirm: "تأكيد",
          back: "رجوع",
          next: "التالي",
          min: "دقيقة",
          login: "تسجيل الدخول",
          register: "تسجيل",
          logout: "تسجيل الخروج",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          phone: "الهاتف",
          name: "الاسم",
          actions: "الإجراءات",
          optional: "اختياري",
          telegram: "تيليجرام",
          instagram: "انستغرام",
          status: "الحالة",
          savechanges: "حفظ التغييرات",
          changespecialist: "تغيير المتخصص",
          past: "سابق",
          ongoing: "جاري",
          upcoming: "قادم",
          future: "مستقبلي",
          specialist: "متخصص",
          errorApproving: "خطأ في الموافقة",
          errorRejecting: "خطأ في الرفض",
          errorSaving: "خطأ في الحفظ",
          specialists: "المتخصصون",
          schedule: "الجدول",
          services: "الخدمات",
          service: "الخدمة",
          pendingApprovals: "موافقات معلقة",
          activeSpecialists: "المتخصصون النشطون",
          approve: "موافقة",
          reject: "رفض",
          namecompany: "الاسم/الشركة",
          firstcontact: "أول اتصال",
          contacts: "جهات الاتصال",
          projectstatus: "حالة المشروع",
          createdby: "أنشئ بواسطة",
          assignedto: "مُسند إلى",
          clearalldeleted: "مسح كل المحذوفات",
          dashboard: "لوحة التحكم",
          editservices: "تعديل الخدمات",
          setschedule: "تعيين الجدول",
          website: "الموقع الإلكتروني",
          new: "جديد",
          regular: "منتظم",
          former: "سابق",
          deleted: "محذوف",
          clientstatus: "حالة العميل",
          address: "العنوان",
          assignspecialiststo: "تعيين متخصصين لـ",
          discussion: "مناقشة",
          firstcontactdate: "تاريخ أول اتصال",
          projecttype: "نوع المشروع",
          projectdescription: "وصف المشروع",
          technicaldetails: "التفاصيل التقنية",
          budget: "الميزانية",
          contacted: "تم الاتصال",
          unreachable: "غير متاح",
          negotiating: "قيد التفاوض",
          meeting: "اجتماع",
          development: "تطوير",
          completed: "مكتمل",
          telegramoptional: "تيليجرام (اختياري)",
          instagramoptional: "انستغرام (اختياري)",
          alreadyhaveanaccount: "لديك حساب بالفعل؟ تسجيل الدخول",
          myappointments: "مواعيدي",
          myclients: "عملائي",
          settings: "الإعدادات",
          profilesettings: "إعدادات الملف الشخصي",
          saveprofilechanges: "حفظ تغييرات الملف الشخصي",
          changepassword: "تغيير كلمة المرور",
          currentpassword: "كلمة المرور الحالية",
          newpassword: "كلمة المرور الجديدة",
          confirmnewpassword: "تأكيد كلمة المرور الجديدة",
          deleteaccount: "حذف الحساب",
          accountsettings: "إعدادات الحساب",
          saveschedule: "حفظ الجدول",
          starttime: "وقت البدء",
          endtime: "وقت الانتهاء",
          addnewclient: "إضافة عميل جديد",
          editclient: "تعديل العميل",
          newclient: "عميل جديد",
          export: "تصدير",
          import: "استيراد",
          saving: "جاري الحفظ...",
          role: "دور",
          editRole: "تحرير الدور",
          changeRole: "تغيير الدور",
          specialistRoleDescription: "الوصول إلى المهام الخاصة وبيانات المشروع",
          adminRoleDescription: "وصول كامل للإعدادات وإدارة المستخدمين",
          superadmin: "الدعم الفني Aunimeda",
          admin: "مسؤول",
          noServicesSelected: "لم يتم اختيار أي خدمات",
          none: "لا شيء",
          create: "إنشاء",  
    
          projectStatus: {
            discussion: "مناقشة",
            contacted: "تم الاتصال",
            unreachable: "غير متاح",
            negotiating: "قيد التفاوض",
            meeting: "اجتماع",
            development: "تطوير",
            completed: "مكتمل"
          },
    
          assignedspecialists: "المتخصصون المعينون",
          visibletoallspecialists: "مرئي لجميع المتخصصين",
          allspecialists: "جميع المتخصصين",
          createclient: "إنشاء عميل",
          client: "عميل",
          selectservices: "اختيار الخدمات",
          selectspecialist: "اختيار متخصص",
          selectdateandtime: "اختيار التاريخ والوقت",
          confirmbooking: "تأكيد الحجز",
          selectall: "اختيار الكل",
          editservicesfor: "تعديل الخدمات لـ",
          clearall: "مسح الكل",
          duration: "المدة",
          price: "السعر",
          selected: "مختار",
          saveservices: "حفظ الخدمات",
          selectservicesthisspecialistcanprovidetoclients: "اختر الخدمات التي يمكن لهذا المتخصص تقديمها للعملاء",
          confirmClearAllDeleted: "هل أنت متأكد من أنك تريد حذف جميع العملاء من مجلد المحذوفات؟ لا يمكن التراجع عن هذا الإجراء.",
    
          setSchedule: "تعيين الجدول",
          setWorkingHours: "تعيين ساعات العمل",
          setworkinghoursfor: "تعيين ساعات العمل لـ",
          startTime: "وقت البدء",
          endTime: "وقت الانتهاء",
          monday: "الاثنين",
          tuesday: "الثلاثاء",
          wednesday: "الأربعاء",
          thursday: "الخميس",
          friday: "الجمعة",
          saturday: "السبت",
          sunday: "الأحد"
        },
        auth: {
          login: {
            title: "تسجيل الدخول",
            invalidCredentials: "بريد إلكتروني أو كلمة مرور غير صحيحة",
            forgotPassword: "نسيت كلمة المرور؟",
            noAccount: "ليس لديك حساب؟",
            registerHere: "سجل هنا"
          },
          register: {
            title: "تسجيل",
            success: "تم التسجيل بنجاح",
            haveAccount: "لديك حساب بالفعل؟",
            loginHere: "سجل الدخول هنا",
            asClient: "التسجيل كعميل",
            asSpecialist: "التسجيل كمتخصص",
            waitingApproval: "تم التسجيل بنجاح. في انتظار موافقة المسؤول."
          }
        },
        booking: {
          steps: {
            selectService: "اختيار الخدمة",
            selectSpecialist: "اختيار المتخصص",
            selectDateTime: "اختيار التاريخ والوقت",
            confirmation: "التأكيد"
          },
          services: {
            title: "اختر خدمة",
            duration: "المدة",
            price: "السعر"
          },
          specialists: {
            title: "اختر متخصصاً",
            availability: "الأوقات المتاحة",
            noAvailability: "لا توجد مواعيد متاحة"
          },
          datetime: {
            title: "اختر التاريخ والوقت",
            availableSlots: "المواعيد المتاحة",
            noSlots: "لا توجد مواعيد متاحة لهذا التاريخ"
          },
          confirmation: {
            title: "تأكيد الحجز",
            details: "تفاصيل الحجز",
            service: "الخدمة",
            specialist: "المتخصص",
            dateTime: "التاريخ والوقت",
            clientInfo: "معلوماتك",
            confirming: "جاري التأكيد...",
            confirmBooking: "تأكيد الحجز",
            error: "حدث خطأ في إنشاء الحجز"
          }
        },
        dashboard: {
          tabs: {
            appointments: "المواعيد",
            clients: "العملاء",
            services: "الخدمات",
            specialists: "المتخصصون",
            settings: "الإعدادات",
            products: "المنتجات"

          },
          appointments: {
            title: "المواعيد",
            upcoming: "القادمة",
            past: "السابقة",
            datetime: "التاريخ والوقت",
            client: "العميل",
            service: "الخدمة",
            specialist: "المتخصص",
            duration: "المدة",
            deleteConfirm: "هل أنت متأكد من أنك تريد حذف هذا الموعد؟",
            status: {
              pending: "معلق",
              confirmed: "مؤكد",
              cancelled: "ملغي",
              completed: "مكتمل"
            },
            actions: {
              confirm: "تأكيد",
              cancel: "إلغاء",
              reschedule: "إعادة جدولة"
            }
          },
          clients: {
            title: "العملاء",
            addNew: "إضافة عميل جديد",
            management: "إدارة العملاء",
            details: "تفاصيل العميل",
            history: "سجل العميل",
            status: {
              new: "جديد",
              regular: "منتظم",
              former: "سابق",
              deleted: "محذوف"
            },
            tabs: {
              new: "جديد",
              regular: "منتظم",
              former: "سابق",
              deleted: "محذوف"
            }
          },
          services: {
            title: "الخدمات",
            addNew: "إضافة خدمة جديدة",
            editService: "تعديل الخدمة",
            fields: {
              name: "اسم الخدمة",
              duration: "المدة",
              price: "السعر"
            }
          },
          specialists: {
            title: "المتخصصون",
            addNew: "إضافة متخصص جديد",
            management: "إدارة المتخصصين",
            schedule: "جدول العمل",
            services: "الخدمات المتاحة",
            status: {
              pending: "في انتظار الموافقة",
              approved: "تمت الموافقة",
              rejected: "مرفوض"
            }
          },
          settings: {
            title: "الإعدادات",
            profile: "إعدادات الملف الشخصي",
            account: "إعدادات الحساب",
            password: "تغيير كلمة المرور",
            fields: {
              currentPassword: "كلمة المرور الحالية",
              newPassword: "كلمة المرور الجديدة",
              confirmPassword: "تأكيد كلمة المرور"
            }
          }
        },

        settings: {
          tabAndColumnVisibility: "رؤية علامات التبويب والأعمدة",
          tabOrder: "ترتيب علامات التبويب",
          hiddenTabs: "علامات التبويب المخفية",
          clientColumns: "أعمدة العميل",      
          crmSettings: "إعدادات CRM",
          promoText: "نص ترويجي",
          headerTitle: "العنوان",
          headerSubtitle: "الوصف",
          defaultLanguage: "اللغة الافتراضية",
          currency: "العملة",
          currencyPosition: "موقع العملة",
          currencyRight: "يمين",
          currencyLeft: "يسار",
          hideAppointments: "إخفاء علامة التبويب 'المواعيد'",
          hideSpecialists: "إخفاء علامة التبويب 'المتخصصين'",
          hideServices: "إخفاء علامة التبويب 'الخدمات'",
          hideClients: "إخفاء علامة التبويب 'العملاء'",
          hideProducts: "إخفاء علامة التبويب 'المنتجات'",
          tabsSaved: "تم حفظ إعدادات علامات التبويب",
          errorFetching: "خطأ في تحميل الإعدادات",
          errorSaving: "خطأ في حفظ الإعدادات",
          tabsDescription: "قم بتكوين مظهر وسلوك التبويبات",
          tabVisibility: "التبديل بين رؤية التبويبات",
          configureTabs: "ضبط إعدادات التبويبات"
  
         },
         products: {
          import: {
            steps: {
              upload: "تحميل",
              map: "خريطة",
              import: "استيراد"
            },
            selectfile: "اختر ملف",
            guide: "لاستيراد المنتجات: 1) قم بإنشاء ملف Excel يحتوي على أعمدة لبيانات المنتج 2) يجب أن تحتوي الصف الأول على أسماء الأعمدة 3) كل صف يمثل منتجًا 4) حقل إلزامي: اسم المنتج 5) التعيين الافتراضي للأعمدة يتم تعيينه إلى A1, B1, إلخ.",
            guideTitle: "إرشادات الاستيراد"
          },  
          defaultcategory: "افتراضي",
          title: "إدارة المنتجات",
          addNew: "إضافة منتج جديد",
          edit: "تحرير المنتج",
          create: "إنشاء منتج",
          name: "الاسم",
          category: "الفئة",
          price: "السعر",
          costPrice: "التكلفة",
          warehouseName: "اسم المستودع",
          warehouseAddress: "عنوان المستودع",
          articleNumber: "كود المنتج",
          unit: "الوحدة",
          weight: "الوزن",
          length: "الطول",
          width: "العرض",
          height: "الارتفاع",
          stock: "المخزون",
          responsibleEmployee: "الموظف المسؤول",
          dimensions: "الأبعاد",
          warehouse: "المستودع",
          deleteTitle: "حذف المنتج",
          deleteConfirm: "هل أنت متأكد من رغبتك في حذف المنتج {{name}}؟",
          units: {
            piece: "قطعة",
            kg: "كيلوغرام",
            package: "حزمة"
          }
         }  
      }
    },


    tj: {
      translation: {
        common: {
          nazvanie: "Ном",
          maxprice: "Нархи максималӣ",
          category: "Категория",
          title: "Сарлавҳа",
          addnew: "Иловаи нав",
          projectType: "Намуди лоиҳа",
          history: "Таърих",
          assignSpecialists: "Таъйин кардани мутахассисон",
          uploadSpecialistPhoto: "Бор кардани акси мутахассис",
          selectimage: "Интихоби тасвир",
          upload: "Боркунӣ",
          anySpecialist: "Ҳар мутахассис",
          allServices: "Ҳамаи хизматрасониҳо",      
          minutes: "дақиқа",
          deleted: "Дур",
          add: "Илова кардан",
          edit: "Таҳрир кардан",
          delete: "Нест кардан",
          save: "Нигоҳ доштан",
          cancel: "Бекор кардан",
          confirm: "Тасдиқ кардан",
          back: "Бозгашт",
          next: "Навбатӣ",
          min: "дақ",
          login: "Воридшавӣ",
          register: "Бақайдгирӣ",
          logout: "Баромадан",
          email: "Email",
          password: "Рамз",
          phone: "Телефон",
          name: "Ном",
          actions: "Амалҳо",
          optional: "ихтиёрӣ",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Ҳолат",
          savechanges: "Нигоҳ доштани тағйирот",
          changespecialist: "Иваз кардани мутахассис",
          past: "Гузашта",
          ongoing: "Ҷорӣ",
          upcoming: "Оянда",
          future: "Оянда",
          specialist: "Мутахассис",
          errorApproving: "Хатои тасдиқ",
          errorRejecting: "Хатои рад кардан",
          errorSaving: "Хатои нигоҳдорӣ",
          specialists: "Мутахассисон",
          schedule: "Ҷадвал",
          services: "Хизматҳо",
          service: "Хизмат",
          pendingApprovals: "Дар ҳоли баррасӣ",
          activeSpecialists: "Мутахассисони фаъол",
          approve: "Тасдиқ кардан",
          reject: "Рад кардан",
          namecompany: "Ном/Ширкат",
          firstcontact: "Тамоси аввал",
          contacts: "Тамосҳо",
          projectstatus: "Ҳолати лоиҳа",
          createdby: "Эҷодкунанда",
          assignedto: "Таъин шудааст ба",
          clearalldeleted: "Тоза кардани ҳамаи нестшуда",
          dashboard: "Лавҳаи идоракунӣ",
          editservices: "Таҳрири хизматҳо",
          setschedule: "Танзими ҷадвал",
          website: "Вебсайт",
          new: "Нав",
          regular: "Доимӣ",
          former: "Собиқ",
          clientstatus: "Ҳолати муштарӣ",
          address: "Суроға",
          assignspecialiststo: "Таъини мутахассисон ба",
          discussion: "Муҳокима",
          firstcontactdate: "Санаи тамоси аввал",
          projecttype: "Навъи лоиҳа",
          projectdescription: "Тавсифи лоиҳа",
          technicaldetails: "Ҷузъиёти техникӣ",
          budget: "Буҷет",
          contacted: "Тамос гирифта шуд",
          unreachable: "Дастрас нест",
          negotiating: "Музокира",
          meeting: "Вохӯрӣ",
          development: "Коркард",
          completed: "Анҷомёфта",
          telegramoptional: "Telegram (ихтиёрӣ)",
          instagramoptional: "Instagram (ихтиёрӣ)",
          alreadyhaveanaccount: "Аллакай ҳисоб доред? Воридшавӣ",
          myappointments: "Мулоқотҳои ман",
          myclients: "Муштариёни ман",
          settings: "Танзимот",
          profilesettings: "Танзимоти профил",
          saveprofilechanges: "Нигоҳ доштани тағйироти профил",
          changepassword: "Иваз кардани рамз",
          currentpassword: "Рамзи ҷорӣ",
          newpassword: "Рамзи нав",
          confirmnewpassword: "Тасдиқи рамзи нав",
          deleteaccount: "Нест кардани ҳисоб",
          accountsettings: "Танзимоти ҳисоб",
          saveschedule: "Нигоҳ доштани ҷадвал",
          starttime: "Вақти оғоз",
          endtime: "Вақти анҷом",
          addnewclient: "Илова кардани муштарии нав",
          editclient: "Таҳрири муштарӣ",
          newclient: "Муштарии нав",
          export: "Содир кардан",
          import: "Ворид кардан",
          saving: "Захира шуда истодааст...",
          role: "Нақш",
          editRole: "Таҳрири нақш",
          changeRole: "Иваз кардани нақш",
          specialistRoleDescription: "Дастрасӣ ба вазифаҳои махсус ва додаҳои лоиҳа",
          adminRoleDescription: "Дастрасии пурра ба танзимот ва идораи корбарон",
          superadmin: "Дастгирии техникии Aunimeda",
          admin: "Маъмур",
          noServicesSelected: "Хизматрасониҳо интихоб нашудаанд",
          none: "Ягона",
          create: "Эҷод кардан",

    
          projectStatus: {
            discussion: "Муҳокима",
            contacted: "Тамос гирифта шуд",
            unreachable: "Дастрас нест",
            negotiating: "Музокира",
            meeting: "Вохӯрӣ",
            development: "Коркард",
            completed: "Анҷомёфта"
          },
    
          assignedspecialists: "Мутахассисони таъиншуда",
          visibletoallspecialists: "Барои ҳамаи мутахассисон намоён",
          allspecialists: "Ҳамаи мутахассисон",
          createclient: "Эҷоди муштарӣ",
          client: "Муштарӣ",
          selectservices: "Интихоби хизматҳо",
          selectspecialist: "Интихоби мутахассис",
          selectdateandtime: "Интихоби сана ва вақт",
          confirmbooking: "Тасдиқи банд кардан",
          selectall: "Интихоби ҳама",
          editservicesfor: "Таҳрири хизматҳо барои",
          clearall: "Тоза кардани ҳама",
          duration: "Давомнокӣ",
          price: "Нарх",
          selected: "Интихобшуда",
          saveservices: "Нигоҳ доштани хизматҳо",
          selectservicesthisspecialistcanprovidetoclients: "Интихоби хизматҳое, ки ин мутахассис метавонад ба муштариён пешниҳод кунад",
          confirmClearAllDeleted: "Оё мехоҳед ҳамаи муштариёнро аз папкаи нестшуда тоза кунед? Ин амалро бекор кардан ғайриимкон аст.",
    
          setSchedule: "Танзими ҷадвал",
          setWorkingHours: "Танзими соатҳои корӣ",
          setworkinghoursfor: "Танзими соатҳои корӣ барои",
          startTime: "Вақти оғоз",
          endTime: "Вақти анҷом",
          monday: "Душанбе",
          tuesday: "Сешанбе",
          wednesday: "Чоршанбе",
          thursday: "Панҷшанбе",
          friday: "Ҷумъа",
          saturday: "Шанбе",
          sunday: "Якшанбе"
        },
        auth: {
          login: {
            title: "Воридшавӣ",
            invalidCredentials: "Email ё рамзи нодуруст",
            forgotPassword: "Рамзро фаромӯш кардед?",
            noAccount: "Ҳисоб надоред?",
            registerHere: "Инҷо бақайд гиред"
          },
          register: {
            title: "Бақайдгирӣ",
            success: "Бақайдгирӣ бомуваффақият анҷом ёфт",
            haveAccount: "Аллакай ҳисоб доред?",
            loginHere: "Инҷо ворид шавед",
            asClient: "Бақайдгирӣ ҳамчун муштарӣ",
            asSpecialist: "Бақайдгирӣ ҳамчун мутахассис",
            waitingApproval: "Бақайдгирӣ бомуваффақият анҷом ёфт. Мунтазири тасдиқи маъмур."
          }
        },
        booking: {
          steps: {
            selectService: "Интихоби хизмат",
            selectSpecialist: "Интихоби мутахассис",
            selectDateTime: "Интихоби сана ва вақт",
            confirmation: "Тасдиқ"
          },
          services: {
            title: "Хизматро интихоб кунед",
            duration: "Давомнокӣ",
            price: "Нарх"
          },
          specialists: {
            title: "Мутахассисро интихоб кунед",
            availability: "Вақтҳои холӣ",
            noAvailability: "Вақтҳои холӣ нестанд"
          },
          datetime: {
            title: "Сана ва вақтро интихоб кунед",
            availableSlots: "Вақтҳои холӣ",
            noSlots: "Барои ин сана вақтҳои холӣ нестанд"
          },
          confirmation: {
            title: "Тасдиқи банд кардан",
            details: "Тафсилоти банд кардан",
            service: "Хизмат",
            specialist: "Мутахассис",
            dateTime: "Сана ва вақт",
            clientInfo: "Маълумоти шумо",
            confirming: "Тасдиқ шуда истодааст...",
            confirmBooking: "Тасдиқи банд кардан",
            error: "Хато ҳангоми эҷоди банд кардан"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Мулоқотҳо",
            clients: "Муштариён",
            services: "Хизматҳо",
            specialists: "Мутахассисон",
            settings: "Танзимот",
            products: "Маҳсулот"

          },
          appointments: {
            title: "Мулоқотҳо",
            upcoming: "Наздик",
            past: "Гузашта",
            datetime: "Сана ва вақт",
            client: "Муштарӣ",
            service: "Хизмат",
            specialist: "Мутахассис",
            duration: "Давомнокӣ",
            deleteConfirm: "Оё мехоҳед ин мулоқотро нест кунед?",
            status: {
              pending: "Дар ҳоли баррасӣ",
              confirmed: "Тасдиқшуда",
              cancelled: "Бекоршуда",
              completed: "Анҷомёфта"
            },
            actions: {
              confirm: "Тасдиқ",
              cancel: "Бекор кардан",
              reschedule: "Бозсозии вақт"
            }
          },
          clients: {
            title: "Муштариён",
            addNew: "Илова кардани муштарии нав",
            management: "Идоракунии муштариён",
            details: "Тафсилоти муштарӣ",
            history: "Таърихи муштарӣ",
            status: {
              new: "Нав",
              regular: "Доимӣ",
              former: "Собиқ",
              deleted: "Нестшуда"
            },
            tabs: {
              new: "Нав",
              regular: "Доимӣ",
              former: "Собиқ",
              deleted: "Нестшуда"
            }
          },
          services: {
            title: "Хизматҳо",
            addNew: "Илова кардани хизмати нав",
            editService: "Таҳрири хизмат",
            fields: {
              name: "Номи хизмат",
              duration: "Давомнокӣ",
              price: "Нарх"
            }
          },
          specialists: {
            title: "Мутахассисон",
            addNew: "Илова кардани мутахассиси нав",
            management: "Идоракунии мутахассисон",
            schedule: "Ҷадвали корӣ",
            services: "Хизматҳои дастрас",
            status: {
              pending: "Дар ҳоли баррасӣ",
              approved: "Тасдиқшуда",
              rejected: "Радшуда"
            }
          },
          settings: {
            title: "Танзимот",
            profile: "Танзимоти профил",
            account: "Танзимоти ҳисоб",
            password: "Иваз кардани рамз",
            fields: {
              currentPassword: "Рамзи ҷорӣ",
              newPassword: "Рамзи нав",
              confirmPassword: "Тасдиқи рамз"
            }
          }
        },
        settings: {
          tabAndColumnVisibility: "Намоёнӣ аз ҷадвалҳо ва сутунҳо",
          tabOrder: "Тартиби ҷадвалҳо",
          hiddenTabs: "Ҷадвалҳои пинҳоншуда",
          clientColumns: "Сутунҳои мизоҷ",      
          crmSettings: "Танзимоти CRM",
          promoText: "Матни таблиғотӣ",
          headerTitle: "Сарлавҳа",
          headerSubtitle: "Тавсиф",
          defaultLanguage: "Забони пешфарз",
          currency: "Асъор",
          currencyPosition: "Мавқеи асъор",
          currencyRight: "Рост",
          currencyLeft: "Чап",
          hideAppointments: "Пинҳон кардани варақаи 'Вохӯрӣ'",
          hideSpecialists: "Пинҳон кардани варақаи 'Мутахассисон'",
          hideServices: "Пинҳон кардани варақаи 'Хизматҳо'",
          hideClients: "Пинҳон кардани варақаи 'Муштариён'",
          hideProducts: "Пинҳон кардани варақаи 'Маҳсулот'",
          tabsSaved: "Танзимоти варақаҳо нигоҳ дошта шуд",
          errorFetching: "Хатогӣ ҳангоми боргирии танзимот",
          errorSaving: "Хатогӣ ҳангоми захираи танзимот",
          tabsDescription: "Маъзари ва рафтори табҳоро танзим кунед",
          tabVisibility: "Намоиш ё пӯшида кардани табҳоро иваз кунед",
          configureTabs: "Танзимоти табҳоро дуруст кунед"

  
         },
         products: {
          defaultcategory: "Пешфарз",

          import: {
            steps: {
              upload: "Боркунӣ",
              map: "Харита",
              import: "Воридот"
            },
            selectfile: "Интихоби файл",
            guide: "Барои ворид кардани маҳсулот: 1) Файли Excel бо сутунҳо барои маълумоти маҳсулот эҷод кунед 2) Сатри аввал бояд номҳои сутунҳоро дар бар гирад 3) Ҳар сатр як маҳсулотро ифода мекунад 4) Майдони ҳатмӣ: Номи маҳсулот 5) Танзими сутунҳои пешфарз ба A1, B1 ва ғайра муқаррар карда шудааст.",
            guideTitle: "Дастур оид ба воридот"
          },  
          title: "Идораи маҳсулот",
          addNew: "Илова кардани маҳсулоти нав",
          edit: "Таҳрири маҳсулот",
          create: "Эҷоди маҳсулот",
          name: "Ном",
          category: "Категория",
          price: "Нарх",
          costPrice: "Арзиш",
          warehouseName: "Номи анбор",
          warehouseAddress: "آдреси анбор",
          articleNumber: "Код маҳсулот",
          unit: "Воҳид",
          weight: "Вазн",
          length: "Дарозӣ",
          width: "Бараввазӣ",
          height: "Баландӣ",
          stock: "Захира",
          responsibleEmployee: "Корманди масъул",
          dimensions: "Андозаҳо",
          warehouse: "Анбор",
          deleteTitle: "Нест кардани маҳсулот",
          deleteConfirm: "Шумо мутмаин ҳастед, ки мехоҳед маҳсулоти {{name}}-ро нест кунед?",
          units: {
            piece: "Адад",
            kg: "Килограмм",
            package: "Бастаи молӣ"
          }
         }

      }
    },



    kz: {
      translation: {
        common: {
          nazvanie: "Аты",
          maxprice: "Ең жоғары баға",
          category: "Санат",
          title: "Тақырып",
          addnew: "Жаңа қосу",
          projectType: "Жоба түрі",
          history: "Тарих",
          assignSpecialists: "Мамандарды тағайындау",
          uploadSpecialistPhoto: "Маманның суретін жүктеу",
          selectimage: "Суретті таңдау",
          upload: "Жүктеу",
          anySpecialist: "Кез келген маман",
          allServices: "Барлық қызметтер",
          minutes: "минут",
          deleted: "Қашықтан",
          add: "Қосу",
          edit: "Өңдеу",
          delete: "Жою",
          save: "Сақтау",
          cancel: "Бас тарту",
          confirm: "Растау",
          back: "Артқа",
          next: "Келесі",
          min: "мин",
          login: "Кіру",
          register: "Тіркелу",
          logout: "Шығу",
          email: "Email",
          password: "Құпия сөз",
          phone: "Телефон",
          name: "Аты",
          actions: "Әрекеттер",
          optional: "міндетті емес",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Мәртебе",
          savechanges: "Өзгерістерді сақтау",
          changespecialist: "Маманды ауыстыру",
          past: "Өткен",
          ongoing: "Ағымдағы",
          upcoming: "Алдағы",
          future: "Болашақ",
          specialist: "Маман",
          errorApproving: "Бекітуде қате",
          errorRejecting: "Қабылдамауда қате",
          errorSaving: "Сақтауда қате",
          specialists: "Мамандар",
          schedule: "Кесте",
          services: "Қызметтер",
          service: "Қызмет",
          pendingApprovals: "Бекітуді күтуде",
          activeSpecialists: "Белсенді мамандар",
          approve: "Бекіту",
          reject: "Қабылдамау",
          namecompany: "Аты/Компания",
          firstcontact: "Алғашқы байланыс",
          contacts: "Байланыстар",
          projectstatus: "Жоба мәртебесі",
          createdby: "Құрған",
          assignedto: "Тағайындалған",
          clearalldeleted: "Барлық жойылғандарды тазалау",
          dashboard: "Басқару тақтасы",
          editservices: "Қызметтерді өңдеу",
          setschedule: "Кесте құру",
          website: "Веб-сайт",
          new: "Жаңа",
          regular: "Тұрақты",
          former: "Бұрынғы",
          clientstatus: "Клиент мәртебесі",
          address: "Мекенжай",
          assignspecialiststo: "Мамандарды тағайындау",
          discussion: "Талқылау",
          firstcontactdate: "Алғашқы байланыс күні",
          projecttype: "Жоба түрі",
          projectdescription: "Жоба сипаттамасы",
          technicaldetails: "Техникалық мәліметтер",
          budget: "Бюджет",
          contacted: "Байланысқан",
          unreachable: "Қол жетімсіз",
          negotiating: "Келіссөз жүргізуде",
          meeting: "Кездесу",
          development: "Әзірлеу",
          completed: "Аяқталды",
          telegramoptional: "Telegram (міндетті емес)",
          instagramoptional: "Instagram (міндетті емес)",
          alreadyhaveanaccount: "Тіркелгіңіз бар ма? Кіру",
          myappointments: "Менің жазылуларым",
          myclients: "Менің клиенттерім",
          settings: "Параметрлер",
          profilesettings: "Профиль параметрлері",
          saveprofilechanges: "Профиль өзгерістерін сақтау",
          changepassword: "Құпия сөзді өзгерту",
          currentpassword: "Ағымдағы құпия сөз",
          newpassword: "Жаңа құпия сөз",
          confirmnewpassword: "Жаңа құпия сөзді растау",
          deleteaccount: "Тіркелгіні жою",
          accountsettings: "Тіркелгі параметрлері",
          saveschedule: "Кестені сақтау",
          starttime: "Бастау уақыты",
          endtime: "Аяқтау уақыты",
          addnewclient: "Жаңа клиент қосу",
          editclient: "Клиентті өңдеу",
          newclient: "Жаңа клиент",
          export: "Экспорттау",
          import: "Импорттау",
          saving: "Сақталуда...",
          role: "Рөл",
          editRole: "Рөлді өңдеу",
          changeRole: "Рөлді өзгерту",
          specialistRoleDescription: "Арнайы тапсырмалар мен жоба деректеріне қол жеткізу",
          adminRoleDescription: "Параметрлер мен пайдаланушыларды басқаруға толық қол жеткізу",
          superadmin: "Aunimeda техникалық қолдауы",
          admin: "Әкімші",
          noServicesSelected: "Қызметтер таңдалмаған",
          none: "Ештеңе жоқ",
          create: "Жасау",  
    
          projectStatus: {
            discussion: "Талқылау",
            contacted: "Байланысқан",
            unreachable: "Қол жетімсіз",
            negotiating: "Келіссөз жүргізуде",
            meeting: "Кездесу",
            development: "Әзірлеу",
            completed: "Аяқталды"
          },
    
          assignedspecialists: "Тағайындалған мамандар",
          visibletoallspecialists: "Барлық мамандарға көрінеді",
          allspecialists: "Барлық мамандар",
          createclient: "Клиент құру",
          client: "Клиент",
          selectservices: "Қызметтерді таңдау",
          selectspecialist: "Маманды таңдау",
          selectdateandtime: "Күн мен уақытты таңдау",
          confirmbooking: "Жазылуды растау",
          selectall: "Барлығын таңдау",
          editservicesfor: "Қызметтерді өңдеу",
          clearall: "Барлығын тазалау",
          duration: "Ұзақтық",
          price: "Бағасы",
          selected: "Таңдалды",
          saveservices: "Қызметтерді сақтау",
          selectservicesthisspecialistcanprovidetoclients: "Бұл маман көрсете алатын қызметтерді таңдаңыз",
          confirmClearAllDeleted: "Жойылған қалтадан барлық клиенттерді жоюды қалайсыз ба? Бұл әрекетті қайтару мүмкін емес.",
    
          setSchedule: "Кесте құру",
          setWorkingHours: "Жұмыс уақытын орнату",
          setworkinghoursfor: "Жұмыс уақытын орнату",
          startTime: "Бастау уақыты",
          endTime: "Аяқтау уақыты",
          monday: "Дүйсенбі",
          tuesday: "Сейсенбі",
          wednesday: "Сәрсенбі",
          thursday: "Бейсенбі",
          friday: "Жұма",
          saturday: "Сенбі",
          sunday: "Жексенбі"
        },
        auth: {
          login: {
            title: "Кіру",
            invalidCredentials: "Қате email немесе құпия сөз",
            forgotPassword: "Құпия сөзді ұмыттыңыз ба?",
            noAccount: "Тіркелгіңіз жоқ па?",
            registerHere: "Мұнда тіркеліңіз"
          },
          register: {
            title: "Тіркелу",
            success: "Тіркелу сәтті аяқталды",
            haveAccount: "Тіркелгіңіз бар ма?",
            loginHere: "Мұнда кіріңіз",
            asClient: "Клиент ретінде тіркелу",
            asSpecialist: "Маман ретінде тіркелу",
            waitingApproval: "Тіркелу сәтті. Әкімшінің бекітуін күтуде."
          }
        },
        booking: {
          steps: {
            selectService: "Қызметті таңдау",
            selectSpecialist: "Маманды таңдау",
            selectDateTime: "Күн мен уақытты таңдау",
            confirmation: "Растау"
          },
          services: {
            title: "Қызметті таңдаңыз",
            duration: "Ұзақтық",
            price: "Бағасы"
          },
          specialists: {
            title: "Маманды таңдаңыз",
            availability: "Бос уақыттар",
            noAvailability: "Бос уақыттар жоқ"
          },
          datetime: {
            title: "Күн мен уақытты таңдаңыз",
            availableSlots: "Бос уақыттар",
            noSlots: "Бұл күнге бос уақыттар жоқ"
          },
          confirmation: {
            title: "Жазылуды растау",
            details: "Жазылу мәліметтері",
            service: "Қызмет",
            specialist: "Маман",
            dateTime: "Күн және уақыт",
            clientInfo: "Сіздің мәліметтеріңіз",
            confirming: "Расталуда...",
            confirmBooking: "Жазылуды растау",
            error: "Жазылуды құруда қате"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Жазылулар",
            clients: "Клиенттер",
            services: "Қызметтер",
            specialists: "Мамандар",
            settings: "Параметрлер",
            products: "Өнімдер"

          },
          appointments: {
            title: "Жазылулар",
            upcoming: "Алдағы",
            past: "Өткен",
            datetime: "Күн және уақыт",
            client: "Клиент",
            service: "Қызмет",
            specialist: "Маман",
            duration: "Ұзақтық",
            deleteConfirm: "Бұл жазылуды жоюды қалайсыз ба?",
            status: {
              pending: "Күтуде",
              confirmed: "Расталған",
              cancelled: "Бас тартылған",
              completed: "Аяқталған"
            },
            actions: {
              confirm: "Растау",
              cancel: "Бас тарту",
              reschedule: "Қайта жоспарлау"
            }
          },
          clients: {
            title: "Клиенттер",
            addNew: "Жаңа клиент қосу",
            management: "Клиенттерді басқару",
            details: "Клиент мәліметтері",
            history: "Клиент тарихы",
            status: {
              new: "Жаңа",
              regular: "Тұрақты",
              former: "Бұрынғы",
              deleted: "Жойылған"
            },
            tabs: {
              new: "Жаңа",
              regular: "Тұрақты",
              former: "Бұрынғы",
              deleted: "Жойылған"
            }
          },
          services: {
            title: "Қызметтер",
            addNew: "Жаңа қызмет қосу",
            editService: "Қызметті өңдеу",
            fields: {
              name: "Қызмет атауы",
              duration: "Ұзақтық",
              price: "Бағасы"
            }
          },
          specialists: {
            title: "Мамандар",
            addNew: "Жаңа маман қосу",
            management: "Мамандарды басқару",
            schedule: "Жұмыс кестесі",
            services: "Қол жетімді қызметтер",
            status: {
              pending: "Бекітуді күтуде",
              approved: "Бекітілген",
              rejected: "Қабылданбаған"
            }
          },
          settings: {
            title: "Параметрлер",
            profile: "Профиль параметрлері",
            account: "Тіркелгі параметрлері",
            password: "Құпия сөзді өзгерту",
            fields: {
              currentPassword: "Ағымдағы құпия сөз",
              newPassword: "Жаңа құпия сөз",
              confirmPassword: "Құпия сөзді растау"
            }
          }
        },
        settings: {
          tabAndColumnVisibility: "Қойындылар мен бағандардың көрінуі",
          tabOrder: "Қойындылардың реті",
          hiddenTabs: "Жасырын қойындылар",
          clientColumns: "Клиент бағандары",      
          crmSettings: "CRM параметрлері",
          promoText: "Промо мәтін",
          headerTitle: "Тақырып",
          headerSubtitle: "Сипаттама",
          defaultLanguage: "Әдепкі тіл",
          currency: "Валюта",
          currencyPosition: "Валюта орны",
          currencyRight: "Оң жақта",
          currencyLeft: "Сол жақта",
          hideAppointments: "Кездесулер қойындысын жасыру",
          hideSpecialists: "Мамандар қойындысын жасыру",
          hideServices: "Қызметтер қойындысын жасыру",
          hideClients: "Клиенттер қойындысын жасыру",
          hideProducts: "Өнімдер қойындысын жасыру",
          tabsSaved: "Қойынды параметрлері сақталды",
          errorFetching: "Параметрлерді жүктеу қатесі",
          errorSaving: "Параметрлерді сақтау қатесі",
          tabsDescription: "Терезенің көрінісі мен мінез-құлқын баптаңыз",
          tabVisibility: "Терезенің көрінуін ауыстыру",
          configureTabs: "Терезе баптауларын реттеу"
  
         },
         products: {
          import: {
            steps: {
              upload: "Жүктеу",
              map: "Картасын шығару",
              import: "Импорттау"
            },
            selectfile: "Файлды таңдау",
            guide: "Өнімдерді импорттау үшін: 1) Өнім деректері бар Excel файлын жасау 2) Бірінші қатарда баған атаулары болуы керек 3) Әр қатар бір өнімді білдіреді 4) Міндетті өріс: Өнімнің атауы 5) Әдепкі бағандарды тағайындау A1, B1 және т.б. болып орнатылады.",
            guideTitle: "Импорттау бойынша нұсқаулық"
          },  
          defaultcategory: "Әдепкі",
          title: "Өнімдерді басқару",
          addNew: "Жаңа өнім қосу",
          edit: "Өнімді өңдеу",
          create: "Өнім жасау",
          name: "Атауы",
          category: "Санат",
          price: "Бағасы",
          costPrice: "Өзіндік құны",
          warehouseName: "Қоймның атауы",
          warehouseAddress: "Қойма мекен-жайы",
          articleNumber: "Өнім коды",
          unit: "Бірлік",
          weight: "Салмақ",
          length: "Ұзындық",
          width: "Ені",
          height: "Биіктік",
          stock: "Қор",
          responsibleEmployee: "Жауапты қызметкер",
          dimensions: "Өлшемдер",
          warehouse: "Қойма",
          deleteTitle: "Өнімді жою",
          deleteConfirm: "{{name}} өнімін жоюға сенімдісіз бе?",
          units: {
            piece: "Дана",
            kg: "Килограмм",
            package: "Топтама"
          }
         }

      }
    },


    hy: {
      translation: {
        common: {
          nazvanie: "Անուն",
          maxprice: "Առավելագույն գին",
          category: "Կատեգորիա",
          title: "Վերնագիր",
          addnew: "Ավելացնել նոր",
          projectType: "Նախագծի տեսակ",
          history: "Պատմություն",
          assignSpecialists: "Նշանակել մասնագետներ",
          uploadSpecialistPhoto: "Վերբեռնել մասնագետի լուսանկար",
          selectimage: "Ընտրել նկար",
          upload: "Վերբեռնել",
          anySpecialist: "Ցանկացած մասնագետ",
          allServices: "Բոլոր ծառայությունները",            
          minutes: "րոպե",
          add: "Ավելացնել",
          edit: "Խմբագրել",
          delete: "Ջնջել",
          save: "Պահպանել",
          cancel: "Չեղարկել",
          confirm: "Հաստատել",
          back: "Հետ",
          next: "Հաջորդը",
          min: "րոպե",
          login: "Մուտք",
          register: "Գրանցվել",
          logout: "Ելք",
          email: "Էլ․ փոստ",
          password: "Գաղտնաբառ",
          phone: "Հեռախոս",
          name: "Անուն",
          actions: "Գործողություններ",
          optional: "ոչ պարտադիր",
          telegram: "Telegram",
          instagram: "Instagram",
          status: "Կարգավիճակ",
          savechanges: "Պահպանել փոփոխությունները",
          changespecialist: "Փոխել մասնագետին",
          past: "Անցյալ",
          ongoing: "Ընթացիկ",
          upcoming: "Առաջիկա",
          future: "Ապագա",
          specialist: "Մասնագետ",
          errorApproving: "Հաստատման սխալ",
          errorRejecting: "Մերժման սխալ",
          errorSaving: "Պահպանման սխալ",
          specialists: "Մասնագետներ",
          schedule: "Ժամանակացույց",
          services: "Ծառայություններ",
          service: "Ծառայություն",
          pendingApprovals: "Սպասվող հաստատումներ",
          activeSpecialists: "Ակտիվ մասնագետներ",
          approve: "Հաստատել",
          reject: "Մերժել",
          namecompany: "Անուն/Ընկերություն",
          firstcontact: "Առաջին կապ",
          contacts: "Կոնտակտներ",
          projectstatus: "Ծրագրի կարգավիճակ",
          createdby: "Ստեղծել է",
          assignedto: "Նշանակված է",
          clearalldeleted: "Մաքրել բոլոր ջնջվածները",
          dashboard: "Վահանակ",
          editservices: "Խմբագրել ծառայությունները",
          setschedule: "Սահմանել ժամանակացույց",
          website: "Կայք",
          new: "Նոր",
          regular: "Կանոնավոր",
          former: "Նախկին",
          deleted: "Ջնջված",
          clientstatus: "Հաճախորդի կարգավիճակ",
          address: "Հասցե",
          assignspecialiststo: "Նշանակել մասնագետներին",
          discussion: "Քննարկում",
          firstcontactdate: "Առաջին կապի ամսաթիվ",
          projecttype: "Ծրագրի տեսակ",
          projectdescription: "Ծրագրի նկարագրություն",
          technicaldetails: "Տեխնիկական մանրամասներ",
          budget: "Բյուջե",
          contacted: "Կապ է հաստատվել",
          unreachable: "Անհասանելի",
          negotiating: "Բանակցում",
          meeting: "Հանդիպում",
          development: "Մշակում",
          completed: "Ավարտված",
          telegramoptional: "Telegram (ոչ պարտադիր)",
          instagramoptional: "Instagram (ոչ պարտադիր)",
          alreadyhaveanaccount: "Արդեն ունե՞ք հաշիվ: Մուտք",
          myappointments: "Իմ ժամադրությունները",
          myclients: "Իմ հաճախորդները",
          settings: "Կարգավորումներ",
          profilesettings: "Պրոֆիլի կարգավորումներ",
          saveprofilechanges: "Պահպանել պրոֆիլի փոփոխությունները",
          changepassword: "Փոխել գաղտնաբառը",
          currentpassword: "Ընթացիկ գաղտնաբառ",
          newpassword: "Նոր գաղտնաբառ",
          confirmnewpassword: "Հաստատել նոր գաղտնաբառը",
          deleteaccount: "Ջնջել հաշիվը",
          accountsettings: "Հաշվի կարգավորումներ",
          saveschedule: "Պահպանել ժամանակացույցը",
          starttime: "Սկզբի ժամ",
          endtime: "Ավարտի ժամ",
          addnewclient: "Ավելացնել նոր հաճախորդ",
          editclient: "Խմբագրել հաճախորդին",
          newclient: "Նոր հաճախորդ",
          export: "արտահանել",
          import: "ներմուծել",
          saving: "Պահպանվում է...",
          role: "Դեր",
          editRole: "Խմբագրել դերը",
          changeRole: "Փոխել դերը",
          specialistRoleDescription: "Հատուկ առաջադրանքների և նախագծի տվյալների մուտք",
          adminRoleDescription: "Լիարժեք մուտք կարգավորումներ և օգտագործողների կառավարում",
          superadmin: "Aunimeda տեխնիկական աջակցություն",
          admin: "Ադմինիստրատոր",
          noServicesSelected: "Ծառայություններ ընտրված չեն",
          none: "Ոչինչ",
          create: "Ստեղծել",
          
    
          projectStatus: {
            discussion: "Քննարկում",
            contacted: "Կապ է հաստատվել",
            unreachable: "Անհասանելի",
            negotiating: "Բանակցում",
            meeting: "Հանդիպում",
            development: "Մշակում",
            completed: "Ավարտված"
          },
    
          assignedspecialists: "Նշանակված մասնագետներ",
          visibletoallspecialists: "Տեսանելի է բոլոր մասնագետներին",
          allspecialists: "Բոլոր մասնագետները",
          createclient: "Ստեղծել հաճախորդ",
          client: "Հաճախորդ",
          selectservices: "Ընտրել ծառայությունները",
          selectspecialist: "Ընտրել մասնագետ",
          selectdateandtime: "Ընտրել ամսաթիվ և ժամ",
          confirmbooking: "Հաստատել ամրագրումը",
          selectall: "Ընտրել բոլորը",
          editservicesfor: "Խմբագրել ծառայությունները",
          clearall: "Մաքրել բոլորը",
          duration: "Տևողություն",
          price: "Գին",
          selected: "Ընտրված",
          saveservices: "Պահպանել ծառայությունները",
          selectservicesthisspecialistcanprovidetoclients: "Ընտրել ծառայություններ, որոնք այս մասնագետը կարող է մատուցել հաճախորդներին",
          confirmClearAllDeleted: "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել բոլոր հաճախորդներին ջնջված թղթապանակից: Այս գործողությունը հնարավոր չէ հետ շրջել:",
    
          setSchedule: "Սահմանել ժամանակացույց",
          setWorkingHours: "Սահմանել աշխատանքային ժամերը",
          setworkinghoursfor: "Սահմանել աշխատանքային ժամերը",
          startTime: "Սկզբի ժամ",
          endTime: "Ավարտի ժամ",
          monday: "Երկուշաբթի",
          tuesday: "Երեքշաբթի",
          wednesday: "Չորեքշաբթի",
          thursday: "Հինգշաբթի",
          friday: "Ուրբաթ",
          saturday: "Շաբաթ",
          sunday: "Կիրակի"
        },
        auth: {
          login: {
            title: "Մուտք",
            invalidCredentials: "Սխալ էլ․ փոստ կամ գաղտնաբառ",
            forgotPassword: "Մոռացե՞լ եք գաղտնաբառը",
            noAccount: "Չունե՞ք հաշիվ",
            registerHere: "Գրանցվեք այստեղ"
          },
          register: {
            title: "Գրանցում",
            success: "Գրանցումը հաջողված է",
            haveAccount: "Արդեն ունե՞ք հաշիվ",
            loginHere: "Մուտք գործեք այստեղ",
            asClient: "Գրանցվել որպես հաճախորդ",
            asSpecialist: "Գրանցվել որպես մասնագետ",
            waitingApproval: "Գրանցումը հաջողված է: Սպասում ենք ադմինիստրատորի հաստատմանը:"
          }
        },
        booking: {
          steps: {
            selectService: "Ընտրել ծառայություն",
            selectSpecialist: "Ընտրել մասնագետ",
            selectDateTime: "Ընտրել ամսաթիվ և ժամ",
            confirmation: "Հաստատում"
          },
          services: {
            title: "Ընտրել ծառայություն",
            duration: "Տևողություն",
            price: "Գին"
          },
          specialists: {
            title: "Ընտրել մասնագետ",
            availability: "Հասանելի ժամեր",
            noAvailability: "Հասանելի ժամեր չկան"
          },
          datetime: {
            title: "Ընտրել ամսաթիվ և ժամ",
            availableSlots: "Հասանելի ժամեր",
            noSlots: "Այս ամսաթվի համար հասանելի ժամեր չկան"
          },
          confirmation: {
            title: "Հաստատել ամրագրումը",
            details: "Ամրագրման մանրամասներ",
            service: "Ծառայություն",
            specialist: "Մասնագետ",
            dateTime: "Ամսաթիվ և ժամ",
            clientInfo: "Ձեր տվյալները",
            confirming: "Հաստատվում է...",
            confirmBooking: "Հաստատել ամրագրումը",
            error: "Սխալ ամրագրման ստեղծման ժամանակ"
          }
        },
        dashboard: {
          tabs: {
            appointments: "Ժամադրություններ",
            clients: "Հաճախորդներ",
            services: "Ծառայություններ",
            specialists: "Մասնագետներ",
            settings: "Կարգավորումներ",
            products: "Արտադրանք"

          },
          appointments: {
            title: "Ժամադրություններ",
            upcoming: "Առաջիկա",
            past: "Անցյալ",
            datetime: "Ամսաթիվ և ժամ",
            client: "Հաճախորդ",
            service: "Ծառայություն",
            specialist: "Մասնագետ",
            duration: "Տևողություն",
            deleteConfirm: "Վստա՞հ եք, որ ցանկանում եք ջնջել այս ժամադրությունը",
            status: {
              pending: "Սպասման մեջ",
              confirmed: "Հաստատված",
              cancelled: "Չեղարկված",
              completed: "Ավարտված"
            },
            actions: {
              confirm: "Հաստատել",
              cancel: "Չեղարկել",
              reschedule: "Վերանշանակել"
            }
          },
          clients: {
            title: "Հաճախորդներ",
            addNew: "Ավելացնել նոր հաճախորդ",
            management: "Հաճախորդների կառավարում",
            details: "Հաճախորդի մանրամասներ",
            history: "Հաճախորդի պատմություն",
            status: {
              new: "Նոր",
              regular: "Կանոնավոր",
              former: "Նախկին",
              deleted: "Ջնջված"
            },
            tabs: {
              new: "Նոր",
              regular: "Կանոնավոր",
              former: "Նախկին",
              deleted: "Ջնջված"
            }
          },
          services: {
            title: "Ծառայություններ",
            addNew: "Ավելացնել նոր ծառայություն",
            editService: "Խմբագրել ծառայությունը",
            fields: {
              name: "Ծառայության անվանում",
              duration: "Տևողություն",
              price: "Գին"
            }
          },
          specialists: {
            title: "Մասնագետներ",
            addNew: "Ավելացնել նոր մասնագետ",
            management: "Մասնագետների կառավարում",
            schedule: "Աշխատանքային ժամեր",
            services: "Հասանելի ծառայություններ",
            status: {
              pending: "Սպասում է հաստատման",
              approved: "Հաստատված",
              rejected: "Մերժված"
        }
      },
      settings: {
        title: "Կարգավորումներ",
        profile: "Պրոֆիլի կարգավորումներ",
        account: "Հաշվի կարգավորումներ",
        password: "Փոխել գաղտնաբառը",
        fields: {
          currentPassword: "Ընթացիկ գաղտնաբառ",
          newPassword: "Նոր գաղտնաբառ",
          confirmPassword: "Հաստատել գաղտնաբառը"
        }
      }
    },
    settings: {
      tabAndColumnVisibility: "Նշանակությունների և սյուների տեսանելիություն",
      tabOrder: "Նշանակությունների կարգ",
      hiddenTabs: "Թաքցված նշանակություններ",
      clientColumns: "Հաճախորդի սյուներ", 
      crmSettings: "CRM կարգավորումներ",
      promoText: "Գովազդային տեքստ",
      headerTitle: "Վերնագիր",
      headerSubtitle: "Նկարագրություն",
      defaultLanguage: "Լռելյայն լեզու",
      currency: "Արժույթ",
      currencyPosition: "Արժույթի դիրք",
      currencyRight: "Աջ",
      currencyLeft: "Ձախ",
      hideAppointments: "Թաքցնել 'Հանդիպումներ' ներդիրը",
      hideSpecialists: "Թաքցնել 'Մասնագետներ' ներդիրը",
      hideServices: "Թաքցնել 'Ծառայություններ' ներդիրը",
      hideClients: "Թաքցնել 'Հաճախորդներ' ներդիրը",
      hideProducts: "Թաքցնել 'Արտադրանք' ներդիրը",
      tabsSaved: "Ներդիրների կարգավորումները պահպանվել են",
      errorFetching: "Սխալ կարգավորումները բեռնելիս",
      errorSaving: "Սխալ կարգավորումները պահպանելիս",
      tabsDescription: "Տեղեկատախտակների արտաքին տեսքն ու վարքագիծը կարգավորեք",
      tabVisibility: "Տեղեկատախտակների տեսանելիությունը փոխեք",
      configureTabs: "Կարգավորեք տեղեկատախտակների կարգավորումները"

     },
     products: {
      defaultcategory: "Լռելյայն",

      import: {
        steps: {
          upload: "Վերբեռնել",
          map: "Քարտեզ",
          import: "Ներմուծում"
        },
        selectfile: "Ընտրել ֆայլ",
        guide: "Ապրանքների ներմուծում: 1) Ստեղծեք Excel ֆայլ ապրանքների տվյալների համար 2) Առաջին տողը պետք է պարունակի սյուների անուններ 3) Յուրաքանչյուր տողը ներկայացնում է մեկ ապրանք 4) Պարտադիր դաշտ: Ապրանքի անուն 5) Լռելյայն սյուների նշանակումը սահմանված է A1, B1 և այլն:",
        guideTitle: "Ներմուծման ցուցումներ"
      },  
      title: "Արտադրանքի կառավարում",
      addNew: "Ավելացնել նոր արտադրանք",
      edit: "Խմբագրել արտադրանքը",
      create: "Ստեղծել արտադրանք",
      name: "Անուն",
      category: "Կատեգորիա",
      price: "Գին",
      costPrice: "Արժեք",
      warehouseName: "Պահեստի անուն",
      warehouseAddress: "Պահեստի հասցե",
      articleNumber: "Արտադրանքի կոդ",
      unit: "Միավոր",
      weight: "Քաշ",
      length: "Երկարություն",
      width: "Լայնություն",
      height: "Բարձրություն",
      stock: "Պաշար",
      responsibleEmployee: "Պատասխանատու աշխատակից",
      dimensions: "Չափեր",
      warehouse: "Պահեստ",
      deleteTitle: "Ջնջել արտադրանքը",
      deleteConfirm: "Վստա՞հ եք, որ ուզում եք ջնջել {{name}} արտադրանքը",
      units: {
        piece: "Հատ",
        kg: "Կիլոգրամ",
        package: "Փաթեթ"
      }
     }  
  }
},


ka: {
  translation: {
    common: {
      nazvanie: "სახელი",
      maxprice: "მაქსიმალური ფასი",
      category: "კატეგორია",
      title: "სათაური",
      addnew: "ახლის დამატება",
      projectType: "პროექტის ტიპი",
      history: "ისტორია",
      assignSpecialists: "სპეციალისტების დანიშვნა",
      uploadSpecialistPhoto: "სპეციალისტის ფოტოს ატვირთვა",
      selectimage: "სურათის არჩევა",
      upload: "ატვირთვა",
      anySpecialist: "ნებისმიერი სპეციალისტი",
      allServices: "ყველა სერვისი",  
      minutes: "წუთი",
      add: "დამატება",
      edit: "რედაქტირება",
      delete: "წაშლა",
      save: "შენახვა",
      cancel: "გაუქმება",
      confirm: "დადასტურება",
      back: "უკან",
      next: "შემდეგი",
      min: "წთ",
      login: "შესვლა",
      register: "რეგისტრაცია",
      logout: "გასვლა",
      email: "ელ.ფოსტა",
      password: "პაროლი",
      phone: "ტელეფონი",
      name: "სახელი",
      actions: "მოქმედებები",
      optional: "არასავალდებულო",
      telegram: "Telegram",
      instagram: "Instagram",
      status: "სტატუსი",
      savechanges: "ცვლილებების შენახვა",
      changespecialist: "სპეციალისტის შეცვლა",
      past: "წარსული",
      ongoing: "მიმდინარე",
      upcoming: "მომავალი",
      future: "სამომავლო",
      specialist: "სპეციალისტი",
      errorApproving: "დამტკიცების შეცდომა",
      errorRejecting: "უარყოფის შეცდომა",
      errorSaving: "შენახვის შეცდომა",
      specialists: "სპეციალისტები",
      schedule: "განრიგი",
      services: "სერვისები",
      service: "სერვისი",
      pendingApprovals: "დასამტკიცებელი",
      activeSpecialists: "აქტიური სპეციალისტები",
      approve: "დამტკიცება",
      reject: "უარყოფა",
      namecompany: "სახელი/კომპანია",
      firstcontact: "პირველი კონტაქტი",
      contacts: "კონტაქტები",
      projectstatus: "პროექტის სტატუსი",
      createdby: "შემქმნელი",
      assignedto: "მინიჭებულია",
      clearalldeleted: "წაშლილების გასუფთავება",
      dashboard: "დაფა",
      editservices: "სერვისების რედაქტირება",
      setschedule: "განრიგის დაყენება",
      website: "ვებსაიტი",
      new: "ახალი",
      regular: "რეგულარული",
      former: "ყოფილი",
      deleted: "წაშლილი",
      clientstatus: "კლიენტის სტატუსი",
      address: "მისამართი",
      assignspecialiststo: "სპეციალისტის მინიჭება",
      discussion: "განხილვა",
      firstcontactdate: "პირველი კონტაქტის თარიღი",
      projecttype: "პროექტის ტიპი",
      projectdescription: "პროექტის აღწერა",
      technicaldetails: "ტექნიკური დეტალები",
      budget: "ბიუჯეტი",
      contacted: "დაკონტაქტებული",
      unreachable: "მიუწვდომელი",
      negotiating: "მოლაპარაკება",
      meeting: "შეხვედრა",
      development: "განვითარება",
      completed: "დასრულებული",
      telegramoptional: "Telegram (არასავალდებულო)",
      instagramoptional: "Instagram (არასავალდებულო)",
      alreadyhaveanaccount: "უკვე გაქვთ ანგარიში? შესვლა",
      myappointments: "ჩემი ჯავშნები",
      myclients: "ჩემი კლიენტები",
      settings: "პარამეტრები",
      profilesettings: "პროფილის პარამეტრები",
      saveprofilechanges: "პროფილის ცვლილებების შენახვა",
      changepassword: "პაროლის შეცვლა",
      currentpassword: "მიმდინარე პაროლი",
      newpassword: "ახალი პაროლი",
      confirmnewpassword: "ახალი პაროლის დადასტურება",
      deleteaccount: "ანგარიშის წაშლა",
      accountsettings: "ანგარიშის პარამეტრები",
      saveschedule: "განრიგის შენახვა",
      starttime: "დაწყების დრო",
      endtime: "დასრულების დრო",
      addnewclient: "ახალი კლიენტის დამატება",
      editclient: "კლიენტის რედაქტირება",
      newclient: "ახალი კლიენტი",
      export: "ექსპორტი",
      import: "იმპორტი",
      saving: "მიმდინარეობს შენახვა...",
      role: "როლი",
      editRole: "როლის რედაქტირება",
      changeRole: "როლის შეცვლა",
      specialistRoleDescription: "სპეციალური დავალებებისა და პროექტის მონაცემებზე წვდომა",
      adminRoleDescription: "სრული წვდომა პარამეტრებსა და მომხმარებლის მართვაზე",
      superadmin: "Aunimeda ტექნიკური მხარდაჭერა",
      admin: "ადმინისტრატორი",
      noServicesSelected: "სერვისები არ არის არჩეული",
      none: "არაფერი",
      create: "შექმნა",


      projectStatus: {
        discussion: "განხილვა",
        contacted: "დაკონტაქტებული",
        unreachable: "მიუწვდომელი",
        negotiating: "მოლაპარაკება",
        meeting: "შეხვედრა",
        development: "განვითარება",
        completed: "დასრულებული"
      },

      assignedspecialists: "მინიჭებული სპეციალისტები",
      visibletoallspecialists: "ხილულია ყველა სპეციალისტისთვის",
      allspecialists: "ყველა სპეციალისტი",
      createclient: "კლიენტის შექმნა",
      client: "კლიენტი",
      selectservices: "სერვისების არჩევა",
      selectspecialist: "სპეციალისტის არჩევა",
      selectdateandtime: "თარიღისა და დროის არჩევა",
      confirmbooking: "ჯავშნის დადასტურება",
      selectall: "ყველას მონიშვნა",
      editservicesfor: "სერვისების რედაქტირება",
      clearall: "ყველას გასუფთავება",
      duration: "ხანგრძლივობა",
      price: "ფასი",
      selected: "არჩეული",
      saveservices: "სერვისების შენახვა",
      selectservicesthisspecialistcanprovidetoclients: "აირჩიეთ სერვისები, რომელთა მიწოდებაც შეუძლია ამ სპეციალისტს კლიენტებისთვის",
      confirmClearAllDeleted: "დარწმუნებული ხართ, რომ გსურთ ყველა წაშლილი კლიენტის წაშლა? ეს მოქმედება შეუქცევადია.",

      setSchedule: "განრიგის დაყენება",
      setWorkingHours: "სამუშაო საათების დაყენება",
      setworkinghoursfor: "სამუშაო საათების დაყენება",
      startTime: "დაწყების დრო",
      endTime: "დასრულების დრო",
      monday: "ორშაბათი",
      tuesday: "სამშაბათი",
      wednesday: "ოთხშაბათი",
      thursday: "ხუთშაბათი",
      friday: "პარასკევი",
      saturday: "შაბათი",
      sunday: "კვირა"
    },
    auth: {
      login: {
        title: "შესვლა",
        invalidCredentials: "არასწორი ელ.ფოსტა ან პაროლი",
        forgotPassword: "დაგავიწყდათ პაროლი?",
        noAccount: "არ გაქვთ ანგარიში?",
        registerHere: "დარეგისტრირდით აქ"
      },
      register: {
        title: "რეგისტრაცია",
        success: "რეგისტრაცია წარმატებით დასრულდა",
        haveAccount: "უკვე გაქვთ ანგარიში?",
        loginHere: "შედით აქ",
        asClient: "რეგისტრაცია კლიენტად",
        asSpecialist: "რეგისტრაცია სპეციალისტად",
        waitingApproval: "რეგისტრაცია წარმატებულია. ველოდებით ადმინისტრატორის დამტკიცებას."
      }
    },
    booking: {
      steps: {
        selectService: "სერვისის არჩევა",
        selectSpecialist: "სპეციალისტის არჩევა",
        selectDateTime: "თარიღისა და დროის არჩევა",
        confirmation: "დადასტურება"
      },
      services: {
        title: "აირჩიეთ სერვისი",
        duration: "ხანგრძლივობა",
        price: "ფასი"
      },
      specialists: {
        title: "აირჩიეთ სპეციალისტი",
        availability: "ხელმისაწვდომი დრო",
        noAvailability: "ხელმისაწვდომი დრო არ არის"
      },
      datetime: {
        title: "აირჩიეთ თარიღი და დრო",
        availableSlots: "ხელმისაწვდომი სლოტები",
        noSlots: "ამ თარიღისთვის სლოტები არ არის"
      },
      confirmation: {
        title: "ჯავშნის დადასტურება",
        details: "ჯავშნის დეტალები",
        service: "სერვისი",
        specialist: "სპეციალისტი",
        dateTime: "თარიღი და დრო",
        clientInfo: "თქვენი ინფორმაცია",
        confirming: "დასტურდება...",
        confirmBooking: "ჯავშნის დადასტურება",
        error: "შეცდომა ჯავშნის შექმნისას"
      }
    },
    dashboard: {
      tabs: {
        appointments: "ჯავშნები",
        clients: "კლიენტები",
        services: "სერვისები",
        specialists: "სპეციალისტები",
        settings: "პარამეტრები",
        products: "პროდუქტები"

      },
      appointments: {
        title: "ჯავშნები",
        upcoming: "მომავალი",
        past: "წარსული",
        datetime: "თარიღი და დრო",
        client: "კლიენტი",
        service: "სერვისი",
        specialist: "სპეციალისტი",
        duration: "ხანგრძლივობა",
        deleteConfirm: "დარწმუნებული ხართ, რომ გსურთ ამ ჯავშნის წაშლა?",
        status: {
          pending: "მოლოდინში",
          confirmed: "დადასტურებული",
          cancelled: "გაუქმებული",
          completed: "დასრულებული"
        },
        actions: {
          confirm: "დადასტურება",
          cancel: "გაუქმება",
          reschedule: "გადაჯავშნა"
        }
      },
      clients: {
        title: "კლიენტები",
        addNew: "ახალი კლიენტის დამატება",
        management: "კლიენტების მართვა",
        details: "კლიენტის დეტალები",
        history: "კლიენტის ისტორია",
        status: {
          new: "ახალი",
          regular: "რეგულარული",
          former: "ყოფილი",
          deleted: "წაშლილი"
        },
        tabs: {
          new: "ახალი",
          regular: "რეგულარული",
          former: "ყოფილი",
          deleted: "წაშლილი"
        }
      },
      services: {
        title: "სერვისები",
        addNew: "ახალი სერვისის დამატება",
        editService: "სერვისის რედაქტირება",
        fields: {
          name: "სერვისის სახელი",
          duration: "ხანგრძლივობა",
          price: "ფასი"
        }
      },
      specialists: {
        title: "სპეციალისტები",
        addNew: "ახალი სპეციალისტის დამატება",
        management: "სპეციალისტების მართვა",
        schedule: "სამუშაო საათები",
        services: "ხელმისაწვდომი სერვისები",
        status: {
          pending: "დასამტკიცებელი",
          approved: "დამტკიცებული",
          rejected: "უარყოფილი"
        }
      },
      settings: {
        title: "პარამეტრები",
        profile: "პროფილის პარამეტრები",
        account: "ანგარიშის პარამეტრები",
        password: "პაროლის შეცვლა",
        fields: {
          currentPassword: "მიმდინარე პაროლი",
          newPassword: "ახალი პაროლი",
          confirmPassword: "პაროლის დადასტურება"
        }
      }
    },
    settings: {
      tabAndColumnVisibility: "ტაბისა და სვეტების ხილვადობა",
      tabOrder: "ტაბის თანმიმდევრობა",
      hiddenTabs: "დამალული ტაბები",
      clientColumns: "კლიენტის სვეტები",  
      crmSettings: "CRM პარამეტრები",
      promoText: "სარეკლამო ტექსტი",
      headerTitle: "სათაური",
      headerSubtitle: "აღწერა",
      defaultLanguage: "ნაგულისხმები ენა",
      currency: "ვალუტა",
      currencyPosition: "ვალუტის პოზიცია",
      currencyRight: "მარჯვნივ",
      currencyLeft: "მარცხნივ",
      hideAppointments: "ჩანართის 'შეხვედრები' დამალვა",
      hideSpecialists: "ჩანართის 'სპეციალისტები' დამალვა",
      hideServices: "ჩანართის 'მომსახურებები' დამალვა",
      hideClients: "ჩანართის 'კლიენტები' დამალვა",
      hideProducts: "ჩანართის 'პროდუქტები' დამალვა",
      tabsSaved: "ჩანართის პარამეტრები შენახულია",
      errorFetching: "პარამეტრების ჩატვირთვის შეცდომა",
      errorSaving: "პარამეტრების შენახვის შეცდომა",
      tabsDescription: "აკომოდირების და ქცევის კონფიგურაცია",
      tabVisibility: "აკომოდირების ხილვადობის გადართვა",
      configureTabs: "აკომოდირების პარამეტრების შეცვლა"

     },
     products: {
      defaultcategory: "ნაგულისხმები",
      import: {
        steps: {
          upload: "ატვირთვა",
          map: "რუკა",
          import: "იმპორტი"
        },
        selectfile: "ფაილის არჩევა",
        guide: "პროდუქტების იმპორტი: 1) შექმენით Excel ფაილი პროდუქტების მონაცემების სვეტებით 2) პირველი ხაზი უნდა შეიცავდეს სვეტების სახელებს 3) თითოეული ხაზი წარმოადგენს ერთ პროდუქტს 4) სავალდებულო ველი: პროდუქტის სახელი 5) სტანდარტული სვეტების დანიშნულება განისაზღვრება A1, B1 და ა.შ.",
        guideTitle: "იმპორტის ინსტრუქციები"
      },  
      title: "პროდუქტების მართვა",
      addNew: "ახალი პროდუქტის დამატება",
      edit: "პროდუქტის რედაქტირება",
      create: "პროდუქტის შექმნა",
      name: "სახელი",
      category: "კატეგორია",
      price: "ფასი",
      costPrice: "თვითღირებულება",
      warehouseName: "საწყობის სახელი",
      warehouseAddress: "საწყობის მისამართი",
      articleNumber: "პროდუქტის კოდი",
      unit: "ერთეული",
      weight: "წონა",
      length: "სიგრძე",
      width: "სიგანე",
      height: "სიმაღლე",
      stock: "მარაგი",
      responsibleEmployee: "პასუხისმგებელი თანამშრომელი",
      dimensions: "გაბარიტები",
      warehouse: "საწყობი",
      deleteTitle: "პროდუქტის წაშლა",
      deleteConfirm: "დარწმუნებული ხართ, რომ გსურთ წაშალოთ {{name}} პროდუქტი?",
      units: {
        piece: "ცალი",
        kg: "კილოგრამი",
        package: "შეფუთვა"
      }
     }  
  }
},

uk: {
  translation: {
    common: {
      minutes: "хвилин",
      nazvanie: "Назва",
      maxprice: "Максимальна ціна",
      category: "Категорія",
      title: "Заголовок",
      addnew: "Додати нове",
      projectType: "Тип проекту",
      history: "Історія",
      assignSpecialists: "Призначити фахівців",
      uploadSpecialistPhoto: "Завантажити фото фахівця",
      selectimage: "Вибрати зображення",
      upload: "Завантажити",
      anySpecialist: "Будь-який фахівець",
      allServices: "Усі послуги",

      add: "Додати",
      edit: "Редагувати",
      delete: "Видалити",
      save: "Зберегти",
      cancel: "Скасувати",
      confirm: "Підтвердити",
      back: "Назад",
      next: "Далі",
      min: "хв",
      login: "Увійти",
      register: "Зареєструватися",
      logout: "Вийти",
      email: "Електронна пошта",
      password: "Пароль",
      phone: "Телефон",
      name: "Ім'я",
      actions: "Дії",
      optional: "необов'язково",
      telegram: "Telegram",
      instagram: "Instagram",
      status: "Статус",
      savechanges: "Зберегти зміни",
      changespecialist: "Змінити спеціаліста",
      past: "Минулі",
      ongoing: "Поточні",
      upcoming: "Майбутні",
      future: "Майбутні",
      specialist: "Спеціаліст",
      errorApproving: "Помилка затвердження",
      errorRejecting: "Помилка відхилення",
      errorSaving: "Помилка збереження",
      specialists: "Спеціалісти",
      schedule: "Розклад",
      services: "Послуги",
      service: "Послуга",
      pendingApprovals: "Очікують затвердження",
      activeSpecialists: "Активні спеціалісти",
      approve: "Затвердити",
      reject: "Відхилити",
      namecompany: "Ім'я/Компанія",
      firstcontact: "Перший контакт",
      contacts: "Контакти",
      projectstatus: "Статус проекту",
      createdby: "Створено",
      assignedto: "Призначено",
      clearalldeleted: "Очистити всі видалені",
      dashboard: "Панель керування",
      editservices: "Редагувати послуги",
      setschedule: "Встановити розклад",
      website: "Веб-сайт",
      new: "Новий",
      regular: "Постійний",
      former: "Колишній",
      deleted: "Видалений",
      clientstatus: "Статус клієнта",
      address: "Адреса",
      assignspecialiststo: "Призначити спеціалістів для",
      discussion: "Обговорення",
      firstcontactdate: "Дата першого контакту",
      projecttype: "Тип проекту",
      projectdescription: "Опис проекту",
      technicaldetails: "Технічні деталі",
      budget: "Бюджет",
      contacted: "Зв'язались",
      unreachable: "Недоступний",
      negotiating: "Переговори",
      meeting: "Зустріч",
      development: "Розробка",
      completed: "Завершено",
      telegramoptional: "Telegram (необов'язково)",
      instagramoptional: "Instagram (необов'язково)",
      alreadyhaveanaccount: "Вже маєте обліковий запис? Увійти",
      myappointments: "Мої записи",
      myclients: "Мої клієнти",
      settings: "Налаштування",
      profilesettings: "Налаштування профілю",
      saveprofilechanges: "Зберегти зміни профілю",
      changepassword: "Змінити пароль",
      currentpassword: "Поточний пароль",
      newpassword: "Новий пароль",
      confirmnewpassword: "Підтвердити новий пароль",
      deleteaccount: "Видалити обліковий запис",
      accountsettings: "Налаштування облікового запису",
      saveschedule: "Зберегти розклад",
      starttime: "Час початку",
      endtime: "Час закінчення",
      addnewclient: "Додати нового клієнта",
      editclient: "Редагувати клієнта",
      newclient: "Новий клієнт",
      export: "Експортувати",
      import: "Імпортувати",
      saving: "Збереження...",
      role: "Роль",
      editRole: "Редагувати роль",
      changeRole: "Змінити роль",
      specialistRoleDescription: "Доступ до спеціальних завдань і даних проекту",
      adminRoleDescription: "Повний доступ до налаштувань і керування користувачами",
      superadmin: "Технічна підтримка Aunimeda",
      admin: "Адміністратор",
      noServicesSelected: "Жодної служби не вибрано",
      none: "Немає",
      create: "Створити",


      projectStatus: {
        discussion: "Обговорення",
        contacted: "Зв'язались",
        unreachable: "Недоступний",
        negotiating: "Переговори",
        meeting: "Зустріч",
        development: "Розробка",
        completed: "Завершено"
      },

      assignedspecialists: "Призначені спеціалісти",
      visibletoallspecialists: "Видно всім спеціалістам",
      allspecialists: "Всі спеціалісти",
      createclient: "Створити клієнта",
      client: "Клієнт",
      selectservices: "Вибрати послуги",
      selectspecialist: "Вибрати спеціаліста",
      selectdateandtime: "Вибрати дату та час",
      confirmbooking: "Підтвердити запис",
      selectall: "Вибрати все",
      editservicesfor: "Редагувати послуги для",
      clearall: "Очистити все",
      duration: "Тривалість",
      price: "Ціна",
      selected: "Вибрано",
      saveservices: "Зберегти послуги",
      selectservicesthisspecialistcanprovidetoclients: "Виберіть послуги, які цей спеціаліст може надавати клієнтам",
      confirmClearAllDeleted: "Ви впевнені, що хочете видалити всіх клієнтів з папки видалених? Цю дію неможливо скасувати.",

      setSchedule: "Встановити розклад",
      setWorkingHours: "Встановити робочі години",
      setworkinghoursfor: "Встановити робочі години для",
      startTime: "Час початку",
      endTime: "Час закінчення",
      monday: "Понеділок",
      tuesday: "Вівторок",
      wednesday: "Середа",
      thursday: "Четвер",
      friday: "П'ятниця",
      saturday: "Субота",
      sunday: "Неділя"
    },
    auth: {
      login: {
        title: "Вхід",
        invalidCredentials: "Невірна електронна пошта або пароль",
        forgotPassword: "Забули пароль?",
        noAccount: "Немає облікового запису?",
        registerHere: "Зареєструватися тут"
      },
      register: {
        title: "Реєстрація",
        success: "Реєстрація успішна",
        haveAccount: "Вже маєте обліковий запис?",
        loginHere: "Увійти тут",
        asClient: "Зареєструватися як клієнт",
        asSpecialist: "Зареєструватися як спеціаліст",
        waitingApproval: "Реєстрація успішна. Очікуйте затвердження адміністратора."
      }
    },
    booking: {
      steps: {
        selectService: "Вибір послуги",
        selectSpecialist: "Вибір спеціаліста",
        selectDateTime: "Вибір дати та часу",
        confirmation: "Підтвердження"
      },
      services: {
        title: "Виберіть послугу",
        duration: "Тривалість",
        price: "Ціна"
      },
      specialists: {
        title: "Виберіть спеціаліста",
        availability: "Доступний час",
        noAvailability: "Немає доступного часу"
      },
      datetime: {
        title: "Виберіть дату та час",
        availableSlots: "Доступні слоти",
        noSlots: "Немає доступних слотів на цю дату"
      },
      confirmation: {
        title: "Підтвердження запису",
        details: "Деталі запису",
        service: "Послуга",
        specialist: "Спеціаліст",
        dateTime: "Дата та час",
        clientInfo: "Ваша інформація",
        confirming: "Підтверджується...",
        confirmBooking: "Підтвердити запис",
        error: "Помилка створення запису"
      }
    },
    dashboard: {
      tabs: {
        appointments: "Записи",
        clients: "Клієнти",
        services: "Послуги",
        specialists: "Спеціалісти",
        settings: "Налаштування",
        products: "Продукти"

      },
      appointments: {
        title: "Записи",
        upcoming: "Майбутні",
        past: "Минулі",
        datetime: "Дата та час",
        client: "Клієнт",
        service: "Послуга",
        specialist: "Спеціаліст",
        duration: "Тривалість",
        deleteConfirm: "Ви впевнені, що хочете видалити цей запис?",
        status: {
          pending: "Очікує",
          confirmed: "Підтверджено",
          cancelled: "Скасовано",
          completed: "Завершено"
        },
        actions: {
          confirm: "Підтвердити",
          cancel: "Скасувати",
          reschedule: "Перепланувати"
        }
      },
      clients: {
        title: "Клієнти",
        addNew: "Додати нового клієнта",
        management: "Керування клієнтами",
        details: "Деталі клієнта",
        history: "Історія клієнта",
        status: {
          new: "Новий",
          regular: "Постійний",
          former: "Колишній",
          deleted: "Видалений"
        },
        tabs: {
          new: "Нові",
          regular: "Постійні",
          former: "Колишні",
          deleted: "Видалені"
        }
      },
      services: {
        title: "Послуги",
        addNew: "Додати нову послугу",
        editService: "Редагувати послугу",
        fields: {
          name: "Назва послуги",
          duration: "Тривалість",
          price: "Ціна"
        }
      },
      specialists: {
        title: "Спеціалісти",
        addNew: "Додати нового спеціаліста",
        management: "Керування спеціалістами",
        schedule: "Робочі години",
        services: "Доступні послуги",
        status: {
          pending: "Очікує затвердження",
          approved: "Затверджено",
          rejected: "Відхилено"
        }
      },
      settings: {
        title: "Налаштування",
        profile: "Налаштування профілю",
        account: "Налаштування облікового запису",
        password: "Змінити пароль",
        fields: {
          currentPassword: "Поточний пароль",
          newPassword: "Новий пароль",
          confirmPassword: "Підтвердити пароль"
        }
      }
    },
    settings: {
      crmSettings: "Налаштування CRM",
      tabAndColumnVisibility: "Видимість вкладок і колонок",
      tabOrder: "Порядок вкладок",
      hiddenTabs: "Приховані вкладки",
      clientColumns: "Колонки клієнта",  
      promoText: "Промо-текст",
      headerTitle: "Заголовок",
      headerSubtitle: "Опис",
      defaultLanguage: "Мова за замовчуванням",
      currency: "Валюта",
      currencyPosition: "Положення валюти",
      currencyRight: "Праворуч",
      currencyLeft: "Ліворуч",
      hideAppointments: "Приховати вкладку 'Записи'",
      hideSpecialists: "Приховати вкладку 'Спеціалісти'",
      hideServices: "Приховати вкладку 'Послуги'",
      hideClients: "Приховати вкладку 'Клієнти'",
      hideProducts: "Приховати вкладку 'Товари'",
      tabsSaved: "Налаштування вкладок збережено",
      errorFetching: "Помилка при завантаженні налаштувань",
      errorSaving: "Помилка при збереженні налаштувань",
      tabsDescription: "Налаштуйте вигляд та поведінку вкладок",
      tabVisibility: "Перемикати видимість вкладок",
      configureTabs: "Налаштуйте параметри вкладок"

     },
     products: {
      defaultcategory: "За замовчуванням",
      import: {
        steps: {
          upload: "Завантажити",
          map: "Карта",
          import: "Імпортувати"
        },
        selectfile: "Вибрати файл",
        guide: "Для імпорту продуктів: 1) Створіть файл Excel з колонками для даних продукту 2) У першому рядку мають бути назви колонок 3) Кожен рядок представляє один продукт 4) Обов'язкове поле: Назва продукту 5) Стандартний розподіл колонок налаштовано на A1, B1 тощо.",
        guideTitle: "Інструкції для імпорту"
      },  
      title: "Управління продуктами",
      addNew: "Додати новий продукт",
      edit: "Редагувати продукт",
      create: "Створити продукт",
      name: "Назва",
      category: "Категорія",
      price: "Ціна",
      costPrice: "Собівартість",
      warehouseName: "Назва складу",
      warehouseAddress: "Адреса складу",
      articleNumber: "Код продукту",
      unit: "Одиниця",
      weight: "Вага",
      length: "Довжина",
      width: "Ширина",
      height: "Висота",
      stock: "Запаси",
      responsibleEmployee: "Відповідальний співробітник",
      dimensions: "Розміри",
      warehouse: "Склад",
      deleteTitle: "Видалити продукт",
      deleteConfirm: "Ви впевнені, що хочете видалити продукт {{name}}?",
      units: {
        piece: "Штука",
        kg: "Кілограм",
        package: "Упаковка"
      }
     }  
  }
},


mn: {
  translation: {
    common: {
      minutes: "минут",
      nazvanie: "Нэр",
      maxprice: "Хамгийн дээд үнэ",
      category: "Ангилал",
      title: "Гарчиг",
      addnew: "Шинээр нэмэх",
      projectType: "Төсөл төрлийн",
      history: "Түүх",
      assignSpecialists: "Мэргэжилтнүүдийг томилох",
      uploadSpecialistPhoto: "Мэргэжилтний зургийг байршуулах",
      selectimage: "Зураг сонгох",
      upload: "Байршуулах",
      anySpecialist: "Ямар ч мэргэжилтэн",
      allServices: "Бүх үйлчилгээ",  
      add: "Нэмэх",
      edit: "Засах",
      delete: "Устгах",
      save: "Хадгалах",
      cancel: "Цуцлах",
      confirm: "Баталгаажуулах",
      back: "Буцах",
      next: "Дараах",
      min: "мин",
      login: "Нэвтрэх",
      register: "Бүртгүүлэх",
      logout: "Гарах",
      email: "Имэйл",
      password: "Нууц үг",
      phone: "Утас",
      name: "Нэр",
      actions: "Үйлдлүүд",
      optional: "заавал биш",
      telegram: "Telegram",
      instagram: "Instagram",
      status: "Төлөв",
      savechanges: "Өөрчлөлтийг хадгалах",
      changespecialist: "Мэргэжилтэн солих",
      past: "Өнгөрсөн",
      ongoing: "Үргэлжилж буй",
      upcoming: "Удахгүй",
      future: "Ирээдүйн",
      specialist: "Мэргэжилтэн",
      errorApproving: "Зөвшөөрөх алдаа",
      errorRejecting: "Татгалзах алдаа",
      errorSaving: "Хадгалах алдаа",
      specialists: "Мэргэжилтнүүд",
      schedule: "Хуваарь",
      services: "Үйлчилгээнүүд",
      service: "Үйлчилгээ",
      pendingApprovals: "Хүлээгдэж буй зөвшөөрлүүд",
      activeSpecialists: "Идэвхтэй мэргэжилтнүүд",
      approve: "Зөвшөөрөх",
      reject: "Татгалзах",
      namecompany: "Нэр/Компани",
      firstcontact: "Анхны холбоо",
      contacts: "Холбоо барих",
      projectstatus: "Төслийн төлөв",
      createdby: "Үүсгэсэн",
      assignedto: "Хариуцуулсан",
      clearalldeleted: "Устгагдсан бүгдийг цэвэрлэх",
      dashboard: "Хяналтын самбар",
      editservices: "Үйлчилгээ засах",
      setschedule: "Хуваарь тохируулах",
      website: "Вэбсайт",
      new: "Шинэ",
      regular: "Байнгын",
      former: "Өмнөх",
      deleted: "Устгагдсан",
      clientstatus: "Үйлчлүүлэгчийн төлөв",
      address: "Хаяг",
      assignspecialiststo: "Мэргэжилтэн томилох",
      discussion: "Хэлэлцүүлэг",
      firstcontactdate: "Анхны холбоо барисан огноо",
      projecttype: "Төслийн төрөл",
      projectdescription: "Төслийн тайлбар",
      technicaldetails: "Техникийн дэлгэрэнгүй",
      budget: "Төсөв",
      contacted: "Холбогдсон",
      unreachable: "Холбогдох боломжгүй",
      negotiating: "Хэлэлцэж буй",
      meeting: "Уулзалт",
      development: "Хөгжүүлэлт",
      completed: "Дууссан",
      telegramoptional: "Telegram (заавал биш)",
      instagramoptional: "Instagram (заавал биш)",
      alreadyhaveanaccount: "Бүртгэл байгаа юу? Нэвтрэх",
      myappointments: "Миний цаг товлолтууд",
      myclients: "Миний үйлчлүүлэгчид",
      settings: "Тохиргоо",
      profilesettings: "Профайл тохиргоо",
      saveprofilechanges: "Профайл өөрчлөлтийг хадгалах",
      changepassword: "Нууц үг солих",
      currentpassword: "Одоогийн нууц үг",
      newpassword: "Шинэ нууц үг",
      confirmnewpassword: "Шинэ нууц үг баталгаажуулах",
      deleteaccount: "Бүртгэл устгах",
      accountsettings: "Бүртгэлийн тохиргоо",
      saveschedule: "Хуваарь хадгалах",
      starttime: "Эхлэх цаг",
      endtime: "Дуусах цаг",
      addnewclient: "Шинэ үйлчлүүлэгч нэмэх",
      editclient: "Үйлчлүүлэгч засах",
      newclient: "Шинэ үйлчлүүлэгч",
      export: "Экспортлох",
      import: "Импортлох",
      saving: "Хадгалж байна...",
      role: "Үүрэг",
      editRole: "Үүргийг засах",
      changeRole: "Үүргийг солих",
      specialistRoleDescription: "Тусгай даалгавар болон төслийн өгөгдөлд хандах",
      adminRoleDescription: "Тохиргоо болон хэрэглэгчийн удирдлагад бүрэн хандах",
      superadmin: "Aunimeda техникийн дэмжлэг",
      admin: "Администратор",
      noServicesSelected: "Үйлчилгээ сонгогдоогүй",
      none: "Байхгүй",
      create: "Үүсгэх",


      projectStatus: {
        discussion: "Хэлэлцүүлэг",
        contacted: "Холбогдсон",
        unreachable: "Холбогдох боломжгүй",
        negotiating: "Хэлэлцэж буй",
        meeting: "Уулзалт",
        development: "Хөгжүүлэлт",
        completed: "Дууссан"
      },

      assignedspecialists: "Томилогдсон мэргэжилтнүүд",
      visibletoallspecialists: "Бүх мэргэжилтэнд харагдах",
      allspecialists: "Бүх мэргэжилтнүүд",
      createclient: "Үйлчлүүлэгч үүсгэх",
      client: "Үйлчлүүлэгч",
      selectservices: "Үйлчилгээ сонгох",
      selectspecialist: "Мэргэжилтэн сонгох",
      selectdateandtime: "Огноо, цаг сонгох",
      confirmbooking: "Захиалга баталгаажуулах",
      selectall: "Бүгдийг сонгох",
      editservicesfor: "Үйлчилгээ засах",
      clearall: "Бүгдийг цэвэрлэх",
      duration: "Үргэлжлэх хугацаа",
      price: "Үнэ",
      selected: "Сонгогдсон",
      saveservices: "Үйлчилгээ хадгалах",
      selectservicesthisspecialistcanprovidetoclients: "Энэ мэргэжилтний үзүүлж чадах үйлчилгээг сонгоно уу",
      confirmClearAllDeleted: "Устгагдсан бүх үйлчлүүлэгчдийг устгахдаа итгэлтэй байна уу? Энэ үйлдлийг буцаах боломжгүй.",

      setSchedule: "Хуваарь тохируулах",
      setWorkingHours: "Ажлын цаг тохируулах",
      setworkinghoursfor: "Ажлын цаг тохируулах",
      startTime: "Эхлэх цаг",
      endTime: "Дуусах цаг",
      monday: "Даваа",
      tuesday: "Мягмар",
      wednesday: "Лхагва",
      thursday: "Пүрэв",
      friday: "Баасан",
      saturday: "Бямба",
      sunday: "Ням"
    },
    auth: {
      login: {
        title: "Нэвтрэх",
        invalidCredentials: "Буруу имэйл эсвэл нууц үг",
        forgotPassword: "Нууц үгээ мартсан уу?",
        noAccount: "Бүртгэл байхгүй юу?",
        registerHere: "Энд бүртгүүлэх"
      },
      register: {
        title: "Бүртгүүлэх",
        success: "Амжилттай бүртгүүллээ",
        haveAccount: "Бүртгэл байгаа юу?",
        loginHere: "Энд нэвтрэх",
        asClient: "Үйлчлүүлэгчээр бүртгүүлэх",
        asSpecialist: "Мэргэжилтнээр бүртгүүлэх",
        waitingApproval: "Амжилттай бүртгүүллээ. Админы зөвшөөрлийг хүлээж байна."
      }
    },
    booking: {
      steps: {
        selectService: "Үйлчилгээ сонгох",
        selectSpecialist: "Мэргэжилтэн сонгох",
        selectDateTime: "Огноо, цаг сонгох",
        confirmation: "Баталгаажуулах"
      },
      services: {
        title: "Үйлчилгээ сонгох",
        duration: "Үргэлжлэх хугацаа",
        price: "Үнэ"
      },
      specialists: {
        title: "Мэргэжилтэн сонгох",
        availability: "Боломжтой цаг",
        noAvailability: "Боломжтой цаг байхгүй"
      },
      datetime: {
        title: "Огноо, цаг сонгох",
        availableSlots: "Боломжтой цагууд",
        noSlots: "Энэ өдөр боломжтой цаг байхгүй байна"
      },
      confirmation: {
        title: "Захиалга баталгаажуулах",
        details: "Захиалгын мэдээлэл",
        service: "Үйлчилгээ",
        specialist: "Мэргэжилтэн",
        dateTime: "Огноо, цаг",
        clientInfo: "Таны мэдээлэл",
        confirming: "Баталгаажуулж байна...",
        confirmBooking: "Захиалга баталгаажуулах",
        error: "Захиалга үүсгэхэд алдаа гарлаа"
      }
    },
    dashboard: {
      tabs: {
        appointments: "Цаг товлолтууд",
        clients: "Үйлчлүүлэгчид",
        services: "Үйлчилгээнүүд",
        specialists: "Мэргэжилтнүүд",
        settings: "Тохиргоо",
        products: "Бүтээгдэхүүн"

      },
      appointments: {
        title: "Цаг товлолтууд",
        upcoming: "Удахгүй",
        past: "Өнгөрсөн",
        datetime: "Огноо, цаг",
        client: "Үйлчлүүлэгч",
        service: "Үйлчилгээ",
        specialist: "Мэргэжилтэн",
        duration: "Үргэлжлэх хугацаа",
        deleteConfirm: "Энэ цаг товлолтыг устгахдаа итгэлтэй байна уу?",
        status: {
          pending: "Хүлээгдэж буй",
          confirmed: "Баталгаажсан",
          cancelled: "Цуцлагдсан",
          completed: "Дууссан"
        },
        actions: {
          confirm: "Баталгаажуулах",
          cancel: "Цуцлах",
          reschedule: "Дахин товлох"
        }
      },
      clients: {
        title: "Үйлчлүүлэгчид",
        addNew: "Шинэ үйлчлүүлэгч нэмэх",
        management: "Үйлчлүүлэгчийн удирдлага",
        details: "Үйлчлүүлэгчийн мэдээлэл",
        history: "Үйлчлүүлэгчийн түүх",
        status: {
          new: "Шинэ",
          regular: "Байнгын",
          former: "Өмнөх",
          deleted: "Устгагдсан"
        },
        tabs: {
          new: "Шинэ",
          regular: "Байнгын",
          former: "Өмнөх",
          deleted: "Устгагдсан"
        }
      },
      services: {
        title: "Үйлчилгээнүүд",
        addNew: "Шинэ үйлчилгээ нэмэх",
        editService: "Үйлчилгээ засах",
        fields: {
          name: "Үйлчилгээний нэр",
          duration: "Үргэлжлэх хугацаа",
          price: "Үнэ"
        }
      },
      specialists: {
        title: "Мэргэжилтнүүд",
        addNew: "Шинэ мэргэжилтэн нэмэх",
        management: "Мэргэжилтний удирдлага",
        schedule: "Ажлын цаг",
        services: "Боломжтой үйлчилгээнүүд",
        status: {
          pending: "Хүлээгдэж буй",
          approved: "Зөвшөөрөгдсөн",
          rejected: "Татгалзсан"
        }
      },
      settings: {
        title: "Тохиргоо",
        profile: "Профайл тохиргоо",
        account: "Бүртгэлийн тохиргоо",
        password: "Нууц үг солих",
        fields: {
          currentPassword: "Одоогийн нууц үг",
          newPassword: "Шинэ нууц үг",
          confirmPassword: "Нууц үг баталгаажуулах"
        }
      }
    },
    settings: {
      tabAndColumnVisibility: "Хавчуурга ба баганын харагдах байдал",
      tabOrder: "Хавчуурганы дараалал",
      hiddenTabs: "Нуусан хавчуурга",
      clientColumns: "Хэрэглэгчийн багана",  
      crmSettings: "CRM тохиргоо",
      promoText: "Сурталчилгааны текст",
      headerTitle: "Гарчиг",
      headerSubtitle: "Тайлбар",
      defaultLanguage: "Анхдагч хэл",
      currency: "Валют",
      currencyPosition: "Валютын байрлал",
      currencyRight: "Баруун",
      currencyLeft: "Зүүн",
      hideAppointments: "Уулзалтын хойно хуудсыг нуух",
      hideSpecialists: "Мэргэжилтний хойно хуудсыг нуух",
      hideServices: "Үйлчилгээний хойно хуудсыг нуух",
      hideClients: "Харилцагчийн хойно хуудсыг нуух",
      hideProducts: "Бүтээгдэхүүний хойно хуудсыг нуух",
      tabsSaved: "Хойно хуудасны тохиргоо хадгалагдлаа",
      errorFetching: "Тохиргоог ачаалах алдаа",
      errorSaving: "Тохиргоог хадгалах алдаа",
      tabsDescription: "Табын дүр төрх ба үйлдлийг тохируулна уу",
      tabVisibility: "Табын харагдах байдлыг сольж байна",
      configureTabs: "Табын тохиргоог тохируулах"

     },
     products: {
      defaultcategory: "Анхдагч",
      import: {
        steps: {
          upload: "Байршуулах",
          map: "Газрын зураг",
          import: "Импорт"
        },
        selectfile: "Файл сонгох",
        guide: "Бүтээгдэхүүнийг импортлохын тулд: 1) Бүтээгдэхүүний мэдээллийн баганатай Excel файл үүсгэх 2) Эхний мөр нь баганы нэрийг агуулсан байх ёстой 3) Гэх мөр нь нэг бүтээгдэхүүнийг илэрхийлдэг 4) Шаардлагатай талбар: Бүтээгдэхүүний нэр 5) Стандарт баганы хуваарилалт A1, B1 гэх мэтээр тохируулагдсан байна.",
        guideTitle: "Импортлох заавар"
      },  
      title: "Бүтээгдэхүүний удирдлага",
      addNew: "Шинэ бүтээгдэхүүн нэмэх",
      edit: "Бүтээгдэхүүн засах",
      create: "Бүтээгдэхүүн үүсгэх",
      name: "Нэр",
      category: "Ангилал",
      price: "Үнэ",
      costPrice: "Өртөг",
      warehouseName: "Агуулахын нэр",
      warehouseAddress: "Агуулахын хаяг",
      articleNumber: "Бүтээгдэхүүний код",
      unit: "Нэгж",
      weight: "Жин",
      length: "Урт",
      width: "Өргөн",
      height: "Өндөр",
      stock: "Бараа",
      responsibleEmployee: "Хариуцсан ажилтан",
      dimensions: "Хэмжээс",
      warehouse: "Агуулах",
      deleteTitle: "Бүтээгдэхүүн устгах",
      deleteConfirm: "{{name}} бүтээгдэхүүнийг устгахдаа итгэлтэй байна уу?",
      units: {
        piece: "Ширхэг",
        kg: "Килограмм",
        package: "装"
      }
     }

  }
},


tl: {
  translation: {
    common: {
      nazvanie: "Pangalan",
      maxprice: "Pinakamataas na presyo",
      category: "Kategorya",
      title: "Pamagat",
      addnew: "Magdagdag ng bago",
      projectType: "Uri ng proyekto",
      history: "Kasaysayan",
      assignSpecialists: "Magtalaga ng mga espesyalista",
      uploadSpecialistPhoto: "Mag-upload ng larawan ng espesyalista",
      selectimage: "Piliin ang imahe",
      upload: "I-upload",
      anySpecialist: "Kahit anong espesyalista",
      allServices: "Lahat ng serbisyo",  
      minutes: "minuto",
      add: "Magdagdag",
      edit: "I-edit",
      delete: "Burahin",
      save: "I-save",
      cancel: "Kanselahin",
      confirm: "Kumpirmahin",
      back: "Bumalik",
      next: "Susunod",
      min: "min",
      login: "Mag-login",
      register: "Mag-rehistro",
      logout: "Mag-logout",
      email: "Email",
      password: "Password",
      phone: "Telepono",
      name: "Pangalan",
      actions: "Mga Aksyon",
      optional: "opsyonal",
      telegram: "Telegram",
      instagram: "Instagram",
      status: "Katayuan",
      savechanges: "I-save ang mga pagbabago",
      changespecialist: "Palitan ang Espesyalista",
      past: "Nakaraan",
      ongoing: "Kasalukuyan",
      upcoming: "Paparating",
      future: "Hinaharap",
      specialist: "Espesyalista",
      errorApproving: "Error sa pag-apruba",
      errorRejecting: "Error sa pagtanggi",
      errorSaving: "Error sa pag-save",
      specialists: "Mga Espesyalista",
      schedule: "Iskedyul",
      services: "Mga Serbisyo",
      service: "Serbisyo",
      pendingApprovals: "Nakabinbing Pag-apruba",
      activeSpecialists: "Aktibong mga Espesyalista",
      approve: "Aprubahan",
      reject: "Tanggihan",
      namecompany: "Pangalan/Kumpanya",
      firstcontact: "Unang Kontak",
      contacts: "Mga Kontak",
      projectstatus: "Katayuan ng Proyekto",
      createdby: "Ginawa ni",
      assignedto: "Nakatalaga kay",
      clearalldeleted: "Burahin lahat ng deleted",
      dashboard: "Dashboard",
      editservices: "I-edit ang mga Serbisyo",
      setschedule: "Itakda ang Iskedyul",
      website: "Website",
      new: "Bago",
      regular: "Regular",
      former: "Dating",
      deleted: "Binura",
      clientstatus: "Katayuan ng Kliyente",
      address: "Address",
      assignspecialiststo: "Italaga ang mga Espesyalista sa",
      discussion: "Talakayan",
      firstcontactdate: "Petsa ng Unang Kontak",
      projecttype: "Uri ng Proyekto",
      projectdescription: "Deskripsyon ng Proyekto",
      technicaldetails: "Teknikal na Detalye",
      budget: "Badyet",
      contacted: "Nakipag-ugnayan",
      unreachable: "Hindi Matawagan",
      negotiating: "Nagne-negosasyon",
      meeting: "Pagpupulong",
      development: "Development",
      completed: "Nakumpleto",
      telegramoptional: "Telegram (opsyonal)",
      instagramoptional: "Instagram (opsyonal)",
      alreadyhaveanaccount: "May account na? Mag-login",
      myappointments: "Aking mga Appointment",
      myclients: "Aking mga Kliyente",
      settings: "Settings",
      profilesettings: "Settings ng Profile",
      saveprofilechanges: "I-save ang mga pagbabago sa Profile",
      changepassword: "Palitan ang Password",
      currentpassword: "Kasalukuyang Password",
      newpassword: "Bagong Password",
      confirmnewpassword: "Kumpirmahin ang Bagong Password",
      deleteaccount: "Burahin ang Account",
      accountsettings: "Settings ng Account",
      saveschedule: "I-save ang Iskedyul",
      starttime: "Oras ng Pagsisimula",
      endtime: "Oras ng Pagtatapos",
      addnewclient: "Magdagdag ng Bagong Kliyente",
      editclient: "I-edit ang Kliyente",
      newclient: "Bagong Kliyente",
      export: "I-eksport",
      import: "I-import",
      saving: "Nagsa-save...",
      role: "Papel",
      editRole: "Baguhin ang papel",
      changeRole: "Palitan ang papel",
      specialistRoleDescription: "Pag-access sa espesyal na gawain at datos ng proyekto",
      adminRoleDescription: "Ganap na access sa mga setting at pamamahala ng user",
      superadmin: "Teknikal na suporta ng Aunimeda",
      admin: "Tagapamahala",
      noServicesSelected: "Walang napiling serbisyo",
      none: "Wala",
      create: "Gumawa",


      projectStatus: {
        discussion: "Talakayan",
        contacted: "Nakipag-ugnayan",
        unreachable: "Hindi Matawagan",
        negotiating: "Nagne-negosasyon",
        meeting: "Pagpupulong",
        development: "Development",
        completed: "Nakumpleto"
      },

      assignedspecialists: "Mga Nakatalagang Espesyalista",
      visibletoallspecialists: "Nakikita ng Lahat ng Espesyalista",
      allspecialists: "Lahat ng Espesyalista",
      createclient: "Gumawa ng Kliyente",
      client: "Kliyente",
      selectservices: "Pumili ng mga Serbisyo",
      selectspecialist: "Pumili ng Espesyalista",
      selectdateandtime: "Pumili ng Petsa at Oras",
      confirmbooking: "Kumpirmahin ang Booking",
      selectall: "Piliin Lahat",
      editservicesfor: "I-edit ang mga Serbisyo para sa",
      clearall: "Burahin Lahat",
      duration: "Tagal",
      price: "Presyo",
      selected: "Napili",
      saveservices: "I-save ang mga Serbisyo",
      selectservicesthisspecialistcanprovidetoclients: "Piliin ang mga serbisyong maibibigay ng espesyalistang ito sa mga kliyente",
      confirmClearAllDeleted: "Sigurado ka bang gusto mong burahin ang lahat ng kliyente mula sa deleted folder? Hindi na mababawi ang aksyong ito.",

      setSchedule: "Itakda ang Iskedyul",
      setWorkingHours: "Itakda ang Oras ng Trabaho",
      setworkinghoursfor: "Itakda ang Oras ng Trabaho para sa",
      startTime: "Oras ng Pagsisimula",
      endTime: "Oras ng Pagtatapos",
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miyerkules",
      thursday: "Huwebes",
      friday: "Biyernes",
      saturday: "Sabado",
      sunday: "Linggo"
    },
    auth: {
      login: {
        title: "Mag-login",
        invalidCredentials: "Hindi tamang email o password",
        forgotPassword: "Nakalimutan ang password?",
        noAccount: "Walang account?",
        registerHere: "Mag-rehistro dito"
      },
      register: {
        title: "Mag-rehistro",
        success: "Matagumpay ang pagre-rehistro",
        haveAccount: "May account na?",
        loginHere: "Mag-login dito",
        asClient: "Mag-rehistro bilang Kliyente",
        asSpecialist: "Mag-rehistro bilang Espesyalista",
        waitingApproval: "Matagumpay ang pagre-rehistro. Hinihintay ang pag-apruba ng admin."
      }
    },
    booking: {
      steps: {
        selectService: "Pumili ng Serbisyo",
        selectSpecialist: "Pumili ng Espesyalista",
        selectDateTime: "Pumili ng Petsa at Oras",
        confirmation: "Kumpirmasyon"
      },
      services: {
        title: "Pumili ng Serbisyo",
        duration: "Tagal",
        price: "Presyo"
      },
      specialists: {
        title: "Pumili ng Espesyalista",
        availability: "Mga Available na Oras",
        noAvailability: "Walang available na oras"
      },
      datetime: {
        title: "Pumili ng Petsa at Oras",
        availableSlots: "Mga Available na Slot",
        noSlots: "Walang available na slot para sa petsang ito"
      },
      confirmation: {
        title: "Kumpirmahin ang Booking",
        details: "Mga Detalye ng Booking",
        service: "Serbisyo",
        specialist: "Espesyalista",
        dateTime: "Petsa at Oras",
        clientInfo: "Impormasyon mo",
        confirming: "Kinukumpirma...",
        confirmBooking: "Kumpirmahin ang Booking",
        error: "May error sa paggawa ng booking"
      }
    },
    dashboard: {
      tabs: {
        appointments: "Mga Appointment",
        clients: "Mga Kliyente",
        services: "Mga Serbisyo",
        specialists: "Mga Espesyalista",
        settings: "Settings",
        products: "Mga Produkto"

      },
      appointments: {
        title: "Mga Appointment",
        upcoming: "Paparating",
        past: "Nakaraan",
        datetime: "Petsa at Oras",
        client: "Kliyente",
        service: "Serbisyo",
        specialist: "Espesyalista",
        duration: "Tagal",
        deleteConfirm: "Sigurado ka bang gusto mong burahin ang appointment na ito?",
        status: {
          pending: "Nakabinbin",
          confirmed: "Nakumpirma",
          cancelled: "Nakansela",
          completed: "Nakumpleto"
        },
        actions: {
          confirm: "Kumpirmahin",
          cancel: "Kanselahin",
          reschedule: "I-reschedule"
        }
      },
      clients: {
        title: "Mga Kliyente",
        addNew: "Magdagdag ng Bagong Kliyente",
        management: "Pamamahala ng mga Kliyente",
        details: "Mga Detalye ng Kliyente",
        history: "Kasaysayan ng Kliyente",
        status: {
          new: "Bago",
          regular: "Regular",
          former: "Dating",
          deleted: "Binura"
        },
        tabs: {
          new: "Bago",
          regular: "Regular",
          former: "Dating",
          deleted: "Binura"
        }
      },
      services: {
        title: "Mga Serbisyo",
        addNew: "Magdagdag ng Bagong Serbisyo",
        editService: "I-edit ang Serbisyo",
        fields: {
          name: "Pangalan ng Serbisyo",
          duration: "Tagal",
          price: "Presyo"
        }
      },
      specialists: {
        title: "Mga Espesyalista",
        addNew: "Magdagdag ng Bagong Espesyalista",
        management: "Pamamahala ng mga Espesyalista",
        schedule: "Oras ng Trabaho",
        services: "Available na mga Serbisyo",
        status: {
          pending: "Nakabinbin",
          approved: "Naaprubahan",
          rejected: "Tinanggihan"
        }
      },
      settings: {
        title: "Settings",
        profile: "Settings ng Profile",
        account: "Settings ng Account",
        password: "Palitan ang Password",
        fields: {
          currentPassword: "Kasalukuyang Password",
          newPassword: "Bagong Password",
          confirmPassword: "Kumpirmahin ang Password"
        }
      }
    },
    settings: {
      tabAndColumnVisibility: "Visibility ng mga tab at column",
      tabOrder: "Pagkakasunod-sunod ng mga tab",
      hiddenTabs: "Nakatagong mga tab",
      clientColumns: "Mga column ng kliyente",  
      crmSettings: "CRM na mga Setting",
      promoText: "Promosyonal na teksto",
      headerTitle: "Pamagat",
      headerSubtitle: "Paglalarawan",
      defaultLanguage: "Default na Wika",
      currency: "Pera",
      currencyPosition: "Posisyon ng Pera",
      currencyRight: "Kanan",
      currencyLeft: "Kaliwa",
      hideAppointments: "Itago ang pahina sa likod ng mga appointment",
      hideSpecialists: "Itago ang pahina sa likod ng mga espesyalista",
      hideServices: "Itago ang pahina sa likod ng mga serbisyo",
      hideClients: "Itago ang pahina sa likod ng mga kliyente",
      hideProducts: "Itago ang pahina sa likod ng mga produkto",
      tabsSaved: "Ang mga setting ng pahina ay na-save",
      errorFetching: "Error sa pagkuha ng mga setting",
      errorSaving: "Error sa pag-save ng mga setting",
      tabsDescription: "I-configure ang hitsura at pag-uugali ng mga tab",
      tabVisibility: "Palitan ang visibility ng mga tab",
      configureTabs: "I-adjust ang mga setting ng tab"



     },
     products: {
      defaultcategory: "Default",
      import: {
        steps: {
          upload: "I-upload",
          map: "Mapa",
          import: "I-import"
        },
        selectfile: "Piliin ang file",
        guide: "Upang mag-import ng mga produkto: 1) Gumawa ng Excel file na may mga column para sa data ng produkto 2) Dapat maglaman ng mga pangalan ng column ang unang linya 3) Bawat linya ay kumakatawan sa isang produkto 4) Kinakailangang larangan: Pangalan ng produkto 5) Ang default na pagtatalaga ng mga column ay naka-set sa A1, B1, at iba pa.",
        guideTitle: "Mga tagubilin sa pag-import"
      },  
      title: "Pamamahala ng Produkto",
      addNew: "Magdagdag ng Bagong Produkto",
      edit: "Baguhin ang Produkto",
      create: "Gumawa ng Produkto",
      name: "Pangalan",
      category: "Kategorya",
      price: "Presyo",
      costPrice: "Gastos",
      warehouseName: "Pangalan ng Bodega",
      warehouseAddress: "Address ng Bodega",
      articleNumber: "Kodigo ng Produkto",
      unit: "Yunit",
      weight: "Bigat",
      length: "Haba",
      width: "Lapad",
      height: "Taas",
      stock: "Imbentaryo",
      responsibleEmployee: "Responsableng Empleyado",
      dimensions: "Mga Dimensyon",
      warehouse: "Bodega",
      deleteTitle: "Tanggalin ang Produkto",
      deleteConfirm: "Sigurado ka bang gusto mong tanggalin ang produktong {{name}}?",
      units: {
        piece: "Piraso",
        kg: "Kilogram",
        package: "Pakete"
      }
     }

  }
},

ro: {
  translation: {
    common: {
      minutes: "minute",
      nazvanie: "Nume",
      maxprice: "Preț maxim",
      category: "Categorie",
      title: "Titlu",
      addnew: "Adăugați nou",
      projectType: "Tip proiect",
      history: "Istorie",
      assignSpecialists: "Atribuiți specialiști",
      uploadSpecialistPhoto: "Încărcați fotografia specialistului",
      selectimage: "Selectați imaginea",
      upload: "Încărcați",
      anySpecialist: "Orice specialist",
      allServices: "Toate serviciile",  
      add: "Adăugare",
      edit: "Editare",
      delete: "Ștergere",
      save: "Salvare",
      cancel: "Anulare",
      confirm: "Confirmare",
      back: "Înapoi",
      next: "Următorul",
      min: "min",
      login: "Autentificare",
      register: "Înregistrare",
      logout: "Deconectare",
      email: "Email",
      password: "Parolă",
      phone: "Telefon",
      name: "Nume",
      actions: "Acțiuni",
      optional: "opțional",
      telegram: "Telegram",
      instagram: "Instagram",
      status: "Stare",
      savechanges: "Salvare modificări",
      changespecialist: "Schimbare specialist",
      past: "Trecut",
      ongoing: "În curs",
      upcoming: "Viitor",
      future: "Viitor",
      specialist: "Specialist",
      errorApproving: "Eroare la aprobare",
      errorRejecting: "Eroare la respingere",
      errorSaving: "Eroare la salvare",
      specialists: "Specialiști",
      schedule: "Program",
      services: "Servicii",
      service: "Serviciu",
      pendingApprovals: "Aprobări în așteptare",
      activeSpecialists: "Specialiști activi",
      approve: "Aprobă",
      reject: "Respinge",
      namecompany: "Nume/Companie",
      firstcontact: "Primul contact",
      contacts: "Contacte",
      projectstatus: "Starea proiectului",
      createdby: "Creat de",
      assignedto: "Atribuit către",
      clearalldeleted: "Șterge toate elementele șterse",
      dashboard: "Panou de control",
      editservices: "Editare servicii",
      setschedule: "Setare program",
      website: "Site web",
      new: "Nou",
      regular: "Regular",
      former: "Fost",
      deleted: "Șters",
      clientstatus: "Starea clientului",
      address: "Adresă",
      assignspecialiststo: "Atribuire specialiști la",
      discussion: "Discuție",
      firstcontactdate: "Data primului contact",
      projecttype: "Tip proiect",
      projectdescription: "Descriere proiect",
      technicaldetails: "Detalii tehnice",
      budget: "Buget",
      contacted: "Contactat",
      unreachable: "Inaccesibil",
      negotiating: "În negociere",
      meeting: "Întâlnire",
      development: "Dezvoltare",
      completed: "Finalizat",
      telegramoptional: "Telegram (opțional)",
      instagramoptional: "Instagram (opțional)",
      alreadyhaveanaccount: "Ai deja un cont? Autentificare",
      myappointments: "Programările mele",
      myclients: "Clienții mei",
      settings: "Setări",
      profilesettings: "Setări profil",
      saveprofilechanges: "Salvare modificări profil",
      changepassword: "Schimbare parolă",
      currentpassword: "Parola actuală",
      newpassword: "Parolă nouă",
      confirmnewpassword: "Confirmare parolă nouă",
      deleteaccount: "Ștergere cont",
      accountsettings: "Setări cont",
      saveschedule: "Salvare program",
      starttime: "Ora de început",
      endtime: "Ora de sfârșit",
      addnewclient: "Adăugare client nou",
      editclient: "Editare client",
      newclient: "Client nou",
      export: "Exportă",
      import: "Importă",
      saving: "Se salvează...",
      role: "Rol",
      editRole: "Editează rolul",
      changeRole: "Schimbă rolul",
      specialistRoleDescription: "Acces la sarcini speciale și date de proiect",
      adminRoleDescription: "Acces complet la setări și gestionarea utilizatorilor",
      superadmin: "Suport tehnic Aunimeda",
      admin: "Administrator",
      noServicesSelected: "Niciun serviciu selectat",
      none: "Niciunul",
      create: "Creează",
      

      projectStatus: {
        discussion: "Discuție",
        contacted: "Contactat",
        unreachable: "Inaccesibil",
        negotiating: "În negociere",
        meeting: "Întâlnire",
        development: "Dezvoltare",
        completed: "Finalizat"
      },

      assignedspecialists: "Specialiști atribuiți",
      visibletoallspecialists: "Vizibil tuturor specialiștilor",
      allspecialists: "Toți specialiștii",
      createclient: "Creare client",
      client: "Client",
      selectservices: "Selectare servicii",
      selectspecialist: "Selectare specialist",
      selectdateandtime: "Selectare dată și oră",
      confirmbooking: "Confirmare programare",
      selectall: "Selectare tot",
      editservicesfor: "Editare servicii pentru",
      clearall: "Șterge tot",
      duration: "Durată",
      price: "Preț",
      selected: "Selectat",
      saveservices: "Salvare servicii",
      selectservicesthisspecialistcanprovidetoclients: "Selectați serviciile pe care acest specialist le poate oferi clienților",
      confirmClearAllDeleted: "Sigur doriți să ștergeți toți clienții din dosarul șters? Această acțiune nu poate fi anulată.",

      setSchedule: "Setare program",
      setWorkingHours: "Setare ore de lucru",
      setworkinghoursfor: "Setare ore de lucru pentru",
      startTime: "Ora de început",
      endTime: "Ora de sfârșit",
      monday: "Luni",
      tuesday: "Marți",
      wednesday: "Miercuri",
      thursday: "Joi",
      friday: "Vineri",
      saturday: "Sâmbătă",
      sunday: "Duminică"
    },
    auth: {
      login: {
        title: "Autentificare",
        invalidCredentials: "Email sau parolă incorecte",
        forgotPassword: "Ai uitat parola?",
        noAccount: "Nu ai cont?",
        registerHere: "Înregistrează-te aici"
      },
      register: {
        title: "Înregistrare",
        success: "Înregistrare reușită",
        haveAccount: "Ai deja cont?",
        loginHere: "Autentifică-te aici",
        asClient: "Înregistrare ca client",
        asSpecialist: "Înregistrare ca specialist",
        waitingApproval: "Înregistrare reușită. Se așteaptă aprobarea administratorului."
      }
    },
    booking: {
      steps: {
        selectService: "Selectare serviciu",
        selectSpecialist: "Selectare specialist",
        selectDateTime: "Selectare dată și oră",
        confirmation: "Confirmare"
      },
      services: {
        title: "Selectare serviciu",
        duration: "Durată",
        price: "Preț"
      },
      specialists: {
        title: "Selectare specialist",
        availability: "Disponibilitate",
        noAvailability: "Nu există disponibilitate"
      },
      datetime: {
        title: "Selectare dată și oră",
        availableSlots: "Intervale disponibile",
        noSlots: "Nu există intervale disponibile pentru această dată"
      },
      confirmation: {
        title: "Confirmare programare",
        details: "Detalii programare",
        service: "Serviciu",
        specialist: "Specialist",
        dateTime: "Data și ora",
        clientInfo: "Informațiile tale",
        confirming: "Se confirmă...",
        confirmBooking: "Confirmare programare",
        error: "Eroare la crearea programării"
      }
    },
    dashboard: {
      tabs: {
        appointments: "Programări",
        clients: "Clienți",
        services: "Servicii",
        specialists: "Specialiști",
        settings: "Setări",
        products: "Produse"

      },
      appointments: {
        title: "Programări",
        upcoming: "Viitoare",
        past: "Trecute",
        datetime: "Data și ora",
        client: "Client",
        service: "Serviciu",
        specialist: "Specialist",
        duration: "Durată",
        deleteConfirm: "Sigur doriți să ștergeți această programare?",
        status: {
          pending: "În așteptare",
          confirmed: "Confirmat",
          cancelled: "Anulat",
          completed: "Finalizat"
        },
        actions: {
          confirm: "Confirmare",
          cancel: "Anulare",
          reschedule: "Reprogramare"
        }
      },
      clients: {
        title: "Clienți",
        addNew: "Adăugare client nou",
        management: "Gestionare clienți",
        details: "Detalii client",
        history: "Istoric client",
        status: {
          new: "Nou",
          regular: "Regular",
          former: "Fost",
          deleted: "Șters"
        },
        tabs: {
          new: "Nou",
          regular: "Regular",
          former: "Fost",
          deleted: "Șters"
        }
      },
      services: {
        title: "Servicii",
        addNew: "Adăugare serviciu nou",
        editService: "Editare serviciu",
        fields: {
          name: "Nume serviciu",
          duration: "Durată",
          price: "Preț"
        }
      },
      specialists: {
        title: "Specialiști",
        addNew: "Adăugare specialist nou",
        management: "Gestionare specialiști",
        schedule: "Program de lucru",
        services: "Servicii disponibile",
        status: {
          pending: "În așteptare",
          approved: "Aprobat",
          rejected: "Respins"
        }
      },
      settings: {
        title: "Setări",
        profile: "Setări profil",
        account: "Setări cont",
        password: "Schimbare parolă",
        fields: {
          currentPassword: "Parola actuală",
          newPassword: "Parolă nouă",
          confirmPassword: "Confirmare parolă"
        }
      }
    },
    settings: {
      crmSettings: "Setări CRM",
      tabAndColumnVisibility: "Vizibilitatea filelor și coloanelor",
      tabOrder: "Ordinea filelor",
      hiddenTabs: "File ascunse",
      clientColumns: "Coloane client",  
      promoText: "Text promoțional",
      headerTitle: "Titlu",
      headerSubtitle: "Descriere",
      defaultLanguage: "Limbă implicită",
      currency: "Valută",
      currencyPosition: "Poziție valută",
      currencyRight: "Dreapta",
      currencyLeft: "Stânga",
      hideAppointments: "Itago ang tab na 'Mga Appointment'",
      hideSpecialists: "Itago ang tab na 'Mga Espesyalista'",
      hideServices: "Itago ang tab na 'Mga Serbisyo'",
      hideClients: "Itago ang tab na 'Mga Kliente'",
      hideProducts: "Itago ang tab na 'Mga Produkto'",
      tabsSaved: "Nailigtas ang mga setting ng tab",
      errorFetching: "May error sa pagkuha ng mga setting",
      errorSaving: "May error sa pagse-save ng mga setting",  
      tabsDescription: "Configurează aspectul și comportamentul filelor",
      tabVisibility: "Schimbă vizibilitatea filelor",
      configureTabs: "Ajustează setările filelor" 
    },
     products: {
      defaultcategory: "Implicit",
      import: {
        steps: {
          upload: "Încărcați",
          map: "Harta",
          import: "Importați"
        },
        selectfile: "Selectați fișierul",
        guide: "Pentru a importa produse: 1) Creați un fișier Excel cu coloane pentru datele produsului 2) Prima linie trebuie să conțină numele coloanelor 3) Fiecare linie reprezintă un produs 4) Câmp obligatoriu: Numele produsului 5) Atribuirea implicită a coloanelor este setată pe A1, B1, etc.",
        guideTitle: "Instrucțiuni de importare"
      },  
      title: "Gestionare produse",
      addNew: "Adaugă produs nou",
      edit: "Editează produs",
      create: "Creează produs",
      name: "Nume",
      category: "Categorie",
      price: "Preț",
      costPrice: "Cost",
      warehouseName: "Nume depozit",
      warehouseAddress: "Adresă depozit",
      articleNumber: "Cod produs",
      unit: "Unitate",
      weight: "Greutate",
      length: "Lungime",
      width: "Lățime",
      height: "Înălțime",
      stock: "Stoc",
      responsibleEmployee: "Angajat responsabil",
      dimensions: "Dimensiuni",
      warehouse: "Depozit",
      deleteTitle: "Șterge produs",
      deleteConfirm: "Sunteți sigur că doriți să ștergeți produsul {{name}}?",
      units: {
        piece: "Bucată",
        kg: "Kilogram",
        package: "Pachet"
      }
     }  
  }
},




      ru: {
        translation: {
          common: {
            add: "Добавить",
            edit: "Редактировать",
            delete: "Удалить",
            save: "Сохранить",
            cancel: "Отмена",
            confirm: "Подтвердить",
            back: "Назад",
            next: "Далее",
            min: "мин",
            login: "Войти",
            register: "Регистрация",
            logout: "Выйти",
            email: "Email",
            password: "Пароль",
            phone: "Телефон",
            name: "Имя",
            actions: "Действия",
            optional: "необязательно",
            telegram: "Telegram",
            instagram: "Instagram",
            status: "Статус",
            savechanges: "Сохранить изменения",
            changespecialist: "Сменить специалиста",
            past: "Прошедший",
            ongoing: "Текущий",
            upcoming: "Предстоящий",
            future: "Будущий",
            specialist: "Специалист",
            errorApproving: "Ошибка подтверждения",
            errorRejecting: "Ошибка отклонения",
            errorSaving: "Ошибка сохранения",
            specialists: "Специалисты",
            services: "Услуги",
            service: "Услуга",
            schedule: "Расписание",
            pendingApprovals: "Ожидают подтверждения",
            activeSpecialists: "Активные специалисты",
            approve: "Подтвердить",
            reject: "Отклонить",
            namecompany: "Имя/ Компания",
            firstcontact: "Первый контакт",
            contacts: "Контакты",
            projectstatus: "Статус проекта",
            createdby: "Создано",
            assignedto: "Назначено",
            clearalldeleted: "Очистить Все",
            editservices: "Изменить Услуги",
            setschedule: "Установить Расписание",
            website: "Веб-сайт",
            new: "Новые",
            regular: "Постоянные",
            former: "Бывшие",
            deleted: "Удаленные",
            clientstatus: "Статус Клиента",
            address: "Адрес",
            assignspecialiststo: "Назначить специалиста для",
            dashboard: "Панель Управления",
            accountsettings: "Настройки Аккаунта",
            saveschedule: "Сохранить Распорядок",
            starttime: "Начало рабочего дня",
            endtime: "Конец рабочего дня",

            discussion: "Обсуждение",
            firstcontactdate: "Дата первого контакта",
            projecttype: "Тип проекта",
            projectdescription: "Описание проекта",
            technicaldetails: "Технические детали",
            budget: "Бюджет",
            contacted: "Контакт",
            unreachable: "Недоступен",
            negotiating: "Переговоры",
            meeting: "Встреча",
            development: "Разработка",
            completed: "Выполнено",
            addnewclient: "Добавить нового клиента",

            editclient: "Редактировать Клиента",
            newclient: "Новый Клиент",

            myappointments: "Мои Записи",
            myclients: "Мои Клиенты",
            settings: "Настройки",
            profilesettings: "Настройки Профиля",
            saveprofilechanges: "Сохранить Изменения Профиля",
            changepassword: "Изменить Пароль",
            currentpassword: "Текущий Пароль",
            newpassword: "Новый Пароль",
            confirmnewpassword: "Подтвердите Новый Пароль",
            deleteaccount: "Удалить Аккаунт",

            export: "Экспорт",
            import: "Импорт", 
            saving: "Сохранение...",
            role: "Роль",
            editRole: "Изменить роль",
            changeRole: "Сменить роль",
            specialistRoleDescription: "Доступ к специализированным задачам и данным проекта",
            adminRoleDescription: "Полный доступ к управлению настройками и пользователями",
            superadmin: "Техподдержка Aunimeda",
            admin: "Администратор",
            noServicesSelected: "Услуги не выбраны", 
            create: "Создать", 
            none: "Нет",  
            allServices: "Все Услуги",   
            
            nazvanie: "Название",
            maxprice: "Максимальная цена",
            category: "Категория",
            title: "Заголовок",
            addnew: "Добавить",
            projectType: "Тип проекта",
            history: "История",
            assignSpecialists: "Назначить специалистов",
            uploadSpecialistPhoto: "Загрузить фото специалиста",
            selectimage: "Выбрать изображение",
            upload: "Загрузить",
            anySpecialist: "Любой специалист",  
                        
            projectStatus: {
              discussion: "Обсуждение",
              contacted: "Контакт",
            unreachable: "Недоступен",
            negotiating: "Переговоры",
            meeting: "Встреча",
            development: "Разработка",
            completed: "Выполнено",
            },

            assignedspecialists: "Назначенные специалисты",
            visibletoallspecialists: "Видно всем специалистам",
            allspecialists: "Все Специалисты",
            createclient: "Создать клиента",
            client: "Клиент",

            selectservices: "Выбрать Услуги",
            selectspecialist: "Выбрать Специалиста",
            selectdateandtime: "Выбрать Дату и Время",
            minutes: "минут",
            confirmbooking: "Подтвердить Запись",
            telegramoptional: "Telegram (необязательно)",
            instagramoptional: "Instagram (необязательно)",

            alreadyhaveanaccount: "Уже есть аккаунт? Войти",

            selectall: "Выбрать Все",
            editservicesfor: "Изменить Услуги у",
            clearall: "Очистить Все",
            duration: "Длительность",
            price: "Цена",
            selected: "Выбрано",
            saveservices: "Сохранить Услуги",
            selectservicesthisspecialistcanprovidetoclients: "Выбрать Услуги которые может оказывать этот специалист",
            confirmClearAllDeleted: "Вы уверены, что хотите удалить всех клиентов из папки удаленных? Это действие нельзя будет отменить.",





            setSchedule: "Установить расписание",
            setWorkingHours: "Установить рабочие часы",
            setworkinghoursfor: "Установить рабочие часы для",
            startTime: "Время начала",
            endTime: "Время окончания",
            monday: "Понедельник",
            tuesday: "Вторник",
            wednesday: "Среда",
            thursday: "Четверг",
            friday: "Пятница",
            saturday: "Суббота",
            sunday: "Воскресенье"
         
          },
          auth: {
            login: {
              title: "Вход",
              invalidCredentials: "Неверный email или пароль",
              forgotPassword: "Забыли пароль?",
              noAccount: "Нет аккаунта?",
              registerHere: "Зарегистрироваться"
            },
            register: {
              title: "Регистрация",
              success: "Регистрация успешна",
              haveAccount: "Уже есть аккаунт?",
              loginHere: "Войти",
              asClient: "Регистрация как клиент",
              asSpecialist: "Регистрация как специалист",
              waitingApproval: "Регистрация успешна. Ожидайте подтверждения администратора."
            }
          },
          booking: {
            steps: {
              selectService: "Выбор услуги",
              selectSpecialist: "Выбор специалиста",
              selectDateTime: "Выбор даты и времени",
              confirmation: "Подтверждение",
              confirming: "Подтверждение...",
              confirmBooking: "Подтвердить запись",
              error: "Ошибка создания записи"
            },
            services: {
              title: "Выберите услугу",
              duration: "Длительность",
              price: "Цена"
            },
            specialists: {
              title: "Выберите специалиста",
              availability: "Доступное время",
              noAvailability: "Нет доступного времени"
            },
            datetime: {
              title: "Выберите дату и время",
              availableSlots: "Доступное время",
              noSlots: "Нет доступных слотов на эту дату"
            },
            confirmation: {
              title: "Подтверждение записи",
              details: "Детали записи",
              service: "Услуга",
              specialist: "Специалист",
              dateTime: "Дата и время",
              clientInfo: "Ваши данные"
            }
          },
          dashboard: {
            tabs: {
              appointments: "Записи",
              clients: "Клиенты",
              services: "Услуги",
              specialists: "Специалисты",
              settings: "Настройки",
              products: "Товары",
            },
            appointments: {
              title: "Записи",
              upcoming: "Предстоящие",
              past: "Прошедшие",
              datetime: "Дата и Время",
              client : "Клиент",
              service: "Услуги",
              specialist: "Специалист",
              duration: "Длительность",
              deleteConfirm: "Вы уверены, что хотите удалить эту запись?",

              status: {
                pending: "Ожидает",
                confirmed: "Подтверждено",
                cancelled: "Отменено",
                completed: "Завершено",
              },
              actions: {
                confirm: "Подтвердить",
                cancel: "Отменить",
                reschedule: "Перенести"
              }
            },
            clients: {
              title: "Клиенты",
              addNew: "Добавить клиента",
              management: "Управление клиентами",
              details: "Детали клиента",
              history: "История клиента",
              status: {
                new: "Новые",
                regular: "Постоянный",
                former: "Бывший",
                deleted: "Удаленный"
              },
              tabs: {
                new: "Новые",
                regular: "Постоянные",
                former: "Бывшие",
                deleted: "Удаленные"
              }
            },
            services: {
              title: "Услуги",
              addNew: "Добавить услугу",
              editService: "Редактировать услугу",
              fields: {
                name: "Название услуги",
                duration: "Длительность",
                price: "Цена"
              }
            },
            specialists: {
              title: "Специалисты",
              addNew: "Добавить специалиста",
              management: "Управление специалистами",
              schedule: "Рабочие часы",
              services: "Доступные услуги",
              status: {
                pending: "Ожидает подтверждения",
                approved: "Подтвержден",
                rejected: "Отклонен"
              }
            },
            settings: {
              title: "Настройки",
              profile: "Настройки профиля",
              account: "Настройки аккаунта",
              password: "Изменить пароль",
              fields: {
                currentPassword: "Текущий пароль",
                newPassword: "Новый пароль",
                confirmPassword: "Подтвердите новый пароль"
              }
            }
          },

          settings: {
            crmSettings: "Настройки CRM",
            promoText: "Промо текст",
            headerTitle: "Заголовок",
            headerSubtitle: "Описание",
            defaultLanguage: "Язык по умолчанию",
            currency: "Валюта",
            currencyPosition: "Позиция валюты",
            currencyRight: "Справа",
            currencyLeft: "Слева",
            configureTabs: "Настройка отображения вкладок",
            tabVisibility: "Настройка видимости вкладок",
            tabsDescription: "Включите или отключите отображение вкладок в панели управления",

            hideAppointments: "Скрыть вкладку 'Записи'",
            hideSpecialists: "Скрыть вкладку 'Специалисты'",
            hideServices: "Скрыть вкладку 'Услуги'",
            hideClients: "Скрыть вкладку 'Клиенты'",
            hideProducts: "Скрыть вкладку 'Товары'",
            tabsSaved: "Настройки вкладок сохранены",
            errorFetching: "Ошибка при загрузке настроек",
            errorSaving: "Ошибка при сохранении настроек",
            tabAndColumnVisibility: "Видимость вкладок и столбцов",
            tabOrder: "Порядок вкладок",
            hiddenTabs: "Скрытые вкладки",
            clientColumns: "Колонки клиента"
           },
        
           products: {
            
            defaultcategory: "По умолчанию",
            title: "Управление товарами",
            addNew: "Добавить товар",
            edit: "Редактировать товар",
            create: "Создать товар",
            name: "Название",
            category: "Категория",
            price: "Цена",
            costPrice: "Себестоимость",
            warehouseName: "Название склада",
            warehouseAddress: "Адрес склада",
            articleNumber: "Артикул",
            unit: "Единица измерения",
            weight: "Вес",
            length: "Длина",
            width: "Ширина", 
            height: "Высота",
            stock: "На складе",
            responsibleEmployee: "Ответственный сотрудник",
            dimensions: "Размеры",
            warehouse: "Склад",
            deleteTitle: "Удаление товара",
            deleteConfirm: "Вы уверены, что хотите удалить {{name}}?",
            
            
            units: {
              piece: "Штука",
              kg: "Килограмм",
              package: "Упаковка"
            },
            import: {
              steps: {
                upload: "Загрузить",
                map: "Соответствие",
                import: "Импорт"
              },
              selectfile: "Выбрать файл",
              guide: "Для импорта продуктов: 1) Создайте Excel-файл с колонками для данных продукта 2) Первая строка должна содержать названия колонок 3) Каждая строка представляет один продукт 4) Обязательное поле: Название продукта 5) По умолчанию соответствие колонок установлено на A1, B1 и т. д.",
              guideTitle: "Инструкция по импорту"
            },

           },
        }
        
      }
  
};

const determineLanguage = async () => {
  try {
      const savedLanguage = localStorage.getItem('preferredLanguage');
      if (savedLanguage) return savedLanguage;

      const token = localStorage.getItem('token');
      if (token) {
          const response = await axiosInstance.get('/settings');
          if (response.data?.defaultLanguage) {
              return response.data.defaultLanguage;
          }
      }

      const browserLang = navigator.language.split('-')[0];
      return resources[browserLang] ? browserLang : 'en';

  } catch (error) {
      console.error('Error determining language:', error);
      return 'en';
  }
};

const initI18n = async () => {
  const defaultLanguage = await determineLanguage();

  i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
          resources,
          lng: defaultLanguage,
          fallbackLng: 'en',
          detection: {
              order: ['localStorage', 'navigator'],
              lookupLocalStorage: 'preferredLanguage',
              caches: ['localStorage']
          },
          interpolation: {
              escapeValue: false
          },
          debug: process.env.NODE_ENV === 'development'
      });
};

initI18n();

export const changeLanguage = async (language) => {
  try {
      await i18n.changeLanguage(language);
      localStorage.setItem('preferredLanguage', language);
  } catch (error) {
      console.error('Error changing language:', error);
  }
};

export default i18n;